/* tslint:disable */
/* eslint-disable */
/**
 * Unnamed Galvyn API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    AddAccountParticipantRequest,
    AddCollectionEntriesRequest,
    AddDeckCardRequest,
    AddGuestParticipantRequest,
    AddScannerSessionEntryRequest,
    AddTournamentAccount200Response,
    AddTournamentCoOrganizer200Response,
    AddTournamentGuest200Response,
    AddWatchListEntryRequest,
    AdminAccountDetail,
    AdminBugReportDetail,
    AdminBugReportFilter,
    AdminDeleteAccountRequest,
    AdminListAccountsResponse,
    AdminListBugReportsResponse,
    AdminListLogResponse,
    AdminLockAccountRequest,
    AdminRenameAccountRequest,
    AdminSetBugReportNoteRequest,
    AdminSetRoleRequest,
    AdminStatisticsResponse,
    AdminSyncsResponse,
    AdminUnlockAccountRequest,
    AdvisorSettingsResponse,
    ApiErrorResponse,
    ArrangeRoundRequest,
    BracketFlagsRequest,
    BracketFlagsResponse,
    CaptureMatchLifeConflict200Response,
    CaptureMatchLifeConflictRequest,
    CardCondition,
    CardFinish,
    CardRarity,
    CheckInTournamentParticipants200Response,
    ChooseUsernameRequest,
    ClaimMatchLifeRequest,
    CollaboratorCandidatesResponse,
    CollectionEntryResponse,
    CollectionOverviewResponse,
    CollectionResponse,
    CollectionStatisticsResponse,
    CreateCollectionRequest,
    CreateDeckFolderRequest,
    CreateDeckRequest,
    CreateDeckTagRequest,
    CreateGlobalTagRequest,
    CreateScannerSessionRequest,
    CreateTournament200Response,
    CreateWatchListRequest,
    DeckCardResponse,
    DeckDriftResponse,
    DeckFolderResponse,
    DeckHistoryResponse,
    DeckOverviewResponse,
    DeckPointResponse,
    DeckResponse,
    DeckSourcingResponse,
    DeckTagResponse,
    DeckUndoResponse,
    DeleteAccountRequest,
    EndTournamentRound200Response,
    EntrySort,
    FileScannerSessionRequest,
    FileScannerSessionResponse,
    FillDeckCollectionRequest,
    FillDeckCollectionResponse,
    FinishAddPasskeyRequest,
    FinishLoginRequest,
    FinishRegistrationRequest,
    FormErrorResponseForAddPasskeyErrors,
    FormErrorResponseForAdminDeleteAccountErrors,
    FormErrorResponseForAdminLockAccountErrors,
    FormErrorResponseForAdminRenameAccountErrors,
    FormErrorResponseForAdminSetRoleErrors,
    FormErrorResponseForAdminUnlockAccountErrors,
    FormErrorResponseForArrangeRoundErrors,
    FormErrorResponseForChooseUsernameErrors,
    FormErrorResponseForDeleteAccountErrors,
    FormErrorResponseForDeletePasskeyErrors,
    FormErrorResponseForDisputeResultErrors,
    FormErrorResponseForDropErrors,
    FormErrorResponseForFinishLoginErrors,
    FormErrorResponseForRegisterDeckErrors,
    FormErrorResponseForRegistrationErrors,
    FormErrorResponseForRenamePasskeyErrors,
    FormErrorResponseForReportResultErrors,
    FormErrorResponseForRoundErrors,
    FormErrorResponseForSetCheckedInErrors,
    FormErrorResponseForSetListSharingErrors,
    FormErrorResponseForSetPaidErrors,
    FormErrorResponseForSetResultErrors,
    FormErrorResponseForSubscribePushDeviceErrors,
    GetPendingOidcLoginResponse,
    ImportDeckCardsRequest,
    ImportDeckCardsResponse,
    ListCardsResponse,
    ListCollectionEntriesResponse,
    ListDeckCardsResponse,
    ListDeckCollaboratorsResponse,
    ListDeckFoldersResponse,
    ListFormatsResponse,
    ListGlobalTagsResponse,
    ListOnLoanResponse,
    ListOpenIdProvidersResponse,
    ListOrganizersResponse,
    ListParticipantDecksResponse,
    ListParticipantsResponse,
    ListPasskeysResponse,
    ListRegisteredDecksResponse,
    ListScannerSessionsResponse,
    ListSharedWithMeResponse,
    ListTournamentsResponse,
    ListWatchListAlarmsResponse,
    ListWatchListCopiesResponse,
    ListWatchListEntriesResponse,
    ListWatchListsResponse,
    MatchLifeConflict,
    MatchLifeConflicts,
    MatchLifeHistoryResponse,
    MatchPlayResponse,
    Me200Response,
    MergeCollectionEntriesRequest,
    MpcFillCardbacksResponse,
    MpcFillSearchRequest,
    MpcFillSearchResponse,
    MyMatchResponse,
    MyRegisteredDeckResponse,
    MyTournamentsResponse,
    NameAccountRequest,
    OfferTournamentHandover200Response,
    PairTournamentRound200Response,
    PriceHistoryResponse,
    PrintingLanguagesResponse,
    PublicCollectionResponse,
    PublicDeckResponse,
    PublicDeckSort,
    PublicProfileResponse,
    PushDeviceRequest,
    PushDeviceResponse,
    PushSettingsResponse,
    PutDeckCollaborator200Response,
    PutDeckCollaboratorRequest,
    ReadDeckUrlRequest,
    ReadDeckUrlResponse,
    RecoverAccountRequest,
    RegisterDeckRequest,
    RegisteredListsResponse,
    RenameAccount200Response,
    RenameAccountRequest,
    RenamePasskeyRequest,
    ReportResultRequest,
    ResolvePrintingsRequest,
    ResolvePrintingsResponse,
    ReturnAllDeckCardsRequest,
    ReturnAllDeckCardsResponse,
    ReturnDeckCardsRequest,
    Role,
    RotateDeckShareTokenResponse,
    RotateShareTokenResponse,
    RoundsResponse,
    SaveMatchLifeHistory200Response,
    SaveMatchLifeRequest,
    ScannerSessionDetailResponse,
    ScannerSessionEntryResponse,
    ScannerSessionResponse,
    SearchPublicDecksResponse,
    SendBugReport200Response,
    SendBugReportRequest,
    SetAdvisorSettingsRequest,
    SetCheckedInRequest,
    SetCollectionVisibilityRequest,
    SetDeckBracketRequest,
    SetDeckCheckpointRequest,
    SetDeckColorsRequest,
    SetDeckFolderRequest,
    SetDeckRuleZeroRequest,
    SetDeckVisibilityRequest,
    SetListSharingRequest,
    SetPaidRequest,
    SetPushSettingsRequest,
    SetResultRequest,
    SetRoundTimerRequest,
    SetSwissRoundsRequest,
    SetTournamentRoundTimer200Response,
    SetTournamentSwissRounds200Response,
    SharedCollectionResponse,
    SharedDeckResponse,
    SignUpForSharedTournament200Response,
    Signup200Response,
    SignupRequest,
    SplitCollectionEntryRequest,
    SplitCollectionEntryResponse,
    StandingsResponse,
    StartAddPasskeyResponse,
    StartLogin200Response,
    StartLoginRequest,
    StartOidcLogin200Response,
    StartOidcLoginRequest,
    StartRegistration200Response,
    StartRegistrationRequest,
    SubscribePushDeviceRequest,
    SwapDeckCardRequest,
    TakeDeckCardsRequest,
    Timeframe,
    TournamentEvent,
    TournamentResponse,
    TournamentSettingsRequest,
    UpdateCollectionEntryRequest,
    UpdateCollectionRequest,
    UpdateDeckCardRequest,
    UpdateDeckFolderRequest,
    UpdateDeckRequest,
    UpdateDeckTagRequest,
    UpdateGlobalTagRequest,
    UpdateScannerSessionEntryRequest,
    UpdateScannerSessionRequest,
    UpdateWatchListEntryRequest,
    UpdateWatchListRequest,
    WatchListResponse,
} from '../models/index';

export interface AcceptTournamentHandoverRequest {
    /**
     * 
     */
    tournament: string;
}

export interface AcknowledgeWatchListAlarmRequest {
    /**
     * 
     */
    list: string;
    /**
     * 
     */
    entry: string;
}

export interface AddCollectionEntriesOperationRequest {
    /**
     * 
     */
    collection: string;
    /**
     * 
     */
    AddCollectionEntriesRequest?: AddCollectionEntriesRequest;
}

export interface AddDeckCardOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    AddDeckCardRequest?: AddDeckCardRequest;
}

export interface AddScannerSessionEntryOperationRequest {
    /**
     * 
     */
    session: string;
    /**
     * 
     */
    AddScannerSessionEntryRequest?: AddScannerSessionEntryRequest;
}

export interface AddTournamentAccountRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    AddAccountParticipantRequest?: AddAccountParticipantRequest;
}

export interface AddTournamentCoOrganizerRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    NameAccountRequest?: NameAccountRequest;
}

export interface AddTournamentGuestRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    AddGuestParticipantRequest?: AddGuestParticipantRequest;
}

export interface AddWatchListEntryOperationRequest {
    /**
     * 
     */
    list: string;
    /**
     * 
     */
    AddWatchListEntryRequest?: AddWatchListEntryRequest;
}

export interface AdminDeleteAccountOperationRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    AdminDeleteAccountRequest?: AdminDeleteAccountRequest;
}

export interface AdminGetAccountRequest {
    /**
     * 
     */
    uuid: string;
}

export interface AdminGetBugReportRequest {
    /**
     * 
     */
    number: number;
}

export interface AdminGetBugReportImageRequest {
    /**
     * 
     */
    number: number;
    /**
     * 
     */
    image: string;
}

export interface AdminListAccountsRequest {
    /**
     * 
     */
    after?: string | null;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    locked?: boolean | null;
    /**
     * 
     */
    role?: Role | null;
    /**
     * 
     */
    search?: string | null;
}

export interface AdminListBugReportsRequest {
    /**
     * 
     */
    after?: number | null;
    /**
     * 
     */
    filter?: AdminBugReportFilter;
    /**
     * 
     */
    limit?: number;
}

export interface AdminListLogRequest {
    /**
     * 
     */
    account?: string | null;
    /**
     * 
     */
    after?: string | null;
    /**
     * 
     */
    limit?: number;
}

export interface AdminLockAccountOperationRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    AdminLockAccountRequest?: AdminLockAccountRequest;
}

export interface AdminMarkBugReportDoneRequest {
    /**
     * 
     */
    number: number;
}

export interface AdminRenameAccountOperationRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    AdminRenameAccountRequest?: AdminRenameAccountRequest;
}

export interface AdminReopenBugReportRequest {
    /**
     * 
     */
    number: number;
}

export interface AdminSetBugReportNoteOperationRequest {
    /**
     * 
     */
    number: number;
    /**
     * 
     */
    AdminSetBugReportNoteRequest?: AdminSetBugReportNoteRequest;
}

export interface AdminSetRoleOperationRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    AdminSetRoleRequest?: AdminSetRoleRequest;
}

export interface AdminUnlockAccountOperationRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    AdminUnlockAccountRequest?: AdminUnlockAccountRequest;
}

export interface ArrangeTournamentRoundRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    number: number;
    /**
     * 
     */
    ArrangeRoundRequest?: ArrangeRoundRequest;
}

export interface AssignCollectionEntryTagRequest {
    /**
     * 
     */
    collection: string;
    /**
     * 
     */
    entry: string;
    /**
     * 
     */
    tag: string;
}

export interface AssignDeckCardTagRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    card: string;
    /**
     * 
     */
    tag: string;
}

export interface AttachDeckCollectionRequest {
    /**
     * 
     */
    deck: string;
}

export interface CancelTournamentRequest {
    /**
     * 
     */
    tournament: string;
}

export interface CaptureMatchLifeConflictOperationRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    match: string;
    /**
     * 
     */
    CaptureMatchLifeConflictRequest?: CaptureMatchLifeConflictRequest;
}

export interface CheckInTournamentParticipantsRequest {
    /**
     * 
     */
    tournament: string;
}

export interface CheckPushDeviceRequest {
    /**
     * 
     */
    PushDeviceRequest?: PushDeviceRequest;
}

export interface ChooseUsernameOperationRequest {
    /**
     * 
     */
    ChooseUsernameRequest?: ChooseUsernameRequest;
}

export interface ClaimMatchLifeHistoryRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    match: string;
    /**
     * 
     */
    ClaimMatchLifeRequest?: ClaimMatchLifeRequest;
}

export interface CreateCollectionOperationRequest {
    /**
     * 
     */
    CreateCollectionRequest?: CreateCollectionRequest;
}

export interface CreateDeckOperationRequest {
    /**
     * 
     */
    CreateDeckRequest?: CreateDeckRequest;
}

export interface CreateDeckFolderOperationRequest {
    /**
     * 
     */
    CreateDeckFolderRequest?: CreateDeckFolderRequest;
}

export interface CreateDeckTagOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    CreateDeckTagRequest?: CreateDeckTagRequest;
}

export interface CreateGlobalTagOperationRequest {
    /**
     * 
     */
    CreateGlobalTagRequest?: CreateGlobalTagRequest;
}

export interface CreateScannerSessionOperationRequest {
    /**
     * 
     */
    CreateScannerSessionRequest?: CreateScannerSessionRequest;
}

export interface CreateTournamentRequest {
    /**
     * 
     */
    TournamentSettingsRequest?: TournamentSettingsRequest;
}

export interface CreateWatchListOperationRequest {
    /**
     * 
     */
    CreateWatchListRequest?: CreateWatchListRequest;
}

export interface DeclineTournamentHandoverRequest {
    /**
     * 
     */
    tournament: string;
}

export interface DeleteAccountOperationRequest {
    /**
     * 
     */
    DeleteAccountRequest?: DeleteAccountRequest;
}

export interface DeleteCollectionRequest {
    /**
     * 
     */
    collection: string;
}

export interface DeleteCollectionEntryRequest {
    /**
     * 
     */
    collection: string;
    /**
     * 
     */
    entry: string;
}

export interface DeleteDeckRequest {
    /**
     * 
     */
    deck: string;
}

export interface DeleteDeckCardRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    card: string;
}

export interface DeleteDeckFolderRequest {
    /**
     * 
     */
    folder: string;
}

export interface DeleteDeckTagRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    tag: string;
}

export interface DeleteGlobalTagRequest {
    /**
     * 
     */
    tag: string;
}

export interface DeletePasskeyRequest {
    /**
     * 
     */
    uuid: string;
}

export interface DeleteScannerSessionRequest {
    /**
     * 
     */
    session: string;
}

export interface DeleteScannerSessionEntryRequest {
    /**
     * 
     */
    session: string;
    /**
     * 
     */
    entry: string;
}

export interface DeleteTournamentRequest {
    /**
     * 
     */
    tournament: string;
}

export interface DeleteWatchListRequest {
    /**
     * 
     */
    list: string;
}

export interface DeleteWatchListEntryRequest {
    /**
     * 
     */
    list: string;
    /**
     * 
     */
    entry: string;
}

export interface DetachDeckCollectionRequest {
    /**
     * 
     */
    deck: string;
}

export interface DiscardTournamentRoundRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    number: number;
}

export interface DisputeTournamentMatchResultRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    match: string;
}

export interface DropOutOfTournamentRequest {
    /**
     * 
     */
    tournament: string;
}

export interface DropTournamentParticipantRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    participant: string;
}

export interface EndTournamentRoundRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    number: number;
}

export interface FileScannerSessionOperationRequest {
    /**
     * 
     */
    session: string;
    /**
     * 
     */
    FileScannerSessionRequest?: FileScannerSessionRequest;
}

export interface FillDeckCollectionOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    FillDeckCollectionRequest?: FillDeckCollectionRequest;
}

export interface FinishAddPasskeyOperationRequest {
    /**
     * 
     */
    FinishAddPasskeyRequest?: FinishAddPasskeyRequest;
}

export interface FinishLoginOperationRequest {
    /**
     * 
     */
    FinishLoginRequest?: FinishLoginRequest;
}

export interface FinishOidcLoginRequest {
    /**
     * 
     */
    code?: string | null;
    /**
     * 
     */
    error?: string | null;
    /**
     * 
     */
    state?: string;
}

export interface FinishRegistrationOperationRequest {
    /**
     * 
     */
    FinishRegistrationRequest?: FinishRegistrationRequest;
}

export interface FollowSharedTournamentRequest {
    /**
     * 
     */
    token: string;
}

export interface FollowTournamentRequest {
    /**
     * 
     */
    tournament: string;
}

export interface GetBracketFlagsRequest {
    /**
     * 
     */
    BracketFlagsRequest?: BracketFlagsRequest;
}

export interface GetCollectionRequest {
    /**
     * 
     */
    collection: string;
}

export interface GetCollectionStatisticsRequest {
    /**
     * 
     */
    collection: string;
}

export interface GetDeckRequest {
    /**
     * 
     */
    deck: string;
}

export interface GetDeckAdvisorSettingsRequest {
    /**
     * 
     */
    deck: string;
}

export interface GetDeckCollectionDriftRequest {
    /**
     * 
     */
    deck: string;
}

export interface GetDeckHistoryRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    after?: string | null;
    /**
     * 
     */
    limit?: number;
}

export interface GetDeckPointRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    change: string;
}

export interface GetDeckSourcingRequest {
    /**
     * 
     */
    deck: string;
}

export interface GetMatchLifeConflictRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    match: string;
    /**
     * 
     */
    conflict: string;
}

export interface GetMatchLifeHistoryRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    match: string;
}

export interface GetMyTournamentDeckRequest {
    /**
     * 
     */
    tournament: string;
}

export interface GetMyTournamentMatchRequest {
    /**
     * 
     */
    tournament: string;
}

export interface GetPriceHistoryRequest {
    /**
     * 
     */
    printing: string;
}

export interface GetPrintingLanguagesRequest {
    /**
     * 
     */
    printing: string;
}

export interface GetPublicCollectionRequest {
    /**
     * 
     */
    collection: string;
}

export interface GetPublicCollectionStatisticsRequest {
    /**
     * 
     */
    collection: string;
}

export interface GetPublicDeckRequest {
    /**
     * 
     */
    deck: string;
}

export interface GetPublicProfileRequest {
    /**
     * 
     */
    username: string;
}

export interface GetScannerSessionRequest {
    /**
     * 
     */
    session: string;
}

export interface GetSharedCollectionRequest {
    /**
     * 
     */
    token: string;
}

export interface GetSharedCollectionStatisticsRequest {
    /**
     * 
     */
    token: string;
}

export interface GetSharedDeckRequest {
    /**
     * 
     */
    token: string;
}

export interface GetSharedTournamentRequest {
    /**
     * 
     */
    token: string;
}

export interface GetSharedTournamentStandingsRequest {
    /**
     * 
     */
    token: string;
}

export interface GetTournamentRequest {
    /**
     * 
     */
    tournament: string;
}

export interface GetTournamentMatchPlayRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    match: string;
}

export interface GetTournamentStandingsRequest {
    /**
     * 
     */
    tournament: string;
}

export interface GetWatchListRequest {
    /**
     * 
     */
    list: string;
}

export interface ImportDeckCardsOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    ImportDeckCardsRequest?: ImportDeckCardsRequest;
}

export interface LeaveDeckRequest {
    /**
     * 
     */
    deck: string;
}

export interface ListCollectionCardsRequest {
    /**
     * 
     */
    collection: string;
    /**
     * 
     */
    after?: string | null;
    /**
     * 
     */
    condition?: CardCondition | null;
    /**
     * 
     */
    descending?: boolean;
    /**
     * 
     */
    finish?: CardFinish | null;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    offset?: number;
    /**
     * 
     */
    printing?: string | null;
    /**
     * 
     */
    rarity?: CardRarity | null;
    /**
     * 
     */
    search?: string | null;
    /**
     * 
     */
    sort?: EntrySort;
}

export interface ListCollectionEntriesRequest {
    /**
     * 
     */
    collection: string;
}

export interface ListCollectionOnLoanRequest {
    /**
     * 
     */
    collection: string;
}

export interface ListDeckCardsRequest {
    /**
     * 
     */
    deck: string;
}

export interface ListDeckCollaboratorsRequest {
    /**
     * 
     */
    deck: string;
}

export interface ListMatchLifeConflictsRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    match: string;
}

export interface ListPublicCollectionCardsRequest {
    /**
     * 
     */
    collection: string;
    /**
     * 
     */
    after?: string | null;
    /**
     * 
     */
    condition?: CardCondition | null;
    /**
     * 
     */
    descending?: boolean;
    /**
     * 
     */
    finish?: CardFinish | null;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    offset?: number;
    /**
     * 
     */
    printing?: string | null;
    /**
     * 
     */
    rarity?: CardRarity | null;
    /**
     * 
     */
    search?: string | null;
    /**
     * 
     */
    sort?: EntrySort;
}

export interface ListPublicDeckCardsRequest {
    /**
     * 
     */
    deck: string;
}

export interface ListPublicTournamentsRequest {
    /**
     * 
     */
    format?: string | null;
    /**
     * 
     */
    location?: string | null;
    /**
     * 
     */
    timeframe?: Timeframe | null;
}

export interface ListSharedCollectionCardsRequest {
    /**
     * 
     */
    token: string;
    /**
     * 
     */
    after?: string | null;
    /**
     * 
     */
    condition?: CardCondition | null;
    /**
     * 
     */
    descending?: boolean;
    /**
     * 
     */
    finish?: CardFinish | null;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    offset?: number;
    /**
     * 
     */
    printing?: string | null;
    /**
     * 
     */
    rarity?: CardRarity | null;
    /**
     * 
     */
    search?: string | null;
    /**
     * 
     */
    sort?: EntrySort;
}

export interface ListSharedDeckCardsRequest {
    /**
     * 
     */
    token: string;
}

export interface ListSharedTournamentParticipantsRequest {
    /**
     * 
     */
    token: string;
}

export interface ListSharedTournamentRegisteredListsRequest {
    /**
     * 
     */
    token: string;
}

export interface ListSharedTournamentRoundsRequest {
    /**
     * 
     */
    token: string;
}

export interface ListTournamentOrganizersRequest {
    /**
     * 
     */
    tournament: string;
}

export interface ListTournamentParticipantDecksRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    participant: string;
}

export interface ListTournamentParticipantsRequest {
    /**
     * 
     */
    tournament: string;
}

export interface ListTournamentRegisteredDecksRequest {
    /**
     * 
     */
    tournament: string;
}

export interface ListTournamentRegisteredListsRequest {
    /**
     * 
     */
    tournament: string;
}

export interface ListTournamentRoundsRequest {
    /**
     * 
     */
    tournament: string;
}

export interface ListWatchListCopiesRequest {
    /**
     * 
     */
    list: string;
    /**
     * 
     */
    entry: string;
}

export interface ListWatchListEntriesRequest {
    /**
     * 
     */
    list: string;
}

export interface MergeCollectionEntriesOperationRequest {
    /**
     * 
     */
    collection: string;
    /**
     * 
     */
    MergeCollectionEntriesRequest?: MergeCollectionEntriesRequest;
}

export interface OfferTournamentHandoverRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    NameAccountRequest?: NameAccountRequest;
}

export interface PairTournamentRoundRequest {
    /**
     * 
     */
    tournament: string;
}

export interface PutDeckCollaboratorOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    PutDeckCollaboratorRequest?: PutDeckCollaboratorRequest;
}

export interface ReadDeckUrlOperationRequest {
    /**
     * 
     */
    ReadDeckUrlRequest?: ReadDeckUrlRequest;
}

export interface RecoverAccountOperationRequest {
    /**
     * 
     */
    RecoverAccountRequest?: RecoverAccountRequest;
}

export interface RedoDeckChangeRequest {
    /**
     * 
     */
    deck: string;
}

export interface RegisterMyTournamentDeckRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    RegisterDeckRequest?: RegisterDeckRequest;
}

export interface RegisterTournamentParticipantDeckRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    participant: string;
    /**
     * 
     */
    RegisterDeckRequest?: RegisterDeckRequest;
}

export interface ReleaseMatchLifeHistoryRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    match: string;
    /**
     * 
     */
    ClaimMatchLifeRequest?: ClaimMatchLifeRequest;
}

export interface RemoveDeckCheckpointRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    change: string;
}

export interface RemoveDeckCollaboratorRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    account: string;
}

export interface RemoveMyTournamentDeckRequest {
    /**
     * 
     */
    tournament: string;
}

export interface RemoveTournamentCoOrganizerRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    account: string;
}

export interface RemoveTournamentParticipantRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    participant: string;
}

export interface RemoveTournamentParticipantDeckRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    participant: string;
}

export interface RenameAccountOperationRequest {
    /**
     * 
     */
    RenameAccountRequest?: RenameAccountRequest;
}

export interface RenamePasskeyOperationRequest {
    /**
     * 
     */
    uuid: string;
    /**
     * 
     */
    RenamePasskeyRequest?: RenamePasskeyRequest;
}

export interface ReportTournamentMatchResultRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    match: string;
    /**
     * 
     */
    ReportResultRequest?: ReportResultRequest;
}

export interface ResetDeckRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    change: string;
}

export interface ResolvePrintingsOperationRequest {
    /**
     * 
     */
    ResolvePrintingsRequest?: ResolvePrintingsRequest;
}

export interface ReturnAllDeckCardsOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    ReturnAllDeckCardsRequest?: ReturnAllDeckCardsRequest;
}

export interface ReturnDeckCardsOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    ReturnDeckCardsRequest?: ReturnDeckCardsRequest;
}

export interface RotateDeckShareTokenRequest {
    /**
     * 
     */
    deck: string;
}

export interface RotateShareTokenRequest {
    /**
     * 
     */
    collection: string;
}

export interface SaveMatchLifeHistoryRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    match: string;
    /**
     * 
     */
    SaveMatchLifeRequest?: SaveMatchLifeRequest;
}

export interface SearchCollaboratorCandidatesRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    query?: string;
}

export interface SearchMpcfillArtRequest {
    /**
     * 
     */
    MpcFillSearchRequest?: MpcFillSearchRequest;
}

export interface SearchPublicDecksRequest {
    /**
     * 
     */
    bracket?: number | null;
    /**
     * 
     */
    descending?: boolean;
    /**
     * 
     */
    format?: string | null;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    offset?: number;
    /**
     * 
     */
    owner?: string | null;
    /**
     * 
     */
    search?: string | null;
    /**
     * 
     */
    sort?: PublicDeckSort;
}

export interface SendBugReportOperationRequest {
    /**
     * The [`SendBugReportRequest`] as json
     */
    report: SendBugReportRequest;
    /**
     * JPEG, PNG or WebP images of at most 5 MB each
     */
    images?: Array<Blob> | null;
}

export interface SetDeckAdvisorSettingsRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    SetAdvisorSettingsRequest?: SetAdvisorSettingsRequest;
}

export interface SetDeckBracketOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    SetDeckBracketRequest?: SetDeckBracketRequest;
}

export interface SetDeckCheckpointOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    change: string;
    /**
     * 
     */
    SetDeckCheckpointRequest?: SetDeckCheckpointRequest;
}

export interface SetDeckColorsOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    SetDeckColorsRequest?: SetDeckColorsRequest;
}

export interface SetDeckFolderOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    SetDeckFolderRequest?: SetDeckFolderRequest;
}

export interface SetDeckRuleZeroOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    SetDeckRuleZeroRequest?: SetDeckRuleZeroRequest;
}

export interface SetMyTournamentListSharingRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    SetListSharingRequest?: SetListSharingRequest;
}

export interface SetPushSettingsOperationRequest {
    /**
     * 
     */
    SetPushSettingsRequest?: SetPushSettingsRequest;
}

export interface SetTournamentMatchResultRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    match: string;
    /**
     * 
     */
    SetResultRequest?: SetResultRequest;
}

export interface SetTournamentParticipantCheckedInRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    participant: string;
    /**
     * 
     */
    SetCheckedInRequest?: SetCheckedInRequest;
}

export interface SetTournamentParticipantPaidRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    participant: string;
    /**
     * 
     */
    SetPaidRequest?: SetPaidRequest;
}

export interface SetTournamentRoundTimerRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    number: number;
    /**
     * 
     */
    SetRoundTimerRequest?: SetRoundTimerRequest;
}

export interface SetTournamentSwissRoundsRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    SetSwissRoundsRequest?: SetSwissRoundsRequest;
}

export interface SetVisibilityCollectionRequest {
    /**
     * 
     */
    collection: string;
    /**
     * 
     */
    SetCollectionVisibilityRequest?: SetCollectionVisibilityRequest;
}

export interface SetVisibilityDeckRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    SetDeckVisibilityRequest?: SetDeckVisibilityRequest;
}

export interface SignUpForSharedTournamentRequest {
    /**
     * 
     */
    token: string;
}

export interface SignUpForTournamentRequest {
    /**
     * 
     */
    tournament: string;
}

export interface SignupOperationRequest {
    /**
     * 
     */
    SignupRequest?: SignupRequest;
}

export interface SplitCollectionEntryOperationRequest {
    /**
     * 
     */
    collection: string;
    /**
     * 
     */
    entry: string;
    /**
     * 
     */
    SplitCollectionEntryRequest?: SplitCollectionEntryRequest;
}

export interface StartLoginOperationRequest {
    /**
     * 
     */
    StartLoginRequest?: StartLoginRequest;
}

export interface StartOidcLoginOperationRequest {
    /**
     * 
     */
    StartOidcLoginRequest?: StartOidcLoginRequest;
}

export interface StartRegistrationOperationRequest {
    /**
     * 
     */
    StartRegistrationRequest?: StartRegistrationRequest;
}

export interface StartTournamentRoundRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    number: number;
}

export interface SubscribePushDeviceOperationRequest {
    /**
     * 
     */
    SubscribePushDeviceRequest?: SubscribePushDeviceRequest;
}

export interface SwapDeckCardOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    card: string;
    /**
     * 
     */
    SwapDeckCardRequest?: SwapDeckCardRequest;
}

export interface TakeBackTournamentRoundRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    number: number;
}

export interface TakeDeckCardsOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    TakeDeckCardsRequest?: TakeDeckCardsRequest;
}

export interface TakeoverMatchLifeHistoryRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    match: string;
    /**
     * 
     */
    ClaimMatchLifeRequest?: ClaimMatchLifeRequest;
}

export interface UnassignCollectionEntryTagRequest {
    /**
     * 
     */
    collection: string;
    /**
     * 
     */
    entry: string;
    /**
     * 
     */
    tag: string;
}

export interface UnassignDeckCardTagRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    card: string;
    /**
     * 
     */
    tag: string;
}

export interface UndoDeckChangeRequest {
    /**
     * 
     */
    deck: string;
}

export interface UnsubscribePushDeviceRequest {
    /**
     * 
     */
    PushDeviceRequest?: PushDeviceRequest;
}

export interface UpdateCollectionOperationRequest {
    /**
     * 
     */
    collection: string;
    /**
     * 
     */
    UpdateCollectionRequest?: UpdateCollectionRequest;
}

export interface UpdateCollectionEntryOperationRequest {
    /**
     * 
     */
    collection: string;
    /**
     * 
     */
    entry: string;
    /**
     * 
     */
    UpdateCollectionEntryRequest?: UpdateCollectionEntryRequest;
}

export interface UpdateDeckOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    UpdateDeckRequest?: UpdateDeckRequest;
}

export interface UpdateDeckCardOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    card: string;
    /**
     * 
     */
    UpdateDeckCardRequest?: UpdateDeckCardRequest;
}

export interface UpdateDeckFolderOperationRequest {
    /**
     * 
     */
    folder: string;
    /**
     * 
     */
    UpdateDeckFolderRequest?: UpdateDeckFolderRequest;
}

export interface UpdateDeckTagOperationRequest {
    /**
     * 
     */
    deck: string;
    /**
     * 
     */
    tag: string;
    /**
     * 
     */
    UpdateDeckTagRequest?: UpdateDeckTagRequest;
}

export interface UpdateGlobalTagOperationRequest {
    /**
     * 
     */
    tag: string;
    /**
     * 
     */
    UpdateGlobalTagRequest?: UpdateGlobalTagRequest;
}

export interface UpdateScannerSessionOperationRequest {
    /**
     * 
     */
    session: string;
    /**
     * 
     */
    UpdateScannerSessionRequest?: UpdateScannerSessionRequest;
}

export interface UpdateScannerSessionEntryOperationRequest {
    /**
     * 
     */
    session: string;
    /**
     * 
     */
    entry: string;
    /**
     * 
     */
    UpdateScannerSessionEntryRequest?: UpdateScannerSessionEntryRequest;
}

export interface UpdateTournamentRequest {
    /**
     * 
     */
    tournament: string;
    /**
     * 
     */
    TournamentSettingsRequest?: TournamentSettingsRequest;
}

export interface UpdateWatchListOperationRequest {
    /**
     * 
     */
    list: string;
    /**
     * 
     */
    UpdateWatchListRequest?: UpdateWatchListRequest;
}

export interface UpdateWatchListEntryOperationRequest {
    /**
     * 
     */
    list: string;
    /**
     * 
     */
    entry: string;
    /**
     * 
     */
    UpdateWatchListEntryRequest?: UpdateWatchListEntryRequest;
}

export interface WithdrawTournamentHandoverRequest {
    /**
     * 
     */
    tournament: string;
}

export interface WithdrawTournamentSignUpRequest {
    /**
     * 
     */
    tournament: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for acceptTournamentHandover without sending the request
     */
    async acceptTournamentHandoverRequestOpts(requestParameters: AcceptTournamentHandoverRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling acceptTournamentHandover().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/handover/accept`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Take over a Tournament offered to the logged-in Account  It becomes the Owner; the former Owner stays as a Co-organizer.
     * Take over a Tournament offered to the logged-in Account
     */
    async acceptTournamentHandoverRaw(requestParameters: AcceptTournamentHandoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentResponse>> {
        const requestOptions = await this.acceptTournamentHandoverRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Take over a Tournament offered to the logged-in Account  It becomes the Owner; the former Owner stays as a Co-organizer.
     * Take over a Tournament offered to the logged-in Account
     */
    async acceptTournamentHandover(requestParameters: AcceptTournamentHandoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentResponse> {
        const response = await this.acceptTournamentHandoverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for acknowledgeWatchListAlarm without sending the request
     */
    async acknowledgeWatchListAlarmRequestOpts(requestParameters: AcknowledgeWatchListAlarmRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['list'] == null) {
            throw new runtime.RequiredError(
                'list',
                'Required parameter "list" was null or undefined when calling acknowledgeWatchListAlarm().'
            );
        }

        if (requestParameters['entry'] == null) {
            throw new runtime.RequiredError(
                'entry',
                'Required parameter "entry" was null or undefined when calling acknowledgeWatchListAlarm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/watch-lists/{list}/entries/{entry}/acknowledge`;
        urlPath = urlPath.replace('{list}', encodeURIComponent(String(requestParameters['list'])));
        urlPath = urlPath.replace('{entry}', encodeURIComponent(String(requestParameters['entry'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Mark an alarm as seen  Only the reading is recorded. The alarm itself stays on the entry until the price rises back through the threshold, because it is still true.
     * Mark an alarm as seen
     */
    async acknowledgeWatchListAlarmRaw(requestParameters: AcknowledgeWatchListAlarmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.acknowledgeWatchListAlarmRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Mark an alarm as seen  Only the reading is recorded. The alarm itself stays on the entry until the price rises back through the threshold, because it is still true.
     * Mark an alarm as seen
     */
    async acknowledgeWatchListAlarm(requestParameters: AcknowledgeWatchListAlarmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.acknowledgeWatchListAlarmRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addCollectionEntries without sending the request
     */
    async addCollectionEntriesRequestOpts(requestParameters: AddCollectionEntriesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling addCollectionEntries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/collections/{collection}/entries`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddCollectionEntriesRequest'],
        };
    }

    /**
     * File stacks of cards into a collection
     * File stacks of cards into a collection
     */
    async addCollectionEntriesRaw(requestParameters: AddCollectionEntriesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.addCollectionEntriesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * File stacks of cards into a collection
     * File stacks of cards into a collection
     */
    async addCollectionEntries(requestParameters: AddCollectionEntriesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.addCollectionEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addDeckCard without sending the request
     */
    async addDeckCardRequestOpts(requestParameters: AddDeckCardOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling addDeckCard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/cards`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddDeckCardRequest'],
        };
    }

    /**
     * Put a card into a deck  Copies joining an alike Deck entry (same printing, zone, finish and proxy status) raise its count instead of opening a second line beside it. The answer is the entry\'s bookkeeping fields either way; catalog data and tags come from the list endpoint. Only the owner adds proxies, see [`DeckGrant::proxy`].
     * Put a card into a deck
     */
    async addDeckCardRaw(requestParameters: AddDeckCardOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckCardResponse>> {
        const requestOptions = await this.addDeckCardRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Put a card into a deck  Copies joining an alike Deck entry (same printing, zone, finish and proxy status) raise its count instead of opening a second line beside it. The answer is the entry\'s bookkeeping fields either way; catalog data and tags come from the list endpoint. Only the owner adds proxies, see [`DeckGrant::proxy`].
     * Put a card into a deck
     */
    async addDeckCard(requestParameters: AddDeckCardOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckCardResponse> {
        const response = await this.addDeckCardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addScannerSessionEntry without sending the request
     */
    async addScannerSessionEntryRequestOpts(requestParameters: AddScannerSessionEntryOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['session'] == null) {
            throw new runtime.RequiredError(
                'session',
                'Required parameter "session" was null or undefined when calling addScannerSessionEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/scanner-sessions/{session}/entries`;
        urlPath = urlPath.replace('{session}', encodeURIComponent(String(requestParameters['session'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddScannerSessionEntryRequest'],
        };
    }

    /**
     * Add scanned copies to a session
     * Add scanned copies to a session
     */
    async addScannerSessionEntryRaw(requestParameters: AddScannerSessionEntryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScannerSessionEntryResponse>> {
        const requestOptions = await this.addScannerSessionEntryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Add scanned copies to a session
     * Add scanned copies to a session
     */
    async addScannerSessionEntry(requestParameters: AddScannerSessionEntryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScannerSessionEntryResponse> {
        const response = await this.addScannerSessionEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addTournamentAccount without sending the request
     */
    async addTournamentAccountRequestOpts(requestParameters: AddTournamentAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling addTournamentAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/participants/accounts`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddAccountParticipantRequest'],
        };
    }

    /**
     * Add an Account as a Participant by its username, as an Organizer  An Organizer may add itself. In Registration, and as a late Participant until the Swiss Rounds are over; the participant limit does not hold Organizers back. Unknown usernames are capped per caller, see [`unknown_username`].
     * Add an Account as a Participant by its username, as an Organizer
     */
    async addTournamentAccountRaw(requestParameters: AddTournamentAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddTournamentAccount200Response>> {
        const requestOptions = await this.addTournamentAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Add an Account as a Participant by its username, as an Organizer  An Organizer may add itself. In Registration, and as a late Participant until the Swiss Rounds are over; the participant limit does not hold Organizers back. Unknown usernames are capped per caller, see [`unknown_username`].
     * Add an Account as a Participant by its username, as an Organizer
     */
    async addTournamentAccount(requestParameters: AddTournamentAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddTournamentAccount200Response> {
        const response = await this.addTournamentAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addTournamentCoOrganizer without sending the request
     */
    async addTournamentCoOrganizerRequestOpts(requestParameters: AddTournamentCoOrganizerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling addTournamentCoOrganizer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/organizers`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['NameAccountRequest'],
        };
    }

    /**
     * Name an Account a Co-organizer by its username, as one of the Organizers  Unknown usernames are capped per caller, see [`unknown_username`].
     * Name an Account a Co-organizer by its username, as one of the Organizers
     */
    async addTournamentCoOrganizerRaw(requestParameters: AddTournamentCoOrganizerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddTournamentCoOrganizer200Response>> {
        const requestOptions = await this.addTournamentCoOrganizerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Name an Account a Co-organizer by its username, as one of the Organizers  Unknown usernames are capped per caller, see [`unknown_username`].
     * Name an Account a Co-organizer by its username, as one of the Organizers
     */
    async addTournamentCoOrganizer(requestParameters: AddTournamentCoOrganizerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddTournamentCoOrganizer200Response> {
        const response = await this.addTournamentCoOrganizerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addTournamentGuest without sending the request
     */
    async addTournamentGuestRequestOpts(requestParameters: AddTournamentGuestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling addTournamentGuest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/participants/guests`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddGuestParticipantRequest'],
        };
    }

    /**
     * Add a Guest by name, as an Organizer  In Registration, and as a late Participant until the Swiss Rounds are over. The name is trimmed; two Guests may share one.
     * Add a Guest by name, as an Organizer
     */
    async addTournamentGuestRaw(requestParameters: AddTournamentGuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddTournamentGuest200Response>> {
        const requestOptions = await this.addTournamentGuestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Add a Guest by name, as an Organizer  In Registration, and as a late Participant until the Swiss Rounds are over. The name is trimmed; two Guests may share one.
     * Add a Guest by name, as an Organizer
     */
    async addTournamentGuest(requestParameters: AddTournamentGuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddTournamentGuest200Response> {
        const response = await this.addTournamentGuestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for addWatchListEntry without sending the request
     */
    async addWatchListEntryRequestOpts(requestParameters: AddWatchListEntryOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['list'] == null) {
            throw new runtime.RequiredError(
                'list',
                'Required parameter "list" was null or undefined when calling addWatchListEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/watch-lists/{list}/entries`;
        urlPath = urlPath.replace('{list}', encodeURIComponent(String(requestParameters['list'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddWatchListEntryRequest'],
        };
    }

    /**
     * Put a card on a watch list
     * Put a card on a watch list
     */
    async addWatchListEntryRaw(requestParameters: AddWatchListEntryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.addWatchListEntryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Put a card on a watch list
     * Put a card on a watch list
     */
    async addWatchListEntry(requestParameters: AddWatchListEntryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.addWatchListEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminDeleteAccount without sending the request
     */
    async adminDeleteAccountRequestOpts(requestParameters: AdminDeleteAccountOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling adminDeleteAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/accounts/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AdminDeleteAccountRequest'],
        };
    }

    /**
     * Delete an Account  By default its public decks go to the Tombstone, as on a self-deletion; a full Deletion takes them too. The Admin types the Account\'s username to confirm, and cannot delete itself. The Admin log entry is written first, so it keeps the username once the Account is gone. Its Participants in other people\'s Tournaments always appear anonymously.
     * Delete an Account
     */
    async adminDeleteAccountRaw(requestParameters: AdminDeleteAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForAdminDeleteAccountErrors>> {
        const requestOptions = await this.adminDeleteAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete an Account  By default its public decks go to the Tombstone, as on a self-deletion; a full Deletion takes them too. The Admin types the Account\'s username to confirm, and cannot delete itself. The Admin log entry is written first, so it keeps the username once the Account is gone. Its Participants in other people\'s Tournaments always appear anonymously.
     * Delete an Account
     */
    async adminDeleteAccount(requestParameters: AdminDeleteAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForAdminDeleteAccountErrors> {
        const response = await this.adminDeleteAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminGetAccount without sending the request
     */
    async adminGetAccountRequestOpts(requestParameters: AdminGetAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling adminGetAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/accounts/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * One Account with its card and passkey counts
     * One Account with its card and passkey counts
     */
    async adminGetAccountRaw(requestParameters: AdminGetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminAccountDetail>> {
        const requestOptions = await this.adminGetAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * One Account with its card and passkey counts
     * One Account with its card and passkey counts
     */
    async adminGetAccount(requestParameters: AdminGetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminAccountDetail> {
        const response = await this.adminGetAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminGetBugReport without sending the request
     */
    async adminGetBugReportRequestOpts(requestParameters: AdminGetBugReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling adminGetBugReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/bug-reports/{number}`;
        urlPath = urlPath.replace('{number}', encodeURIComponent(String(requestParameters['number'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * One Bug report with its text, diagnostics and image references
     * One Bug report with its text, diagnostics and image references
     */
    async adminGetBugReportRaw(requestParameters: AdminGetBugReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminBugReportDetail>> {
        const requestOptions = await this.adminGetBugReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * One Bug report with its text, diagnostics and image references
     * One Bug report with its text, diagnostics and image references
     */
    async adminGetBugReport(requestParameters: AdminGetBugReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminBugReportDetail> {
        const response = await this.adminGetBugReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminGetBugReportImage without sending the request
     */
    async adminGetBugReportImageRequestOpts(requestParameters: AdminGetBugReportImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling adminGetBugReportImage().'
            );
        }

        if (requestParameters['image'] == null) {
            throw new runtime.RequiredError(
                'image',
                'Required parameter "image" was null or undefined when calling adminGetBugReportImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/bug-reports/{number}/images/{image}`;
        urlPath = urlPath.replace('{number}', encodeURIComponent(String(requestParameters['number'])));
        urlPath = urlPath.replace('{image}', encodeURIComponent(String(requestParameters['image'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * One image of a Bug report
     * One image of a Bug report
     */
    async adminGetBugReportImageRaw(requestParameters: AdminGetBugReportImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.adminGetBugReportImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * One image of a Bug report
     * One image of a Bug report
     */
    async adminGetBugReportImage(requestParameters: AdminGetBugReportImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminGetBugReportImageRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for adminGetStatistics without sending the request
     */
    async adminGetStatisticsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/statistics`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The newest Statistics snapshot and the last 30 days of them
     * The newest Statistics snapshot and the last 30 days of them
     */
    async adminGetStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminStatisticsResponse>> {
        const requestOptions = await this.adminGetStatisticsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The newest Statistics snapshot and the last 30 days of them
     * The newest Statistics snapshot and the last 30 days of them
     */
    async adminGetStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminStatisticsResponse> {
        const response = await this.adminGetStatisticsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminGetSyncs without sending the request
     */
    async adminGetSyncsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/syncs`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The state of the catalog and price guide syncs, with their recent Sync runs
     * The state of the catalog and price guide syncs, with their recent Sync runs
     */
    async adminGetSyncsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminSyncsResponse>> {
        const requestOptions = await this.adminGetSyncsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The state of the catalog and price guide syncs, with their recent Sync runs
     * The state of the catalog and price guide syncs, with their recent Sync runs
     */
    async adminGetSyncs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminSyncsResponse> {
        const response = await this.adminGetSyncsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminListAccounts without sending the request
     */
    async adminListAccountsRequestOpts(requestParameters: AdminListAccountsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['locked'] != null) {
            queryParameters['locked'] = requestParameters['locked'];
        }

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/accounts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List Accounts, newest first
     * List Accounts, newest first
     */
    async adminListAccountsRaw(requestParameters: AdminListAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminListAccountsResponse>> {
        const requestOptions = await this.adminListAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List Accounts, newest first
     * List Accounts, newest first
     */
    async adminListAccounts(requestParameters: AdminListAccountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminListAccountsResponse> {
        const response = await this.adminListAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminListBugReports without sending the request
     */
    async adminListBugReportsRequestOpts(requestParameters: AdminListBugReportsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/bug-reports`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List Bug reports, newest first, the open ones unless asked otherwise
     * List Bug reports, newest first, the open ones unless asked otherwise
     */
    async adminListBugReportsRaw(requestParameters: AdminListBugReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminListBugReportsResponse>> {
        const requestOptions = await this.adminListBugReportsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List Bug reports, newest first, the open ones unless asked otherwise
     * List Bug reports, newest first, the open ones unless asked otherwise
     */
    async adminListBugReports(requestParameters: AdminListBugReportsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminListBugReportsResponse> {
        const response = await this.adminListBugReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminListLog without sending the request
     */
    async adminListLogRequestOpts(requestParameters: AdminListLogRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['account'] != null) {
            queryParameters['account'] = requestParameters['account'];
        }

        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/log`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List the Admin log, newest first
     * List the Admin log, newest first
     */
    async adminListLogRaw(requestParameters: AdminListLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminListLogResponse>> {
        const requestOptions = await this.adminListLogRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List the Admin log, newest first
     * List the Admin log, newest first
     */
    async adminListLog(requestParameters: AdminListLogRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminListLogResponse> {
        const response = await this.adminListLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminLockAccount without sending the request
     */
    async adminLockAccountRequestOpts(requestParameters: AdminLockAccountOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling adminLockAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/accounts/{uuid}/lock`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AdminLockAccountRequest'],
        };
    }

    /**
     * Lock an Account  Its Login and Registration link Enrollment are refused from now on, and its sessions fail on their next request. An Admin cannot Lock itself.
     * Lock an Account
     */
    async adminLockAccountRaw(requestParameters: AdminLockAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForAdminLockAccountErrors>> {
        const requestOptions = await this.adminLockAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Lock an Account  Its Login and Registration link Enrollment are refused from now on, and its sessions fail on their next request. An Admin cannot Lock itself.
     * Lock an Account
     */
    async adminLockAccount(requestParameters: AdminLockAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForAdminLockAccountErrors> {
        const response = await this.adminLockAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminMarkBugReportDone without sending the request
     */
    async adminMarkBugReportDoneRequestOpts(requestParameters: AdminMarkBugReportDoneRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling adminMarkBugReportDone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/bug-reports/{number}/done`;
        urlPath = urlPath.replace('{number}', encodeURIComponent(String(requestParameters['number'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Mark a Bug report done, recording the Admin and the time
     * Mark a Bug report done, recording the Admin and the time
     */
    async adminMarkBugReportDoneRaw(requestParameters: AdminMarkBugReportDoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.adminMarkBugReportDoneRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Mark a Bug report done, recording the Admin and the time
     * Mark a Bug report done, recording the Admin and the time
     */
    async adminMarkBugReportDone(requestParameters: AdminMarkBugReportDoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.adminMarkBugReportDoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminRenameAccount without sending the request
     */
    async adminRenameAccountRequestOpts(requestParameters: AdminRenameAccountOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling adminRenameAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/accounts/{uuid}/username`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AdminRenameAccountRequest'],
        };
    }

    /**
     * Rename an Account  Takes the same usernames as a Rename by the Account itself, also for a locked Account, and mails the Account its new username without the reason. An Admin renames itself through its own settings, not here.
     * Rename an Account
     */
    async adminRenameAccountRaw(requestParameters: AdminRenameAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForAdminRenameAccountErrors>> {
        const requestOptions = await this.adminRenameAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Rename an Account  Takes the same usernames as a Rename by the Account itself, also for a locked Account, and mails the Account its new username without the reason. An Admin renames itself through its own settings, not here.
     * Rename an Account
     */
    async adminRenameAccount(requestParameters: AdminRenameAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForAdminRenameAccountErrors> {
        const response = await this.adminRenameAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminReopenBugReport without sending the request
     */
    async adminReopenBugReportRequestOpts(requestParameters: AdminReopenBugReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling adminReopenBugReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/admin/bug-reports/{number}/reopen`;
        urlPath = urlPath.replace('{number}', encodeURIComponent(String(requestParameters['number'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Open a done Bug report again  What a purge removed stays removed.
     * Open a done Bug report again
     */
    async adminReopenBugReportRaw(requestParameters: AdminReopenBugReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.adminReopenBugReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Open a done Bug report again  What a purge removed stays removed.
     * Open a done Bug report again
     */
    async adminReopenBugReport(requestParameters: AdminReopenBugReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.adminReopenBugReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminSetBugReportNote without sending the request
     */
    async adminSetBugReportNoteRequestOpts(requestParameters: AdminSetBugReportNoteOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling adminSetBugReportNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/bug-reports/{number}/note`;
        urlPath = urlPath.replace('{number}', encodeURIComponent(String(requestParameters['number'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AdminSetBugReportNoteRequest'],
        };
    }

    /**
     * Set the Admins\' internal note on a Bug report, an empty note removes it
     * Set the Admins\' internal note on a Bug report, an empty note removes it
     */
    async adminSetBugReportNoteRaw(requestParameters: AdminSetBugReportNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.adminSetBugReportNoteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Set the Admins\' internal note on a Bug report, an empty note removes it
     * Set the Admins\' internal note on a Bug report, an empty note removes it
     */
    async adminSetBugReportNote(requestParameters: AdminSetBugReportNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.adminSetBugReportNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminSetRole without sending the request
     */
    async adminSetRoleRequestOpts(requestParameters: AdminSetRoleOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling adminSetRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/accounts/{uuid}/role`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AdminSetRoleRequest'],
        };
    }

    /**
     * Change an Account\'s Role  An Admin cannot demote itself, so there is always an Admin left to undo a change. A change writes an Admin log entry; setting the Role an Account has already writes none.
     * Change an Account\'s Role
     */
    async adminSetRoleRaw(requestParameters: AdminSetRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForAdminSetRoleErrors>> {
        const requestOptions = await this.adminSetRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Change an Account\'s Role  An Admin cannot demote itself, so there is always an Admin left to undo a change. A change writes an Admin log entry; setting the Role an Account has already writes none.
     * Change an Account\'s Role
     */
    async adminSetRole(requestParameters: AdminSetRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForAdminSetRoleErrors> {
        const response = await this.adminSetRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminUnlockAccount without sending the request
     */
    async adminUnlockAccountRequestOpts(requestParameters: AdminUnlockAccountOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling adminUnlockAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/admin/accounts/{uuid}/unlock`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AdminUnlockAccountRequest'],
        };
    }

    /**
     * Lift an Account\'s Lock
     * Lift an Account\'s Lock
     */
    async adminUnlockAccountRaw(requestParameters: AdminUnlockAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForAdminUnlockAccountErrors>> {
        const requestOptions = await this.adminUnlockAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Lift an Account\'s Lock
     * Lift an Account\'s Lock
     */
    async adminUnlockAccount(requestParameters: AdminUnlockAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForAdminUnlockAccountErrors> {
        const response = await this.adminUnlockAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for arrangeTournamentRound without sending the request
     */
    async arrangeTournamentRoundRequestOpts(requestParameters: ArrangeTournamentRoundRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling arrangeTournamentRound().'
            );
        }

        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling arrangeTournamentRound().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/rounds/{number}/layout`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{number}', encodeURIComponent(String(requestParameters['number'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ArrangeRoundRequest'],
        };
    }

    /**
     * Lay out a previewed Round by hand, as an Organizer  The whole Round at once: every Match in table order with its Participants in Seat order, and the Byes. Starting the Round starts this layout.
     * Lay out a previewed Round by hand, as an Organizer
     */
    async arrangeTournamentRoundRaw(requestParameters: ArrangeTournamentRoundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForArrangeRoundErrors>> {
        const requestOptions = await this.arrangeTournamentRoundRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Lay out a previewed Round by hand, as an Organizer  The whole Round at once: every Match in table order with its Participants in Seat order, and the Byes. Starting the Round starts this layout.
     * Lay out a previewed Round by hand, as an Organizer
     */
    async arrangeTournamentRound(requestParameters: ArrangeTournamentRoundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForArrangeRoundErrors> {
        const response = await this.arrangeTournamentRoundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for assignCollectionEntryTag without sending the request
     */
    async assignCollectionEntryTagRequestOpts(requestParameters: AssignCollectionEntryTagRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling assignCollectionEntryTag().'
            );
        }

        if (requestParameters['entry'] == null) {
            throw new runtime.RequiredError(
                'entry',
                'Required parameter "entry" was null or undefined when calling assignCollectionEntryTag().'
            );
        }

        if (requestParameters['tag'] == null) {
            throw new runtime.RequiredError(
                'tag',
                'Required parameter "tag" was null or undefined when calling assignCollectionEntryTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/collections/{collection}/entries/{entry}/tags/{tag}`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));
        urlPath = urlPath.replace('{entry}', encodeURIComponent(String(requestParameters['entry'])));
        urlPath = urlPath.replace('{tag}', encodeURIComponent(String(requestParameters['tag'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Put a card-wide tag on a stack  The tag lands on the card the stack holds, not on the row: another copy of the same card, in another printing, language or collection, carries it from then on, and so does every slot of it in a deck. That is what makes a tag worth keeping across a whole account, and why only the tags that are not local to a deck can be put on here.
     * Put a card-wide tag on a stack
     */
    async assignCollectionEntryTagRaw(requestParameters: AssignCollectionEntryTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.assignCollectionEntryTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Put a card-wide tag on a stack  The tag lands on the card the stack holds, not on the row: another copy of the same card, in another printing, language or collection, carries it from then on, and so does every slot of it in a deck. That is what makes a tag worth keeping across a whole account, and why only the tags that are not local to a deck can be put on here.
     * Put a card-wide tag on a stack
     */
    async assignCollectionEntryTag(requestParameters: AssignCollectionEntryTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.assignCollectionEntryTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for assignDeckCardTag without sending the request
     */
    async assignDeckCardTagRequestOpts(requestParameters: AssignDeckCardTagRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling assignDeckCardTag().'
            );
        }

        if (requestParameters['card'] == null) {
            throw new runtime.RequiredError(
                'card',
                'Required parameter "card" was null or undefined when calling assignDeckCardTag().'
            );
        }

        if (requestParameters['tag'] == null) {
            throw new runtime.RequiredError(
                'tag',
                'Required parameter "tag" was null or undefined when calling assignDeckCardTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/cards/{card}/tags/{tag}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));
        urlPath = urlPath.replace('{card}', encodeURIComponent(String(requestParameters['card'])));
        urlPath = urlPath.replace('{tag}', encodeURIComponent(String(requestParameters['tag'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Put a tag on a card  An Editor only puts on tags local to this deck: a global one would tag the card on every deck of the owner.
     * Put a tag on a card
     */
    async assignDeckCardTagRaw(requestParameters: AssignDeckCardTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.assignDeckCardTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Put a tag on a card  An Editor only puts on tags local to this deck: a global one would tag the card on every deck of the owner.
     * Put a tag on a card
     */
    async assignDeckCardTag(requestParameters: AssignDeckCardTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.assignDeckCardTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for attachDeckCollection without sending the request
     */
    async attachDeckCollectionRequestOpts(requestParameters: AttachDeckCollectionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling attachDeckCollection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/collection`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Start keeping the cards that are physically in this deck  The deck gets a collection of its own. Idempotent, so the client can call it without first asking whether there already is one.
     * Start keeping the cards that are physically in this deck
     */
    async attachDeckCollectionRaw(requestParameters: AttachDeckCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CollectionResponse>> {
        const requestOptions = await this.attachDeckCollectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start keeping the cards that are physically in this deck  The deck gets a collection of its own. Idempotent, so the client can call it without first asking whether there already is one.
     * Start keeping the cards that are physically in this deck
     */
    async attachDeckCollection(requestParameters: AttachDeckCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CollectionResponse> {
        const response = await this.attachDeckCollectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for cancelTournament without sending the request
     */
    async cancelTournamentRequestOpts(requestParameters: CancelTournamentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling cancelTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/cancel`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Cancel a Tournament, as an Organizer  Any time before it is Finished. A previewed Round goes; the Rounds played so far stay visible.
     * Cancel a Tournament, as an Organizer
     */
    async cancelTournamentRaw(requestParameters: CancelTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.cancelTournamentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Cancel a Tournament, as an Organizer  Any time before it is Finished. A previewed Round goes; the Rounds played so far stay visible.
     * Cancel a Tournament, as an Organizer
     */
    async cancelTournament(requestParameters: CancelTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.cancelTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for captureMatchLifeConflict without sending the request
     */
    async captureMatchLifeConflictRequestOpts(requestParameters: CaptureMatchLifeConflictOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling captureMatchLifeConflict().'
            );
        }

        if (requestParameters['match'] == null) {
            throw new runtime.RequiredError(
                'match',
                'Required parameter "match" was null or undefined when calling captureMatchLifeConflict().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/matches/{match}/life-history/conflicts`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{match}', encodeURIComponent(String(requestParameters['match'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CaptureMatchLifeConflictRequest'],
        };
    }

    /**
     * Preserves all recovered old-device changes as an independent authorized artifact.
     * Preserves all recovered old-device changes as an independent authorized artifact.
     */
    async captureMatchLifeConflictRaw(requestParameters: CaptureMatchLifeConflictOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaptureMatchLifeConflict200Response>> {
        const requestOptions = await this.captureMatchLifeConflictRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Preserves all recovered old-device changes as an independent authorized artifact.
     * Preserves all recovered old-device changes as an independent authorized artifact.
     */
    async captureMatchLifeConflict(requestParameters: CaptureMatchLifeConflictOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaptureMatchLifeConflict200Response> {
        const response = await this.captureMatchLifeConflictRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for checkInTournamentParticipants without sending the request
     */
    async checkInTournamentParticipantsRequestOpts(requestParameters: CheckInTournamentParticipantsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling checkInTournamentParticipants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/participants/check-in`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Check in every Participant that plays on, as an Organizer  Only in a Tournament that takes check-in, until it is over. Where a deck is required, Accounts without a Registered deck are left out and named in the answer; Guests are checked in all the same.
     * Check in every Participant that plays on, as an Organizer
     */
    async checkInTournamentParticipantsRaw(requestParameters: CheckInTournamentParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckInTournamentParticipants200Response>> {
        const requestOptions = await this.checkInTournamentParticipantsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Check in every Participant that plays on, as an Organizer  Only in a Tournament that takes check-in, until it is over. Where a deck is required, Accounts without a Registered deck are left out and named in the answer; Guests are checked in all the same.
     * Check in every Participant that plays on, as an Organizer
     */
    async checkInTournamentParticipants(requestParameters: CheckInTournamentParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckInTournamentParticipants200Response> {
        const response = await this.checkInTournamentParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for checkPushDevice without sending the request
     */
    async checkPushDeviceRequestOpts(requestParameters: CheckPushDeviceRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/accounts/me/push/devices/check`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['PushDeviceRequest'],
        };
    }

    /**
     * Whether a device gets the logged-in account\'s pushes  The browser knows it has a subscription, not whose it is: another account may have taken the device over since.
     * Whether a device gets the logged-in account\'s pushes
     */
    async checkPushDeviceRaw(requestParameters: CheckPushDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushDeviceResponse>> {
        const requestOptions = await this.checkPushDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Whether a device gets the logged-in account\'s pushes  The browser knows it has a subscription, not whose it is: another account may have taken the device over since.
     * Whether a device gets the logged-in account\'s pushes
     */
    async checkPushDevice(requestParameters: CheckPushDeviceRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushDeviceResponse> {
        const response = await this.checkPushDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for chooseUsername without sending the request
     */
    async chooseUsernameRequestOpts(requestParameters: ChooseUsernameOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/oidc/username`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ChooseUsernameRequest'],
        };
    }

    /**
     * Finish the username step: create the External Account and log it in  Creates the Identity, the External identity and the Account, with the provider\'s verified email, in one transaction. A refused username keeps the login pending, so the person can pick another, also when a concurrent request took it after the check. An email an Account took since the callback ends the pending login.
     * Finish the username step: create the External Account and log it in
     */
    async chooseUsernameRaw(requestParameters: ChooseUsernameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForChooseUsernameErrors>> {
        const requestOptions = await this.chooseUsernameRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Finish the username step: create the External Account and log it in  Creates the Identity, the External identity and the Account, with the provider\'s verified email, in one transaction. A refused username keeps the login pending, so the person can pick another, also when a concurrent request took it after the check. An email an Account took since the callback ends the pending login.
     * Finish the username step: create the External Account and log it in
     */
    async chooseUsername(requestParameters: ChooseUsernameOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForChooseUsernameErrors> {
        const response = await this.chooseUsernameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for claimMatchLifeHistory without sending the request
     */
    async claimMatchLifeHistoryRequestOpts(requestParameters: ClaimMatchLifeHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling claimMatchLifeHistory().'
            );
        }

        if (requestParameters['match'] == null) {
            throw new runtime.RequiredError(
                'match',
                'Required parameter "match" was null or undefined when calling claimMatchLifeHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/matches/{match}/life-history/claim`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{match}', encodeURIComponent(String(requestParameters['match'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ClaimMatchLifeRequest'],
        };
    }

    /**
     * Deliberately claim a recording slot with a private, device-local capability.
     * Deliberately claim a recording slot with a private, device-local capability.
     */
    async claimMatchLifeHistoryRaw(requestParameters: ClaimMatchLifeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SaveMatchLifeHistory200Response>> {
        const requestOptions = await this.claimMatchLifeHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Deliberately claim a recording slot with a private, device-local capability.
     * Deliberately claim a recording slot with a private, device-local capability.
     */
    async claimMatchLifeHistory(requestParameters: ClaimMatchLifeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SaveMatchLifeHistory200Response> {
        const response = await this.claimMatchLifeHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createCollection without sending the request
     */
    async createCollectionRequestOpts(requestParameters: CreateCollectionOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/collections`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateCollectionRequest'],
        };
    }

    /**
     */
    async createCollectionRaw(requestParameters: CreateCollectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CollectionResponse>> {
        const requestOptions = await this.createCollectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createCollection(requestParameters: CreateCollectionOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CollectionResponse> {
        const response = await this.createCollectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createDeck without sending the request
     */
    async createDeckRequestOpts(requestParameters: CreateDeckOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateDeckRequest'],
        };
    }

    /**
     * Create a deck
     * Create a deck
     */
    async createDeckRaw(requestParameters: CreateDeckOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckResponse>> {
        const requestOptions = await this.createDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a deck
     * Create a deck
     */
    async createDeck(requestParameters: CreateDeckOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckResponse> {
        const response = await this.createDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createDeckFolder without sending the request
     */
    async createDeckFolderRequestOpts(requestParameters: CreateDeckFolderOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/folders`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateDeckFolderRequest'],
        };
    }

    /**
     * Make a folder
     * Make a folder
     */
    async createDeckFolderRaw(requestParameters: CreateDeckFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckFolderResponse>> {
        const requestOptions = await this.createDeckFolderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Make a folder
     * Make a folder
     */
    async createDeckFolder(requestParameters: CreateDeckFolderOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckFolderResponse> {
        const response = await this.createDeckFolderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createDeckTag without sending the request
     */
    async createDeckTagRequestOpts(requestParameters: CreateDeckTagOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling createDeckTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/tags`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateDeckTagRequest'],
        };
    }

    /**
     * Create a tag on a deck  The tag is the owner\'s, whoever creates it. An Editor only creates tags local to this deck: a global one reaches every deck of the owner.
     * Create a tag on a deck
     */
    async createDeckTagRaw(requestParameters: CreateDeckTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckTagResponse>> {
        const requestOptions = await this.createDeckTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a tag on a deck  The tag is the owner\'s, whoever creates it. An Editor only creates tags local to this deck: a global one reaches every deck of the owner.
     * Create a tag on a deck
     */
    async createDeckTag(requestParameters: CreateDeckTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckTagResponse> {
        const response = await this.createDeckTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createGlobalTag without sending the request
     */
    async createGlobalTagRequestOpts(requestParameters: CreateGlobalTagOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tags`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateGlobalTagRequest'],
        };
    }

    /**
     * Create a tag that follows a card through every deck and every collection  The same thing a deck\'s tag manager makes when it is asked for a global tag, reachable without naming a deck: a shelf is worth sorting before the first deck exists.
     * Create a tag that follows a card through every deck and every collection
     */
    async createGlobalTagRaw(requestParameters: CreateGlobalTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckTagResponse>> {
        const requestOptions = await this.createGlobalTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a tag that follows a card through every deck and every collection  The same thing a deck\'s tag manager makes when it is asked for a global tag, reachable without naming a deck: a shelf is worth sorting before the first deck exists.
     * Create a tag that follows a card through every deck and every collection
     */
    async createGlobalTag(requestParameters: CreateGlobalTagOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckTagResponse> {
        const response = await this.createGlobalTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createScannerSession without sending the request
     */
    async createScannerSessionRequestOpts(requestParameters: CreateScannerSessionOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/scanner-sessions`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateScannerSessionRequest'],
        };
    }

    /**
     * Start a new persisted scanner session
     * Start a new persisted scanner session
     */
    async createScannerSessionRaw(requestParameters: CreateScannerSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScannerSessionResponse>> {
        const requestOptions = await this.createScannerSessionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start a new persisted scanner session
     * Start a new persisted scanner session
     */
    async createScannerSession(requestParameters: CreateScannerSessionOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScannerSessionResponse> {
        const response = await this.createScannerSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createTournament without sending the request
     */
    async createTournamentRequestOpts(requestParameters: CreateTournamentRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['TournamentSettingsRequest'],
        };
    }

    /**
     * Create a Tournament, owned by the logged-in Account
     * Create a Tournament, owned by the logged-in Account
     */
    async createTournamentRaw(requestParameters: CreateTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTournament200Response>> {
        const requestOptions = await this.createTournamentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create a Tournament, owned by the logged-in Account
     * Create a Tournament, owned by the logged-in Account
     */
    async createTournament(requestParameters: CreateTournamentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTournament200Response> {
        const response = await this.createTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createWatchList without sending the request
     */
    async createWatchListRequestOpts(requestParameters: CreateWatchListOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/watch-lists`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateWatchListRequest'],
        };
    }

    /**
     * Start a new watch list
     * Start a new watch list
     */
    async createWatchListRaw(requestParameters: CreateWatchListOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WatchListResponse>> {
        const requestOptions = await this.createWatchListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start a new watch list
     * Start a new watch list
     */
    async createWatchList(requestParameters: CreateWatchListOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WatchListResponse> {
        const response = await this.createWatchListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for declineTournamentHandover without sending the request
     */
    async declineTournamentHandoverRequestOpts(requestParameters: DeclineTournamentHandoverRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling declineTournamentHandover().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/handover/decline`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Turn down a Tournament offered to the logged-in Account  Everything stays as it was, and the offer is gone.
     * Turn down a Tournament offered to the logged-in Account
     */
    async declineTournamentHandoverRaw(requestParameters: DeclineTournamentHandoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.declineTournamentHandoverRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Turn down a Tournament offered to the logged-in Account  Everything stays as it was, and the offer is gone.
     * Turn down a Tournament offered to the logged-in Account
     */
    async declineTournamentHandover(requestParameters: DeclineTournamentHandoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.declineTournamentHandoverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteAccount without sending the request
     */
    async deleteAccountRequestOpts(requestParameters: DeleteAccountOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/accounts/me`;

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['DeleteAccountRequest'],
        };
    }

    /**
     * Delete the logged-in account  The account, its passkeys, its collections, its watch lists and every deck it kept to itself are gone for good. What stays are the decks it put on show: those are handed to a tombstone, so a decklist somebody linked to keeps working while nothing points back at the account that built it.  Its Participants in other people\'s Tournaments stay as Guests, named \"Gelöschter Spieler N\" unless the request asks to keep the last username.  The request has to spell the account\'s own username. It is authenticated either way, so this is not what makes the deletion safe: it is what makes it deliberate.
     * Delete the logged-in account
     */
    async deleteAccountRaw(requestParameters: DeleteAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForDeleteAccountErrors>> {
        const requestOptions = await this.deleteAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete the logged-in account  The account, its passkeys, its collections, its watch lists and every deck it kept to itself are gone for good. What stays are the decks it put on show: those are handed to a tombstone, so a decklist somebody linked to keeps working while nothing points back at the account that built it.  Its Participants in other people\'s Tournaments stay as Guests, named \"Gelöschter Spieler N\" unless the request asks to keep the last username.  The request has to spell the account\'s own username. It is authenticated either way, so this is not what makes the deletion safe: it is what makes it deliberate.
     * Delete the logged-in account
     */
    async deleteAccount(requestParameters: DeleteAccountOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForDeleteAccountErrors> {
        const response = await this.deleteAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteCollection without sending the request
     */
    async deleteCollectionRequestOpts(requestParameters: DeleteCollectionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling deleteCollection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/collections/{collection}`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteCollectionRaw(requestParameters: DeleteCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteCollectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async deleteCollection(requestParameters: DeleteCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteCollectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteCollectionEntry without sending the request
     */
    async deleteCollectionEntryRequestOpts(requestParameters: DeleteCollectionEntryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling deleteCollectionEntry().'
            );
        }

        if (requestParameters['entry'] == null) {
            throw new runtime.RequiredError(
                'entry',
                'Required parameter "entry" was null or undefined when calling deleteCollectionEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/collections/{collection}/entries/{entry}`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));
        urlPath = urlPath.replace('{entry}', encodeURIComponent(String(requestParameters['entry'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove a stack from a collection
     * Remove a stack from a collection
     */
    async deleteCollectionEntryRaw(requestParameters: DeleteCollectionEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteCollectionEntryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Remove a stack from a collection
     * Remove a stack from a collection
     */
    async deleteCollectionEntry(requestParameters: DeleteCollectionEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteCollectionEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteDeck without sending the request
     */
    async deleteDeckRequestOpts(requestParameters: DeleteDeckRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling deleteDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a deck and everything in it
     * Delete a deck and everything in it
     */
    async deleteDeckRaw(requestParameters: DeleteDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete a deck and everything in it
     * Delete a deck and everything in it
     */
    async deleteDeck(requestParameters: DeleteDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteDeckCard without sending the request
     */
    async deleteDeckCardRequestOpts(requestParameters: DeleteDeckCardRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling deleteDeckCard().'
            );
        }

        if (requestParameters['card'] == null) {
            throw new runtime.RequiredError(
                'card',
                'Required parameter "card" was null or undefined when calling deleteDeckCard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/cards/{card}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));
        urlPath = urlPath.replace('{card}', encodeURIComponent(String(requestParameters['card'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Take a card out of a deck
     * Take a card out of a deck
     */
    async deleteDeckCardRaw(requestParameters: DeleteDeckCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteDeckCardRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Take a card out of a deck
     * Take a card out of a deck
     */
    async deleteDeckCard(requestParameters: DeleteDeckCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteDeckCardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteDeckFolder without sending the request
     */
    async deleteDeckFolderRequestOpts(requestParameters: DeleteDeckFolderRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['folder'] == null) {
            throw new runtime.RequiredError(
                'folder',
                'Required parameter "folder" was null or undefined when calling deleteDeckFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/folders/{folder}`;
        urlPath = urlPath.replace('{folder}', encodeURIComponent(String(requestParameters['folder'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Throw a folder away  The decks in it are not touched; they turn up among the ones on no shelf. The archive is refused, see [`update_deck_folder`].
     * Throw a folder away
     */
    async deleteDeckFolderRaw(requestParameters: DeleteDeckFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteDeckFolderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Throw a folder away  The decks in it are not touched; they turn up among the ones on no shelf. The archive is refused, see [`update_deck_folder`].
     * Throw a folder away
     */
    async deleteDeckFolder(requestParameters: DeleteDeckFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteDeckFolderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteDeckTag without sending the request
     */
    async deleteDeckTagRequestOpts(requestParameters: DeleteDeckTagRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling deleteDeckTag().'
            );
        }

        if (requestParameters['tag'] == null) {
            throw new runtime.RequiredError(
                'tag',
                'Required parameter "tag" was null or undefined when calling deleteDeckTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/tags/{tag}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));
        urlPath = urlPath.replace('{tag}', encodeURIComponent(String(requestParameters['tag'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a tag, taking it off every card it sat on  An Editor only deletes a tag local to this deck.
     * Delete a tag, taking it off every card it sat on
     */
    async deleteDeckTagRaw(requestParameters: DeleteDeckTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteDeckTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete a tag, taking it off every card it sat on  An Editor only deletes a tag local to this deck.
     * Delete a tag, taking it off every card it sat on
     */
    async deleteDeckTag(requestParameters: DeleteDeckTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteDeckTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteGlobalTag without sending the request
     */
    async deleteGlobalTagRequestOpts(requestParameters: DeleteGlobalTagRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tag'] == null) {
            throw new runtime.RequiredError(
                'tag',
                'Required parameter "tag" was null or undefined when calling deleteGlobalTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tags/{tag}`;
        urlPath = urlPath.replace('{tag}', encodeURIComponent(String(requestParameters['tag'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Throw a card-wide tag away, taking it off every card it sat on
     * Throw a card-wide tag away, taking it off every card it sat on
     */
    async deleteGlobalTagRaw(requestParameters: DeleteGlobalTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteGlobalTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Throw a card-wide tag away, taking it off every card it sat on
     * Throw a card-wide tag away, taking it off every card it sat on
     */
    async deleteGlobalTag(requestParameters: DeleteGlobalTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteGlobalTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deletePasskey without sending the request
     */
    async deletePasskeyRequestOpts(requestParameters: DeletePasskeyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deletePasskey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/accounts/passkeys/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete one of the logged-in account\'s passkeys  The last one cannot be deleted: with no passkey left there is no way back into the account, and the invite flow only issues a token while an account has none — which this would not restore, since the account still exists.
     * Delete one of the logged-in account\'s passkeys
     */
    async deletePasskeyRaw(requestParameters: DeletePasskeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForDeletePasskeyErrors>> {
        const requestOptions = await this.deletePasskeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete one of the logged-in account\'s passkeys  The last one cannot be deleted: with no passkey left there is no way back into the account, and the invite flow only issues a token while an account has none — which this would not restore, since the account still exists.
     * Delete one of the logged-in account\'s passkeys
     */
    async deletePasskey(requestParameters: DeletePasskeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForDeletePasskeyErrors> {
        const response = await this.deletePasskeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteScannerSession without sending the request
     */
    async deleteScannerSessionRequestOpts(requestParameters: DeleteScannerSessionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['session'] == null) {
            throw new runtime.RequiredError(
                'session',
                'Required parameter "session" was null or undefined when calling deleteScannerSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/scanner-sessions/{session}`;
        urlPath = urlPath.replace('{session}', encodeURIComponent(String(requestParameters['session'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a session and its staging area
     * Delete a session and its staging area
     */
    async deleteScannerSessionRaw(requestParameters: DeleteScannerSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteScannerSessionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete a session and its staging area
     * Delete a session and its staging area
     */
    async deleteScannerSession(requestParameters: DeleteScannerSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteScannerSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteScannerSessionEntry without sending the request
     */
    async deleteScannerSessionEntryRequestOpts(requestParameters: DeleteScannerSessionEntryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['session'] == null) {
            throw new runtime.RequiredError(
                'session',
                'Required parameter "session" was null or undefined when calling deleteScannerSessionEntry().'
            );
        }

        if (requestParameters['entry'] == null) {
            throw new runtime.RequiredError(
                'entry',
                'Required parameter "entry" was null or undefined when calling deleteScannerSessionEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/scanner-sessions/{session}/entries/{entry}`;
        urlPath = urlPath.replace('{session}', encodeURIComponent(String(requestParameters['session'])));
        urlPath = urlPath.replace('{entry}', encodeURIComponent(String(requestParameters['entry'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove a staged stack
     * Remove a staged stack
     */
    async deleteScannerSessionEntryRaw(requestParameters: DeleteScannerSessionEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteScannerSessionEntryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Remove a staged stack
     * Remove a staged stack
     */
    async deleteScannerSessionEntry(requestParameters: DeleteScannerSessionEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteScannerSessionEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteTournament without sending the request
     */
    async deleteTournamentRequestOpts(requestParameters: DeleteTournamentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling deleteTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a Tournament and everything in it, as its Owner
     * Delete a Tournament and everything in it, as its Owner
     */
    async deleteTournamentRaw(requestParameters: DeleteTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteTournamentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete a Tournament and everything in it, as its Owner
     * Delete a Tournament and everything in it, as its Owner
     */
    async deleteTournament(requestParameters: DeleteTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteWatchList without sending the request
     */
    async deleteWatchListRequestOpts(requestParameters: DeleteWatchListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['list'] == null) {
            throw new runtime.RequiredError(
                'list',
                'Required parameter "list" was null or undefined when calling deleteWatchList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/watch-lists/{list}`;
        urlPath = urlPath.replace('{list}', encodeURIComponent(String(requestParameters['list'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Throw a watch list away, taking every entry on it with it
     * Throw a watch list away, taking every entry on it with it
     */
    async deleteWatchListRaw(requestParameters: DeleteWatchListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteWatchListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Throw a watch list away, taking every entry on it with it
     * Throw a watch list away, taking every entry on it with it
     */
    async deleteWatchList(requestParameters: DeleteWatchListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteWatchListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteWatchListEntry without sending the request
     */
    async deleteWatchListEntryRequestOpts(requestParameters: DeleteWatchListEntryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['list'] == null) {
            throw new runtime.RequiredError(
                'list',
                'Required parameter "list" was null or undefined when calling deleteWatchListEntry().'
            );
        }

        if (requestParameters['entry'] == null) {
            throw new runtime.RequiredError(
                'entry',
                'Required parameter "entry" was null or undefined when calling deleteWatchListEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/watch-lists/{list}/entries/{entry}`;
        urlPath = urlPath.replace('{list}', encodeURIComponent(String(requestParameters['list'])));
        urlPath = urlPath.replace('{entry}', encodeURIComponent(String(requestParameters['entry'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Take a card off a watch list
     * Take a card off a watch list
     */
    async deleteWatchListEntryRaw(requestParameters: DeleteWatchListEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteWatchListEntryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Take a card off a watch list
     * Take a card off a watch list
     */
    async deleteWatchListEntry(requestParameters: DeleteWatchListEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteWatchListEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for detachDeckCollection without sending the request
     */
    async detachDeckCollectionRequestOpts(requestParameters: DetachDeckCollectionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling detachDeckCollection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/collection`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Stop keeping them  Refused while cards are still filed in it: they would otherwise leave the account\'s inventory without anybody saying where they went.
     * Stop keeping them
     */
    async detachDeckCollectionRaw(requestParameters: DetachDeckCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.detachDeckCollectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Stop keeping them  Refused while cards are still filed in it: they would otherwise leave the account\'s inventory without anybody saying where they went.
     * Stop keeping them
     */
    async detachDeckCollection(requestParameters: DetachDeckCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.detachDeckCollectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for discardTournamentRound without sending the request
     */
    async discardTournamentRoundRequestOpts(requestParameters: DiscardTournamentRoundRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling discardTournamentRound().'
            );
        }

        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling discardTournamentRound().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/rounds/{number}`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{number}', encodeURIComponent(String(requestParameters['number'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Throw a previewed Round away, as an Organizer, to pair it again
     * Throw a previewed Round away, as an Organizer, to pair it again
     */
    async discardTournamentRoundRaw(requestParameters: DiscardTournamentRoundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForRoundErrors>> {
        const requestOptions = await this.discardTournamentRoundRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Throw a previewed Round away, as an Organizer, to pair it again
     * Throw a previewed Round away, as an Organizer, to pair it again
     */
    async discardTournamentRound(requestParameters: DiscardTournamentRoundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForRoundErrors> {
        const response = await this.discardTournamentRoundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for disputeTournamentMatchResult without sending the request
     */
    async disputeTournamentMatchResultRequestOpts(requestParameters: DisputeTournamentMatchResultRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling disputeTournamentMatchResult().'
            );
        }

        if (requestParameters['match'] == null) {
            throw new runtime.RequiredError(
                'match',
                'Required parameter "match" was null or undefined when calling disputeTournamentMatchResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/matches/{match}/dispute`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{match}', encodeURIComponent(String(requestParameters['match'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Dispute the Result another Participant reported for one\'s own Match  Possible while the Round runs. The Round cannot end until an Organizer settles the Result. A locked Account cannot dispute.
     * Dispute the Result another Participant reported for one\'s own Match
     */
    async disputeTournamentMatchResultRaw(requestParameters: DisputeTournamentMatchResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForDisputeResultErrors>> {
        const requestOptions = await this.disputeTournamentMatchResultRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Dispute the Result another Participant reported for one\'s own Match  Possible while the Round runs. The Round cannot end until an Organizer settles the Result. A locked Account cannot dispute.
     * Dispute the Result another Participant reported for one\'s own Match
     */
    async disputeTournamentMatchResult(requestParameters: DisputeTournamentMatchResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForDisputeResultErrors> {
        const response = await this.disputeTournamentMatchResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dropOutOfTournament without sending the request
     */
    async dropOutOfTournamentRequestOpts(requestParameters: DropOutOfTournamentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling dropOutOfTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/drop`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Drop the logged-in Account out of a Tournament it plays in  Once the first Round started, until the Tournament is over; before the first Round an Account withdraws its sign-up instead. No later Round pairs it; it stays in the standings with its Results so far.
     * Drop the logged-in Account out of a Tournament it plays in
     */
    async dropOutOfTournamentRaw(requestParameters: DropOutOfTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForDropErrors>> {
        const requestOptions = await this.dropOutOfTournamentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Drop the logged-in Account out of a Tournament it plays in  Once the first Round started, until the Tournament is over; before the first Round an Account withdraws its sign-up instead. No later Round pairs it; it stays in the standings with its Results so far.
     * Drop the logged-in Account out of a Tournament it plays in
     */
    async dropOutOfTournament(requestParameters: DropOutOfTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForDropErrors> {
        const response = await this.dropOutOfTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dropTournamentParticipant without sending the request
     */
    async dropTournamentParticipantRequestOpts(requestParameters: DropTournamentParticipantRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling dropTournamentParticipant().'
            );
        }

        if (requestParameters['participant'] == null) {
            throw new runtime.RequiredError(
                'participant',
                'Required parameter "participant" was null or undefined when calling dropTournamentParticipant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/participants/{participant}/drop`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{participant}', encodeURIComponent(String(requestParameters['participant'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Drop a Participant, as an Organizer  Once the first Round started, until the Tournament is over. No later Round pairs it; it stays in the standings with its Results so far.
     * Drop a Participant, as an Organizer
     */
    async dropTournamentParticipantRaw(requestParameters: DropTournamentParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForDropErrors>> {
        const requestOptions = await this.dropTournamentParticipantRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Drop a Participant, as an Organizer  Once the first Round started, until the Tournament is over. No later Round pairs it; it stays in the standings with its Results so far.
     * Drop a Participant, as an Organizer
     */
    async dropTournamentParticipant(requestParameters: DropTournamentParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForDropErrors> {
        const response = await this.dropTournamentParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for endTournamentRound without sending the request
     */
    async endTournamentRoundRequestOpts(requestParameters: EndTournamentRoundRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling endTournamentRound().'
            );
        }

        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling endTournamentRound().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/rounds/{number}/end`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{number}', encodeURIComponent(String(requestParameters['number'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * End a running Round once every Match has its Result, as an Organizer  After the last Swiss Round the Tournament is Finished.
     * End a running Round once every Match has its Result, as an Organizer
     */
    async endTournamentRoundRaw(requestParameters: EndTournamentRoundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EndTournamentRound200Response>> {
        const requestOptions = await this.endTournamentRoundRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * End a running Round once every Match has its Result, as an Organizer  After the last Swiss Round the Tournament is Finished.
     * End a running Round once every Match has its Result, as an Organizer
     */
    async endTournamentRound(requestParameters: EndTournamentRoundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EndTournamentRound200Response> {
        const response = await this.endTournamentRoundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for fileScannerSession without sending the request
     */
    async fileScannerSessionRequestOpts(requestParameters: FileScannerSessionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['session'] == null) {
            throw new runtime.RequiredError(
                'session',
                'Required parameter "session" was null or undefined when calling fileScannerSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/scanner-sessions/{session}/file`;
        urlPath = urlPath.replace('{session}', encodeURIComponent(String(requestParameters['session'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['FileScannerSessionRequest'],
        };
    }

    /**
     * Atomically file every staged stack and empty the session
     * Atomically file every staged stack and empty the session
     */
    async fileScannerSessionRaw(requestParameters: FileScannerSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileScannerSessionResponse>> {
        const requestOptions = await this.fileScannerSessionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Atomically file every staged stack and empty the session
     * Atomically file every staged stack and empty the session
     */
    async fileScannerSession(requestParameters: FileScannerSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileScannerSessionResponse> {
        const response = await this.fileScannerSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for fillDeckCollection without sending the request
     */
    async fillDeckCollectionRequestOpts(requestParameters: FillDeckCollectionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling fillDeckCollection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/sourcing/fill`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['FillDeckCollectionRequest'],
        };
    }

    /**
     * Declare that the deck holds what its list asks for  Two things at once, because they are the same thing at different sizes: the way in for a deck that arrived from somewhere else, where the list is already right and saying so one card at a time would be an afternoon\'s work, and the answer to \"I bought that one\" for a single slot.  The slots are topped up to what they ask for, in the printing and finish they name, as near mint and without an origin: nothing was taken out of a collection, so there is nowhere to put it back. Sorting them into one later is the same return call with a target.
     * Declare that the deck holds what its list asks for
     */
    async fillDeckCollectionRaw(requestParameters: FillDeckCollectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FillDeckCollectionResponse>> {
        const requestOptions = await this.fillDeckCollectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Declare that the deck holds what its list asks for  Two things at once, because they are the same thing at different sizes: the way in for a deck that arrived from somewhere else, where the list is already right and saying so one card at a time would be an afternoon\'s work, and the answer to \"I bought that one\" for a single slot.  The slots are topped up to what they ask for, in the printing and finish they name, as near mint and without an origin: nothing was taken out of a collection, so there is nowhere to put it back. Sorting them into one later is the same return call with a target.
     * Declare that the deck holds what its list asks for
     */
    async fillDeckCollection(requestParameters: FillDeckCollectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FillDeckCollectionResponse> {
        const response = await this.fillDeckCollectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for finishAddPasskey without sending the request
     */
    async finishAddPasskeyRequestOpts(requestParameters: FinishAddPasskeyOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/accounts/passkeys/finish`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['FinishAddPasskeyRequest'],
        };
    }

    /**
     * Finish registering another passkey for the logged-in account
     * Finish registering another passkey for the logged-in account
     */
    async finishAddPasskeyRaw(requestParameters: FinishAddPasskeyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForAddPasskeyErrors>> {
        const requestOptions = await this.finishAddPasskeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Finish registering another passkey for the logged-in account
     * Finish registering another passkey for the logged-in account
     */
    async finishAddPasskey(requestParameters: FinishAddPasskeyOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForAddPasskeyErrors> {
        const response = await this.finishAddPasskeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for finishLogin without sending the request
     */
    async finishLoginRequestOpts(requestParameters: FinishLoginOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/login/finish`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['FinishLoginRequest'],
        };
    }

    /**
     * Finish a passkey login  Verifies the browser\'s credential and logs the account in. An account locked since its login started is logged right out again.
     * Finish a passkey login
     */
    async finishLoginRaw(requestParameters: FinishLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForFinishLoginErrors>> {
        const requestOptions = await this.finishLoginRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Finish a passkey login  Verifies the browser\'s credential and logs the account in. An account locked since its login started is logged right out again.
     * Finish a passkey login
     */
    async finishLogin(requestParameters: FinishLoginOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForFinishLoginErrors> {
        const response = await this.finishLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for finishOidcLogin without sending the request
     */
    async finishOidcLoginRequestOpts(requestParameters: FinishOidcLoginRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['error'] != null) {
            queryParameters['error'] = requestParameters['error'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/auth/oidc/callback`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Finish an OIDC login: the provider sends the browser back here  A known External identity is logged in and lands on the app, unless its Account is locked. An unknown one is held pending and goes to the username step. A refused login goes back to the login page with `oidc_error` naming why.
     * Finish an OIDC login: the provider sends the browser back here
     */
    async finishOidcLoginRaw(requestParameters: FinishOidcLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.finishOidcLoginRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Finish an OIDC login: the provider sends the browser back here  A known External identity is logged in and lands on the app, unless its Account is locked. An unknown one is held pending and goes to the username step. A refused login goes back to the login page with `oidc_error` naming why.
     * Finish an OIDC login: the provider sends the browser back here
     */
    async finishOidcLogin(requestParameters: FinishOidcLoginRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.finishOidcLoginRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for finishRegistration without sending the request
     */
    async finishRegistrationRequestOpts(requestParameters: FinishRegistrationOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/register/finish`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['FinishRegistrationRequest'],
        };
    }

    /**
     * Finish a passkey registration
     * Finish a passkey registration
     */
    async finishRegistrationRaw(requestParameters: FinishRegistrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForRegistrationErrors>> {
        const requestOptions = await this.finishRegistrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Finish a passkey registration
     * Finish a passkey registration
     */
    async finishRegistration(requestParameters: FinishRegistrationOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForRegistrationErrors> {
        const response = await this.finishRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for followSharedTournament without sending the request
     */
    async followSharedTournamentRequestOpts(requestParameters: FollowSharedTournamentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling followSharedTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shared/tournaments/{token}/events`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Follow what changes in the Tournament a share link points at, as Server-Sent Events  What anybody sees: never the previewed Round.
     * Follow what changes in the Tournament a share link points at, as Server-Sent Events
     */
    async followSharedTournamentRaw(requestParameters: FollowSharedTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentEvent>> {
        const requestOptions = await this.followSharedTournamentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Follow what changes in the Tournament a share link points at, as Server-Sent Events  What anybody sees: never the previewed Round.
     * Follow what changes in the Tournament a share link points at, as Server-Sent Events
     */
    async followSharedTournament(requestParameters: FollowSharedTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentEvent> {
        const response = await this.followSharedTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for followTournament without sending the request
     */
    async followTournamentRequestOpts(requestParameters: FollowTournamentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling followTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/events`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Follow what changes in a Tournament the reader may see, as Server-Sent Events  Each event names what changed; the reader fetches that again. Organizers also hear about the previewed Round.
     * Follow what changes in a Tournament the reader may see, as Server-Sent Events
     */
    async followTournamentRaw(requestParameters: FollowTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentEvent>> {
        const requestOptions = await this.followTournamentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Follow what changes in a Tournament the reader may see, as Server-Sent Events  Each event names what changed; the reader fetches that again. Organizers also hear about the previewed Round.
     * Follow what changes in a Tournament the reader may see, as Server-Sent Events
     */
    async followTournament(requestParameters: FollowTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentEvent> {
        const response = await this.followTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllCollections without sending the request
     */
    async getAllCollectionsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/collections`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllCollectionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CollectionOverviewResponse>>> {
        const requestOptions = await this.getAllCollectionsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllCollections(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CollectionOverviewResponse>> {
        const response = await this.getAllCollectionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllDeckFolders without sending the request
     */
    async getAllDeckFoldersRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/folders`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List every folder the account keeps  The archive is part of the answer whether or not anything was ever put away: a client offering to file a deck needs the shelf to exist before the first deck goes onto it.
     * List every folder the account keeps
     */
    async getAllDeckFoldersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDeckFoldersResponse>> {
        const requestOptions = await this.getAllDeckFoldersRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List every folder the account keeps  The archive is part of the answer whether or not anything was ever put away: a client offering to file a deck needs the shelf to exist before the first deck goes onto it.
     * List every folder the account keeps
     */
    async getAllDeckFolders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDeckFoldersResponse> {
        const response = await this.getAllDeckFoldersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllDecks without sending the request
     */
    async getAllDecksRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The decks an account owns
     * The decks an account owns
     */
    async getAllDecksRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeckOverviewResponse>>> {
        const requestOptions = await this.getAllDecksRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The decks an account owns
     * The decks an account owns
     */
    async getAllDecks(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeckOverviewResponse>> {
        const response = await this.getAllDecksRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllGlobalTags without sending the request
     */
    async getAllGlobalTagsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tags`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Every tag the account keeps for all of its decks and collections
     * Every tag the account keeps for all of its decks and collections
     */
    async getAllGlobalTagsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListGlobalTagsResponse>> {
        const requestOptions = await this.getAllGlobalTagsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Every tag the account keeps for all of its decks and collections
     * Every tag the account keeps for all of its decks and collections
     */
    async getAllGlobalTags(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListGlobalTagsResponse> {
        const response = await this.getAllGlobalTagsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllScannerSessions without sending the request
     */
    async getAllScannerSessionsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/scanner-sessions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List every scanner session and its current staging count
     * List every scanner session and its current staging count
     */
    async getAllScannerSessionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListScannerSessionsResponse>> {
        const requestOptions = await this.getAllScannerSessionsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List every scanner session and its current staging count
     * List every scanner session and its current staging count
     */
    async getAllScannerSessions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListScannerSessionsResponse> {
        const response = await this.getAllScannerSessionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllWatchLists without sending the request
     */
    async getAllWatchListsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/watch-lists`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Every watch list the account keeps
     * Every watch list the account keeps
     */
    async getAllWatchListsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWatchListsResponse>> {
        const requestOptions = await this.getAllWatchListsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Every watch list the account keeps
     * Every watch list the account keeps
     */
    async getAllWatchLists(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWatchListsResponse> {
        const response = await this.getAllWatchListsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getBracketFlags without sending the request
     */
    async getBracketFlagsRequestOpts(requestParameters: GetBracketFlagsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/printings/bracket-flags`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['BracketFlagsRequest'],
        };
    }

    /**
     * Which Commander bracket rules the given printings count towards  What a card would do to a deck\'s Bracket claim, asked before it is added.
     * Which Commander bracket rules the given printings count towards
     */
    async getBracketFlagsRaw(requestParameters: GetBracketFlagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BracketFlagsResponse>> {
        const requestOptions = await this.getBracketFlagsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Which Commander bracket rules the given printings count towards  What a card would do to a deck\'s Bracket claim, asked before it is added.
     * Which Commander bracket rules the given printings count towards
     */
    async getBracketFlags(requestParameters: GetBracketFlagsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BracketFlagsResponse> {
        const response = await this.getBracketFlagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCollection without sending the request
     */
    async getCollectionRequestOpts(requestParameters: GetCollectionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling getCollection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/collections/{collection}`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch a single collection  Resolves for the owner and for anything public — a page showing one collection should not have to pull the whole list to learn its name.
     * Fetch a single collection
     */
    async getCollectionRaw(requestParameters: GetCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CollectionResponse>> {
        const requestOptions = await this.getCollectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch a single collection  Resolves for the owner and for anything public — a page showing one collection should not have to pull the whole list to learn its name.
     * Fetch a single collection
     */
    async getCollection(requestParameters: GetCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CollectionResponse> {
        const response = await this.getCollectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCollectionStatistics without sending the request
     */
    async getCollectionStatisticsRequestOpts(requestParameters: GetCollectionStatisticsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling getCollectionStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/collections/{collection}/statistics`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getCollectionStatisticsRaw(requestParameters: GetCollectionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CollectionStatisticsResponse>> {
        const requestOptions = await this.getCollectionStatisticsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getCollectionStatistics(requestParameters: GetCollectionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CollectionStatisticsResponse> {
        const response = await this.getCollectionStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDeck without sending the request
     */
    async getDeckRequestOpts(requestParameters: GetDeckRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling getDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch a single deck, with the caller\'s role on it  Only the owner gets its share link and folder.
     * Fetch a single deck, with the caller\'s role on it
     */
    async getDeckRaw(requestParameters: GetDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckResponse>> {
        const requestOptions = await this.getDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch a single deck, with the caller\'s role on it  Only the owner gets its share link and folder.
     * Fetch a single deck, with the caller\'s role on it
     */
    async getDeck(requestParameters: GetDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckResponse> {
        const response = await this.getDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDeckAdvisorSettings without sending the request
     */
    async getDeckAdvisorSettingsRequestOpts(requestParameters: GetDeckAdvisorSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling getDeckAdvisorSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/advisor-settings`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Read this deck\'s advisor settings  A deck nobody has advised yet still answers: the document at its defaults, not a 404. The 404 is reserved for a deck this account may not edit.
     * Read this deck\'s advisor settings
     */
    async getDeckAdvisorSettingsRaw(requestParameters: GetDeckAdvisorSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdvisorSettingsResponse>> {
        const requestOptions = await this.getDeckAdvisorSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Read this deck\'s advisor settings  A deck nobody has advised yet still answers: the document at its defaults, not a 404. The 404 is reserved for a deck this account may not edit.
     * Read this deck\'s advisor settings
     */
    async getDeckAdvisorSettings(requestParameters: GetDeckAdvisorSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdvisorSettingsResponse> {
        const response = await this.getDeckAdvisorSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDeckCollectionDrift without sending the request
     */
    async getDeckCollectionDriftRequestOpts(requestParameters: GetDeckCollectionDriftRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling getDeckCollectionDrift().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/collection/drift`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Where the deck list and the deck\'s own collection disagree  Read on its own rather than out of the sourcing answer: the header asks this on every tab of the deck, and it has no use for the whole account\'s shelf.
     * Where the deck list and the deck\'s own collection disagree
     */
    async getDeckCollectionDriftRaw(requestParameters: GetDeckCollectionDriftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckDriftResponse>> {
        const requestOptions = await this.getDeckCollectionDriftRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Where the deck list and the deck\'s own collection disagree  Read on its own rather than out of the sourcing answer: the header asks this on every tab of the deck, and it has no use for the whole account\'s shelf.
     * Where the deck list and the deck\'s own collection disagree
     */
    async getDeckCollectionDrift(requestParameters: GetDeckCollectionDriftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckDriftResponse> {
        const response = await this.getDeckCollectionDriftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDeckFormats without sending the request
     */
    async getDeckFormatsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/formats`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * What the offered formats ask of a deck  Construction rules only: size, copies, commander, sideboard. Whether a card is legal is answered per card by the catalog — except for the bans that apply to a zone rather than to a deck, which a printing row cannot carry and which ride along here instead.
     * What the offered formats ask of a deck
     */
    async getDeckFormatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListFormatsResponse>> {
        const requestOptions = await this.getDeckFormatsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * What the offered formats ask of a deck  Construction rules only: size, copies, commander, sideboard. Whether a card is legal is answered per card by the catalog — except for the bans that apply to a zone rather than to a deck, which a printing row cannot carry and which ride along here instead.
     * What the offered formats ask of a deck
     */
    async getDeckFormats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListFormatsResponse> {
        const response = await this.getDeckFormatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDeckHistory without sending the request
     */
    async getDeckHistoryRequestOpts(requestParameters: GetDeckHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling getDeckHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/history`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A deck\'s Deck history, newest first  Only the owner reads it, whoever else may see the deck itself.
     * A deck\'s Deck history, newest first
     */
    async getDeckHistoryRaw(requestParameters: GetDeckHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckHistoryResponse>> {
        const requestOptions = await this.getDeckHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * A deck\'s Deck history, newest first  Only the owner reads it, whoever else may see the deck itself.
     * A deck\'s Deck history, newest first
     */
    async getDeckHistory(requestParameters: GetDeckHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckHistoryResponse> {
        const response = await this.getDeckHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDeckPoint without sending the request
     */
    async getDeckPointRequestOpts(requestParameters: GetDeckPointRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling getDeckPoint().'
            );
        }

        if (requestParameters['change'] == null) {
            throw new runtime.RequiredError(
                'change',
                'Required parameter "change" was null or undefined when calling getDeckPoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/history/{change}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));
        urlPath = urlPath.replace('{change}', encodeURIComponent(String(requestParameters['change'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The deck as it was right after one of its Deck changes, read-only  Only the owner reads it. Computed backwards from the deck as it is now.
     * The deck as it was right after one of its Deck changes, read-only
     */
    async getDeckPointRaw(requestParameters: GetDeckPointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckPointResponse>> {
        const requestOptions = await this.getDeckPointRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The deck as it was right after one of its Deck changes, read-only  Only the owner reads it. Computed backwards from the deck as it is now.
     * The deck as it was right after one of its Deck changes, read-only
     */
    async getDeckPoint(requestParameters: GetDeckPointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckPointResponse> {
        const response = await this.getDeckPointRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDeckSourcing without sending the request
     */
    async getDeckSourcingRequestOpts(requestParameters: GetDeckSourcingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling getDeckSourcing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/sourcing`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * What the deck asks for, what is in it, and where the rest could come from
     * What the deck asks for, what is in it, and where the rest could come from
     */
    async getDeckSourcingRaw(requestParameters: GetDeckSourcingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckSourcingResponse>> {
        const requestOptions = await this.getDeckSourcingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * What the deck asks for, what is in it, and where the rest could come from
     * What the deck asks for, what is in it, and where the rest could come from
     */
    async getDeckSourcing(requestParameters: GetDeckSourcingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckSourcingResponse> {
        const response = await this.getDeckSourcingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDecksSharedWithMe without sending the request
     */
    async getDecksSharedWithMeRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/shared-with-me`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The decks other Accounts named the caller on, alphabetically by name  \"Shared with me\": never filed into the caller\'s folders, which hold only the caller\'s own decks.
     * The decks other Accounts named the caller on, alphabetically by name
     */
    async getDecksSharedWithMeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSharedWithMeResponse>> {
        const requestOptions = await this.getDecksSharedWithMeRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The decks other Accounts named the caller on, alphabetically by name  \"Shared with me\": never filed into the caller\'s folders, which hold only the caller\'s own decks.
     * The decks other Accounts named the caller on, alphabetically by name
     */
    async getDecksSharedWithMe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSharedWithMeResponse> {
        const response = await this.getDecksSharedWithMeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMatchLifeConflict without sending the request
     */
    async getMatchLifeConflictRequestOpts(requestParameters: GetMatchLifeConflictRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling getMatchLifeConflict().'
            );
        }

        if (requestParameters['match'] == null) {
            throw new runtime.RequiredError(
                'match',
                'Required parameter "match" was null or undefined when calling getMatchLifeConflict().'
            );
        }

        if (requestParameters['conflict'] == null) {
            throw new runtime.RequiredError(
                'conflict',
                'Required parameter "conflict" was null or undefined when calling getMatchLifeConflict().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/matches/{match}/life-history/conflicts/{conflict}`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{match}', encodeURIComponent(String(requestParameters['match'])));
        urlPath = urlPath.replace('{conflict}', encodeURIComponent(String(requestParameters['conflict'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Reads one recovered branch without applying it to the Match.
     * Reads one recovered branch without applying it to the Match.
     */
    async getMatchLifeConflictRaw(requestParameters: GetMatchLifeConflictRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchLifeConflict>> {
        const requestOptions = await this.getMatchLifeConflictRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Reads one recovered branch without applying it to the Match.
     * Reads one recovered branch without applying it to the Match.
     */
    async getMatchLifeConflict(requestParameters: GetMatchLifeConflictRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchLifeConflict> {
        const response = await this.getMatchLifeConflictRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMatchLifeHistory without sending the request
     */
    async getMatchLifeHistoryRequestOpts(requestParameters: GetMatchLifeHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling getMatchLifeHistory().'
            );
        }

        if (requestParameters['match'] == null) {
            throw new runtime.RequiredError(
                'match',
                'Required parameter "match" was null or undefined when calling getMatchLifeHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/matches/{match}/life-history`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{match}', encodeURIComponent(String(requestParameters['match'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Observe uploaded history without claiming the recording device.
     * Observe uploaded history without claiming the recording device.
     */
    async getMatchLifeHistoryRaw(requestParameters: GetMatchLifeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchLifeHistoryResponse>> {
        const requestOptions = await this.getMatchLifeHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Observe uploaded history without claiming the recording device.
     * Observe uploaded history without claiming the recording device.
     */
    async getMatchLifeHistory(requestParameters: GetMatchLifeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchLifeHistoryResponse> {
        const response = await this.getMatchLifeHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMpcfillCardbacks without sending the request
     */
    async getMpcfillCardbacksRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/mpcfill/cardbacks`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The card backs MPCFill offers  An order names one back for every card that does not bring its own, so this is the list that choice is made from. The same for everybody, so it is fetched once and held for a few hours.
     * The card backs MPCFill offers
     */
    async getMpcfillCardbacksRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MpcFillCardbacksResponse>> {
        const requestOptions = await this.getMpcfillCardbacksRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The card backs MPCFill offers  An order names one back for every card that does not bring its own, so this is the list that choice is made from. The same for everybody, so it is fetched once and held for a few hours.
     * The card backs MPCFill offers
     */
    async getMpcfillCardbacks(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MpcFillCardbacksResponse> {
        const response = await this.getMpcfillCardbacksRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMyTournamentDeck without sending the request
     */
    async getMyTournamentDeckRequestOpts(requestParameters: GetMyTournamentDeckRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling getMyTournamentDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/deck`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The logged-in Account\'s own Registered deck in a Tournament it plays in  Says whether it may still change it itself, which ends when the first Round starts; a late Participant registers its own until it is pinned.
     * The logged-in Account\'s own Registered deck in a Tournament it plays in
     */
    async getMyTournamentDeckRaw(requestParameters: GetMyTournamentDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyRegisteredDeckResponse>> {
        const requestOptions = await this.getMyTournamentDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The logged-in Account\'s own Registered deck in a Tournament it plays in  Says whether it may still change it itself, which ends when the first Round starts; a late Participant registers its own until it is pinned.
     * The logged-in Account\'s own Registered deck in a Tournament it plays in
     */
    async getMyTournamentDeck(requestParameters: GetMyTournamentDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyRegisteredDeckResponse> {
        const response = await this.getMyTournamentDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMyTournamentMatch without sending the request
     */
    async getMyTournamentMatchRequestOpts(requestParameters: GetMyTournamentMatchRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling getMyTournamentMatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/my-match`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The reader\'s Match in the running Round of a Tournament, with the round timer  For a Participant with an Account: its table, its opponents and its Seat, or its Bye. An Account playing in none gets the Round and timer only.
     * The reader\'s Match in the running Round of a Tournament, with the round timer
     */
    async getMyTournamentMatchRaw(requestParameters: GetMyTournamentMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyMatchResponse>> {
        const requestOptions = await this.getMyTournamentMatchRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The reader\'s Match in the running Round of a Tournament, with the round timer  For a Participant with an Account: its table, its opponents and its Seat, or its Bye. An Account playing in none gets the Round and timer only.
     * The reader\'s Match in the running Round of a Tournament, with the round timer
     */
    async getMyTournamentMatch(requestParameters: GetMyTournamentMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyMatchResponse> {
        const response = await this.getMyTournamentMatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMyTournaments without sending the request
     */
    async getMyTournamentsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/mine`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The Tournaments the logged-in Account organizes and the ones it plays in  Private and unlisted ones included: the Account has its part in each.
     * The Tournaments the logged-in Account organizes and the ones it plays in
     */
    async getMyTournamentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyTournamentsResponse>> {
        const requestOptions = await this.getMyTournamentsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The Tournaments the logged-in Account organizes and the ones it plays in  Private and unlisted ones included: the Account has its part in each.
     * The Tournaments the logged-in Account organizes and the ones it plays in
     */
    async getMyTournaments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyTournamentsResponse> {
        const response = await this.getMyTournamentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPendingOidcLogin without sending the request
     */
    async getPendingOidcLoginRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/auth/oidc/pending`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The session\'s OIDC login waiting for its username step
     * The session\'s OIDC login waiting for its username step
     */
    async getPendingOidcLoginRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPendingOidcLoginResponse>> {
        const requestOptions = await this.getPendingOidcLoginRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The session\'s OIDC login waiting for its username step
     * The session\'s OIDC login waiting for its username step
     */
    async getPendingOidcLogin(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPendingOidcLoginResponse> {
        const response = await this.getPendingOidcLoginRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPriceHistory without sending the request
     */
    async getPriceHistoryRequestOpts(requestParameters: GetPriceHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['printing'] == null) {
            throw new runtime.RequiredError(
                'printing',
                'Required parameter "printing" was null or undefined when calling getPriceHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/printings/{printing}/price-history`;
        urlPath = urlPath.replace('{printing}', encodeURIComponent(String(requestParameters['printing'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * What a card has cost over time  Read from Cardmarket\'s daily price guide, keyed by the product the printing is sold as. Daily for the last quarter, weekly before that — see `models::price`.  An empty list is the honest answer for a card the guide does not carry and for one whose first day has not been read yet. Nothing here is per language: Cardmarket sells every language of a card as the one product.
     * What a card has cost over time
     */
    async getPriceHistoryRaw(requestParameters: GetPriceHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PriceHistoryResponse>> {
        const requestOptions = await this.getPriceHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * What a card has cost over time  Read from Cardmarket\'s daily price guide, keyed by the product the printing is sold as. Daily for the last quarter, weekly before that — see `models::price`.  An empty list is the honest answer for a card the guide does not carry and for one whose first day has not been read yet. Nothing here is per language: Cardmarket sells every language of a card as the one product.
     * What a card has cost over time
     */
    async getPriceHistory(requestParameters: GetPriceHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PriceHistoryResponse> {
        const response = await this.getPriceHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPrintingLanguages without sending the request
     */
    async getPrintingLanguagesRequestOpts(requestParameters: GetPrintingLanguagesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['printing'] == null) {
            throw new runtime.RequiredError(
                'printing',
                'Required parameter "printing" was null or undefined when calling getPrintingLanguages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/printings/{printing}/languages`;
        urlPath = urlPath.replace('{printing}', encodeURIComponent(String(requestParameters['printing'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Every language the same card exists in  A printing is one language, so this is what a card\'s language is changed through: pick the sibling and point the stack at it. Nothing is fetched from Scryfall for this — the catalog already holds every language of every printing, prices included (see `Printing::inherit_from_english`).  An empty list is the honest answer for a printing the catalog does not know.
     * Every language the same card exists in
     */
    async getPrintingLanguagesRaw(requestParameters: GetPrintingLanguagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrintingLanguagesResponse>> {
        const requestOptions = await this.getPrintingLanguagesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Every language the same card exists in  A printing is one language, so this is what a card\'s language is changed through: pick the sibling and point the stack at it. Nothing is fetched from Scryfall for this — the catalog already holds every language of every printing, prices included (see `Printing::inherit_from_english`).  An empty list is the honest answer for a printing the catalog does not know.
     * Every language the same card exists in
     */
    async getPrintingLanguages(requestParameters: GetPrintingLanguagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrintingLanguagesResponse> {
        const response = await this.getPrintingLanguagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPublicCollection without sending the request
     */
    async getPublicCollectionRequestOpts(requestParameters: GetPublicCollectionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling getPublicCollection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/explore/collections/{collection}`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch one collection its owner put on show
     * Fetch one collection its owner put on show
     */
    async getPublicCollectionRaw(requestParameters: GetPublicCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicCollectionResponse>> {
        const requestOptions = await this.getPublicCollectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch one collection its owner put on show
     * Fetch one collection its owner put on show
     */
    async getPublicCollection(requestParameters: GetPublicCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicCollectionResponse> {
        const response = await this.getPublicCollectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPublicCollectionStatistics without sending the request
     */
    async getPublicCollectionStatisticsRequestOpts(requestParameters: GetPublicCollectionStatisticsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling getPublicCollectionStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/explore/collections/{collection}/statistics`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Count a public collection\'s statistics  Minus the purchase figures, see [`redact_statistics`].
     * Count a public collection\'s statistics
     */
    async getPublicCollectionStatisticsRaw(requestParameters: GetPublicCollectionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CollectionStatisticsResponse>> {
        const requestOptions = await this.getPublicCollectionStatisticsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Count a public collection\'s statistics  Minus the purchase figures, see [`redact_statistics`].
     * Count a public collection\'s statistics
     */
    async getPublicCollectionStatistics(requestParameters: GetPublicCollectionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CollectionStatisticsResponse> {
        const response = await this.getPublicCollectionStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPublicDeck without sending the request
     */
    async getPublicDeckRequestOpts(requestParameters: GetPublicDeckRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling getPublicDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/explore/decks/{deck}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch one deck its owner put on show
     * Fetch one deck its owner put on show
     */
    async getPublicDeckRaw(requestParameters: GetPublicDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicDeckResponse>> {
        const requestOptions = await this.getPublicDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch one deck its owner put on show
     * Fetch one deck its owner put on show
     */
    async getPublicDeck(requestParameters: GetPublicDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicDeckResponse> {
        const response = await this.getPublicDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPublicProfile without sending the request
     */
    async getPublicProfileRequestOpts(requestParameters: GetPublicProfileRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError(
                'username',
                'Required parameter "username" was null or undefined when calling getPublicProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/explore/profiles/{username}`;
        urlPath = urlPath.replace('{username}', encodeURIComponent(String(requestParameters['username'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch an account\'s public profile: what it put on show
     * Fetch an account\'s public profile: what it put on show
     */
    async getPublicProfileRaw(requestParameters: GetPublicProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicProfileResponse>> {
        const requestOptions = await this.getPublicProfileRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch an account\'s public profile: what it put on show
     * Fetch an account\'s public profile: what it put on show
     */
    async getPublicProfile(requestParameters: GetPublicProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicProfileResponse> {
        const response = await this.getPublicProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPushSettings without sending the request
     */
    async getPushSettingsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/accounts/me/push`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The logged-in account\'s push settings and the key its devices subscribe with
     * The logged-in account\'s push settings and the key its devices subscribe with
     */
    async getPushSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PushSettingsResponse>> {
        const requestOptions = await this.getPushSettingsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The logged-in account\'s push settings and the key its devices subscribe with
     * The logged-in account\'s push settings and the key its devices subscribe with
     */
    async getPushSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PushSettingsResponse> {
        const response = await this.getPushSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getScannerSession without sending the request
     */
    async getScannerSessionRequestOpts(requestParameters: GetScannerSessionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['session'] == null) {
            throw new runtime.RequiredError(
                'session',
                'Required parameter "session" was null or undefined when calling getScannerSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/scanner-sessions/{session}`;
        urlPath = urlPath.replace('{session}', encodeURIComponent(String(requestParameters['session'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Read one session from any signed-in device
     * Read one session from any signed-in device
     */
    async getScannerSessionRaw(requestParameters: GetScannerSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScannerSessionDetailResponse>> {
        const requestOptions = await this.getScannerSessionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Read one session from any signed-in device
     * Read one session from any signed-in device
     */
    async getScannerSession(requestParameters: GetScannerSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScannerSessionDetailResponse> {
        const response = await this.getScannerSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSharedCollection without sending the request
     */
    async getSharedCollectionRequestOpts(requestParameters: GetSharedCollectionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getSharedCollection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shared/collections/{token}`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch the collection a share link points at
     * Fetch the collection a share link points at
     */
    async getSharedCollectionRaw(requestParameters: GetSharedCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedCollectionResponse>> {
        const requestOptions = await this.getSharedCollectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch the collection a share link points at
     * Fetch the collection a share link points at
     */
    async getSharedCollection(requestParameters: GetSharedCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedCollectionResponse> {
        const response = await this.getSharedCollectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSharedCollectionStatistics without sending the request
     */
    async getSharedCollectionStatisticsRequestOpts(requestParameters: GetSharedCollectionStatisticsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getSharedCollectionStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shared/collections/{token}/statistics`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Count a shared collection\'s statistics  Minus the purchase figures, see [`redact_statistics`].
     * Count a shared collection\'s statistics
     */
    async getSharedCollectionStatisticsRaw(requestParameters: GetSharedCollectionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CollectionStatisticsResponse>> {
        const requestOptions = await this.getSharedCollectionStatisticsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Count a shared collection\'s statistics  Minus the purchase figures, see [`redact_statistics`].
     * Count a shared collection\'s statistics
     */
    async getSharedCollectionStatistics(requestParameters: GetSharedCollectionStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CollectionStatisticsResponse> {
        const response = await this.getSharedCollectionStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSharedDeck without sending the request
     */
    async getSharedDeckRequestOpts(requestParameters: GetSharedDeckRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getSharedDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shared/decks/{token}`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch the deck a share link points at
     * Fetch the deck a share link points at
     */
    async getSharedDeckRaw(requestParameters: GetSharedDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedDeckResponse>> {
        const requestOptions = await this.getSharedDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch the deck a share link points at
     * Fetch the deck a share link points at
     */
    async getSharedDeck(requestParameters: GetSharedDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedDeckResponse> {
        const response = await this.getSharedDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSharedTournament without sending the request
     */
    async getSharedTournamentRequestOpts(requestParameters: GetSharedTournamentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getSharedTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shared/tournaments/{token}`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch the Tournament a share link points at  As anybody without a part in running it sees it: the link is the authorization, not the reader, so even an Organizer gets no share link back.
     * Fetch the Tournament a share link points at
     */
    async getSharedTournamentRaw(requestParameters: GetSharedTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentResponse>> {
        const requestOptions = await this.getSharedTournamentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch the Tournament a share link points at  As anybody without a part in running it sees it: the link is the authorization, not the reader, so even an Organizer gets no share link back.
     * Fetch the Tournament a share link points at
     */
    async getSharedTournament(requestParameters: GetSharedTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentResponse> {
        const response = await this.getSharedTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSharedTournamentStandings without sending the request
     */
    async getSharedTournamentStandingsRequestOpts(requestParameters: GetSharedTournamentStandingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getSharedTournamentStandings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shared/tournaments/{token}/standings`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The standings of the Tournament a share link points at
     * The standings of the Tournament a share link points at
     */
    async getSharedTournamentStandingsRaw(requestParameters: GetSharedTournamentStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StandingsResponse>> {
        const requestOptions = await this.getSharedTournamentStandingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The standings of the Tournament a share link points at
     * The standings of the Tournament a share link points at
     */
    async getSharedTournamentStandings(requestParameters: GetSharedTournamentStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StandingsResponse> {
        const response = await this.getSharedTournamentStandingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTournament without sending the request
     */
    async getTournamentRequestOpts(requestParameters: GetTournamentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling getTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch a Tournament by its id  Anybody gets a public one; its Organizers get it whatever its Visibility. An unlisted one is read through its share link, see `get_shared_tournament`.
     * Fetch a Tournament by its id
     */
    async getTournamentRaw(requestParameters: GetTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentResponse>> {
        const requestOptions = await this.getTournamentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch a Tournament by its id  Anybody gets a public one; its Organizers get it whatever its Visibility. An unlisted one is read through its share link, see `get_shared_tournament`.
     * Fetch a Tournament by its id
     */
    async getTournament(requestParameters: GetTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentResponse> {
        const response = await this.getTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTournamentHandovers without sending the request
     */
    async getTournamentHandoversRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/handovers`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The Tournaments offered to the logged-in Account to take over, latest start first
     * The Tournaments offered to the logged-in Account to take over, latest start first
     */
    async getTournamentHandoversRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTournamentsResponse>> {
        const requestOptions = await this.getTournamentHandoversRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The Tournaments offered to the logged-in Account to take over, latest start first
     * The Tournaments offered to the logged-in Account to take over, latest start first
     */
    async getTournamentHandovers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTournamentsResponse> {
        const response = await this.getTournamentHandoversRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTournamentMatchPlay without sending the request
     */
    async getTournamentMatchPlayRequestOpts(requestParameters: GetTournamentMatchPlayRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling getTournamentMatchPlay().'
            );
        }

        if (requestParameters['match'] == null) {
            throw new runtime.RequiredError(
                'match',
                'Required parameter "match" was null or undefined when calling getTournamentMatchPlay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/matches/{match}/play`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{match}', encodeURIComponent(String(requestParameters['match'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Opens a Match for its Participants or Organizers without recording or submitting any Result.
     * Opens a Match for its Participants or Organizers without recording or submitting any Result.
     */
    async getTournamentMatchPlayRaw(requestParameters: GetTournamentMatchPlayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchPlayResponse>> {
        const requestOptions = await this.getTournamentMatchPlayRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Opens a Match for its Participants or Organizers without recording or submitting any Result.
     * Opens a Match for its Participants or Organizers without recording or submitting any Result.
     */
    async getTournamentMatchPlay(requestParameters: GetTournamentMatchPlayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchPlayResponse> {
        const response = await this.getTournamentMatchPlayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTournamentStandings without sending the request
     */
    async getTournamentStandingsRequestOpts(requestParameters: GetTournamentStandingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling getTournamentStandings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/standings`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The standings of a Tournament: Match points from every Result so far
     * The standings of a Tournament: Match points from every Result so far
     */
    async getTournamentStandingsRaw(requestParameters: GetTournamentStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StandingsResponse>> {
        const requestOptions = await this.getTournamentStandingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The standings of a Tournament: Match points from every Result so far
     * The standings of a Tournament: Match points from every Result so far
     */
    async getTournamentStandings(requestParameters: GetTournamentStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StandingsResponse> {
        const response = await this.getTournamentStandingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getWatchList without sending the request
     */
    async getWatchListRequestOpts(requestParameters: GetWatchListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['list'] == null) {
            throw new runtime.RequiredError(
                'list',
                'Required parameter "list" was null or undefined when calling getWatchList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/watch-lists/{list}`;
        urlPath = urlPath.replace('{list}', encodeURIComponent(String(requestParameters['list'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * One watch list, without what is on it
     * One watch list, without what is on it
     */
    async getWatchListRaw(requestParameters: GetWatchListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WatchListResponse>> {
        const requestOptions = await this.getWatchListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * One watch list, without what is on it
     * One watch list, without what is on it
     */
    async getWatchList(requestParameters: GetWatchListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WatchListResponse> {
        const response = await this.getWatchListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getWatchListAlarms without sending the request
     */
    async getWatchListAlarmsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/watch-lists/alarms`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Every alarm standing across the account\'s watch lists  What the navigation badge is drawn from, which is why it is reachable without naming a list: the point of an alarm is to be seen from wherever the reader happens to be.
     * Every alarm standing across the account\'s watch lists
     */
    async getWatchListAlarmsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWatchListAlarmsResponse>> {
        const requestOptions = await this.getWatchListAlarmsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Every alarm standing across the account\'s watch lists  What the navigation badge is drawn from, which is why it is reachable without naming a list: the point of an alarm is to be seen from wherever the reader happens to be.
     * Every alarm standing across the account\'s watch lists
     */
    async getWatchListAlarms(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWatchListAlarmsResponse> {
        const response = await this.getWatchListAlarmsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for importDeckCards without sending the request
     */
    async importDeckCardsRequestOpts(requestParameters: ImportDeckCardsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling importDeckCards().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/cards/import`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ImportDeckCardsRequest'],
        };
    }

    /**
     * Write a whole decklist into a deck  One transaction for the lot: a pasted list either lands or it does not.
     * Write a whole decklist into a deck
     */
    async importDeckCardsRaw(requestParameters: ImportDeckCardsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportDeckCardsResponse>> {
        const requestOptions = await this.importDeckCardsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Write a whole decklist into a deck  One transaction for the lot: a pasted list either lands or it does not.
     * Write a whole decklist into a deck
     */
    async importDeckCards(requestParameters: ImportDeckCardsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportDeckCardsResponse> {
        const response = await this.importDeckCardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for leaveDeck without sending the request
     */
    async leaveDeckRequestOpts(requestParameters: LeaveDeckRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling leaveDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/leave`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Take oneself off a deck another Account named one on  The deck leaves \"Shared with me\" and its access ends with the next request. Its owner cannot leave it.
     * Take oneself off a deck another Account named one on
     */
    async leaveDeckRaw(requestParameters: LeaveDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.leaveDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Take oneself off a deck another Account named one on  The deck leaves \"Shared with me\" and its access ends with the next request. Its owner cannot leave it.
     * Take oneself off a deck another Account named one on
     */
    async leaveDeck(requestParameters: LeaveDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.leaveDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listCollectionCards without sending the request
     */
    async listCollectionCardsRequestOpts(requestParameters: ListCollectionCardsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling listCollectionCards().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }

        if (requestParameters['condition'] != null) {
            queryParameters['condition'] = requestParameters['condition'];
        }

        if (requestParameters['descending'] != null) {
            queryParameters['descending'] = requestParameters['descending'];
        }

        if (requestParameters['finish'] != null) {
            queryParameters['finish'] = requestParameters['finish'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['printing'] != null) {
            queryParameters['printing'] = requestParameters['printing'];
        }

        if (requestParameters['rarity'] != null) {
            queryParameters['rarity'] = requestParameters['rarity'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/collections/{collection}/cards`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List a page of a collection\'s cards, sorted and filtered  The endpoint the card list is meant to be read through. Everything comes out of one query joined against the catalog, so a page costs one request and the client resolves nothing against Scryfall.
     * List a page of a collection\'s cards, sorted and filtered
     */
    async listCollectionCardsRaw(requestParameters: ListCollectionCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCardsResponse>> {
        const requestOptions = await this.listCollectionCardsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List a page of a collection\'s cards, sorted and filtered  The endpoint the card list is meant to be read through. Everything comes out of one query joined against the catalog, so a page costs one request and the client resolves nothing against Scryfall.
     * List a page of a collection\'s cards, sorted and filtered
     */
    async listCollectionCards(requestParameters: ListCollectionCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCardsResponse> {
        const response = await this.listCollectionCardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listCollectionEntries without sending the request
     */
    async listCollectionEntriesRequestOpts(requestParameters: ListCollectionEntriesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling listCollectionEntries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/collections/{collection}/entries`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List every stack filed in a collection  Superseded by [`list_collection_cards`], which pages and carries the card data with it. Kept while the import dialog still reads the whole collection to work out what it would be topping up.
     * List every stack filed in a collection
     */
    async listCollectionEntriesRaw(requestParameters: ListCollectionEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCollectionEntriesResponse>> {
        const requestOptions = await this.listCollectionEntriesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List every stack filed in a collection  Superseded by [`list_collection_cards`], which pages and carries the card data with it. Kept while the import dialog still reads the whole collection to work out what it would be topping up.
     * List every stack filed in a collection
     */
    async listCollectionEntries(requestParameters: ListCollectionEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCollectionEntriesResponse> {
        const response = await this.listCollectionEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listCollectionOnLoan without sending the request
     */
    async listCollectionOnLoanRequestOpts(requestParameters: ListCollectionOnLoanRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling listCollectionOnLoan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/collections/{collection}/on-loan`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Count a collection\'s statistics  Everything the statistics tab draws, from one query joined against the catalog — the client fetches this single object instead of every entry and every card behind it. All money is euro cents, all counts are copies. What this collection has lent out to decks  Cards that moved into a deck are no longer rows of the collection, so a list of it would quietly be missing them. This is the other half of the shelf: what is out, and which deck it is in.
     * Count a collection\'s statistics
     */
    async listCollectionOnLoanRaw(requestParameters: ListCollectionOnLoanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOnLoanResponse>> {
        const requestOptions = await this.listCollectionOnLoanRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Count a collection\'s statistics  Everything the statistics tab draws, from one query joined against the catalog — the client fetches this single object instead of every entry and every card behind it. All money is euro cents, all counts are copies. What this collection has lent out to decks  Cards that moved into a deck are no longer rows of the collection, so a list of it would quietly be missing them. This is the other half of the shelf: what is out, and which deck it is in.
     * Count a collection\'s statistics
     */
    async listCollectionOnLoan(requestParameters: ListCollectionOnLoanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOnLoanResponse> {
        const response = await this.listCollectionOnLoanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listDeckCards without sending the request
     */
    async listDeckCardsRequestOpts(requestParameters: ListDeckCardsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling listDeckCards().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/cards`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Every card of a deck, with the catalog data and the tags on it  The whole deck in one answer: a hundred slots are not worth paging, and the client groups and sorts them however the list is being looked at. A Collaborator gets it the way the Share link shows it, see [`redact_slot`].
     * Every card of a deck, with the catalog data and the tags on it
     */
    async listDeckCardsRaw(requestParameters: ListDeckCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDeckCardsResponse>> {
        const requestOptions = await this.listDeckCardsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Every card of a deck, with the catalog data and the tags on it  The whole deck in one answer: a hundred slots are not worth paging, and the client groups and sorts them however the list is being looked at. A Collaborator gets it the way the Share link shows it, see [`redact_slot`].
     * Every card of a deck, with the catalog data and the tags on it
     */
    async listDeckCards(requestParameters: ListDeckCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDeckCardsResponse> {
        const response = await this.listDeckCardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listDeckCollaborators without sending the request
     */
    async listDeckCollaboratorsRequestOpts(requestParameters: ListDeckCollaboratorsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling listDeckCollaborators().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/collaborators`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The owner and the Collaborators of a deck, the latter alphabetically by username  The owner and every Collaborator read it.
     * The owner and the Collaborators of a deck, the latter alphabetically by username
     */
    async listDeckCollaboratorsRaw(requestParameters: ListDeckCollaboratorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDeckCollaboratorsResponse>> {
        const requestOptions = await this.listDeckCollaboratorsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The owner and the Collaborators of a deck, the latter alphabetically by username  The owner and every Collaborator read it.
     * The owner and the Collaborators of a deck, the latter alphabetically by username
     */
    async listDeckCollaborators(requestParameters: ListDeckCollaboratorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDeckCollaboratorsResponse> {
        const response = await this.listDeckCollaboratorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listMatchLifeConflicts without sending the request
     */
    async listMatchLifeConflictsRequestOpts(requestParameters: ListMatchLifeConflictsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling listMatchLifeConflicts().'
            );
        }

        if (requestParameters['match'] == null) {
            throw new runtime.RequiredError(
                'match',
                'Required parameter "match" was null or undefined when calling listMatchLifeConflicts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/matches/{match}/life-history/conflicts`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{match}', encodeURIComponent(String(requestParameters['match'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists recovered branches only for this Match\'s authorized audience.
     * Lists recovered branches only for this Match\'s authorized audience.
     */
    async listMatchLifeConflictsRaw(requestParameters: ListMatchLifeConflictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchLifeConflicts>> {
        const requestOptions = await this.listMatchLifeConflictsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Lists recovered branches only for this Match\'s authorized audience.
     * Lists recovered branches only for this Match\'s authorized audience.
     */
    async listMatchLifeConflicts(requestParameters: ListMatchLifeConflictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchLifeConflicts> {
        const response = await this.listMatchLifeConflictsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listOpenidProviders without sending the request
     */
    async listOpenidProvidersRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/auth/oidc/providers`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List the OpenID providers people may log in through  Empty while no provider is configured; the frontend then shows no button.
     * List the OpenID providers people may log in through
     */
    async listOpenidProvidersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOpenIdProvidersResponse>> {
        const requestOptions = await this.listOpenidProvidersRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List the OpenID providers people may log in through  Empty while no provider is configured; the frontend then shows no button.
     * List the OpenID providers people may log in through
     */
    async listOpenidProviders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOpenIdProvidersResponse> {
        const response = await this.listOpenidProvidersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listPasskeys without sending the request
     */
    async listPasskeysRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/accounts/passkeys`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List the passkeys of the logged-in account
     * List the passkeys of the logged-in account
     */
    async listPasskeysRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPasskeysResponse>> {
        const requestOptions = await this.listPasskeysRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List the passkeys of the logged-in account
     * List the passkeys of the logged-in account
     */
    async listPasskeys(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPasskeysResponse> {
        const response = await this.listPasskeysRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listPublicCollectionCards without sending the request
     */
    async listPublicCollectionCardsRequestOpts(requestParameters: ListPublicCollectionCardsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling listPublicCollectionCards().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }

        if (requestParameters['condition'] != null) {
            queryParameters['condition'] = requestParameters['condition'];
        }

        if (requestParameters['descending'] != null) {
            queryParameters['descending'] = requestParameters['descending'];
        }

        if (requestParameters['finish'] != null) {
            queryParameters['finish'] = requestParameters['finish'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['printing'] != null) {
            queryParameters['printing'] = requestParameters['printing'];
        }

        if (requestParameters['rarity'] != null) {
            queryParameters['rarity'] = requestParameters['rarity'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/explore/collections/{collection}/cards`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List a page of a public collection\'s cards, sorted and filtered  The listing the owner reads, minus what was paid, see [`redact_entry`].
     * List a page of a public collection\'s cards, sorted and filtered
     */
    async listPublicCollectionCardsRaw(requestParameters: ListPublicCollectionCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCardsResponse>> {
        const requestOptions = await this.listPublicCollectionCardsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List a page of a public collection\'s cards, sorted and filtered  The listing the owner reads, minus what was paid, see [`redact_entry`].
     * List a page of a public collection\'s cards, sorted and filtered
     */
    async listPublicCollectionCards(requestParameters: ListPublicCollectionCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCardsResponse> {
        const response = await this.listPublicCollectionCardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listPublicDeckCards without sending the request
     */
    async listPublicDeckCardsRequestOpts(requestParameters: ListPublicDeckCardsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling listPublicDeckCards().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/explore/decks/{deck}/cards`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Every card of a public deck, with the catalog data and the tags on it  The listing the owner reads, minus the proxy flags, see [`redact_slot`].
     * Every card of a public deck, with the catalog data and the tags on it
     */
    async listPublicDeckCardsRaw(requestParameters: ListPublicDeckCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDeckCardsResponse>> {
        const requestOptions = await this.listPublicDeckCardsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Every card of a public deck, with the catalog data and the tags on it  The listing the owner reads, minus the proxy flags, see [`redact_slot`].
     * Every card of a public deck, with the catalog data and the tags on it
     */
    async listPublicDeckCards(requestParameters: ListPublicDeckCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDeckCardsResponse> {
        const response = await this.listPublicDeckCardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listPublicTournaments without sending the request
     */
    async listPublicTournamentsRequestOpts(requestParameters: ListPublicTournamentsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['format'] != null) {
            queryParameters['format'] = requestParameters['format'];
        }

        if (requestParameters['location'] != null) {
            queryParameters['location'] = requestParameters['location'];
        }

        if (requestParameters['timeframe'] != null) {
            queryParameters['timeframe'] = requestParameters['timeframe'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The public Tournaments, narrowed down by the filters given  Upcoming ones come soonest first, past and unfiltered ones latest first.
     * The public Tournaments, narrowed down by the filters given
     */
    async listPublicTournamentsRaw(requestParameters: ListPublicTournamentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTournamentsResponse>> {
        const requestOptions = await this.listPublicTournamentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The public Tournaments, narrowed down by the filters given  Upcoming ones come soonest first, past and unfiltered ones latest first.
     * The public Tournaments, narrowed down by the filters given
     */
    async listPublicTournaments(requestParameters: ListPublicTournamentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTournamentsResponse> {
        const response = await this.listPublicTournamentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listSharedCollectionCards without sending the request
     */
    async listSharedCollectionCardsRequestOpts(requestParameters: ListSharedCollectionCardsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling listSharedCollectionCards().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['after'] != null) {
            queryParameters['after'] = requestParameters['after'];
        }

        if (requestParameters['condition'] != null) {
            queryParameters['condition'] = requestParameters['condition'];
        }

        if (requestParameters['descending'] != null) {
            queryParameters['descending'] = requestParameters['descending'];
        }

        if (requestParameters['finish'] != null) {
            queryParameters['finish'] = requestParameters['finish'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['printing'] != null) {
            queryParameters['printing'] = requestParameters['printing'];
        }

        if (requestParameters['rarity'] != null) {
            queryParameters['rarity'] = requestParameters['rarity'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shared/collections/{token}/cards`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List a page of a shared collection\'s cards, sorted and filtered  The listing the owner reads, minus what was paid, see [`redact_entry`].
     * List a page of a shared collection\'s cards, sorted and filtered
     */
    async listSharedCollectionCardsRaw(requestParameters: ListSharedCollectionCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCardsResponse>> {
        const requestOptions = await this.listSharedCollectionCardsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List a page of a shared collection\'s cards, sorted and filtered  The listing the owner reads, minus what was paid, see [`redact_entry`].
     * List a page of a shared collection\'s cards, sorted and filtered
     */
    async listSharedCollectionCards(requestParameters: ListSharedCollectionCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCardsResponse> {
        const response = await this.listSharedCollectionCardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listSharedDeckCards without sending the request
     */
    async listSharedDeckCardsRequestOpts(requestParameters: ListSharedDeckCardsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling listSharedDeckCards().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shared/decks/{token}/cards`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Every card of a shared deck, with the catalog data and the tags on it  The listing the owner reads, minus the proxy flags, see [`redact_slot`].
     * Every card of a shared deck, with the catalog data and the tags on it
     */
    async listSharedDeckCardsRaw(requestParameters: ListSharedDeckCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDeckCardsResponse>> {
        const requestOptions = await this.listSharedDeckCardsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Every card of a shared deck, with the catalog data and the tags on it  The listing the owner reads, minus the proxy flags, see [`redact_slot`].
     * Every card of a shared deck, with the catalog data and the tags on it
     */
    async listSharedDeckCards(requestParameters: ListSharedDeckCardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDeckCardsResponse> {
        const response = await this.listSharedDeckCardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listSharedTournamentParticipants without sending the request
     */
    async listSharedTournamentParticipantsRequestOpts(requestParameters: ListSharedTournamentParticipantsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling listSharedTournamentParticipants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shared/tournaments/{token}/participants`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The Participants of the Tournament a share link points at  Says which of them is the reader, if any.
     * The Participants of the Tournament a share link points at
     */
    async listSharedTournamentParticipantsRaw(requestParameters: ListSharedTournamentParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListParticipantsResponse>> {
        const requestOptions = await this.listSharedTournamentParticipantsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The Participants of the Tournament a share link points at  Says which of them is the reader, if any.
     * The Participants of the Tournament a share link points at
     */
    async listSharedTournamentParticipants(requestParameters: ListSharedTournamentParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListParticipantsResponse> {
        const response = await this.listSharedTournamentParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listSharedTournamentRegisteredLists without sending the request
     */
    async listSharedTournamentRegisteredListsRequestOpts(requestParameters: ListSharedTournamentRegisteredListsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling listSharedTournamentRegisteredLists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shared/tournaments/{token}/registered-lists`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The shared lists of the Tournament a share link points at, once it is Finished  None before; a link never reads as an Organizer.
     * The shared lists of the Tournament a share link points at, once it is Finished
     */
    async listSharedTournamentRegisteredListsRaw(requestParameters: ListSharedTournamentRegisteredListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisteredListsResponse>> {
        const requestOptions = await this.listSharedTournamentRegisteredListsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The shared lists of the Tournament a share link points at, once it is Finished  None before; a link never reads as an Organizer.
     * The shared lists of the Tournament a share link points at, once it is Finished
     */
    async listSharedTournamentRegisteredLists(requestParameters: ListSharedTournamentRegisteredListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisteredListsResponse> {
        const response = await this.listSharedTournamentRegisteredListsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listSharedTournamentRounds without sending the request
     */
    async listSharedTournamentRoundsRequestOpts(requestParameters: ListSharedTournamentRoundsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling listSharedTournamentRounds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shared/tournaments/{token}/rounds`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The Rounds of the Tournament a share link points at  Never a previewed one: the link shows what anybody sees.
     * The Rounds of the Tournament a share link points at
     */
    async listSharedTournamentRoundsRaw(requestParameters: ListSharedTournamentRoundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoundsResponse>> {
        const requestOptions = await this.listSharedTournamentRoundsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The Rounds of the Tournament a share link points at  Never a previewed one: the link shows what anybody sees.
     * The Rounds of the Tournament a share link points at
     */
    async listSharedTournamentRounds(requestParameters: ListSharedTournamentRoundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoundsResponse> {
        const response = await this.listSharedTournamentRoundsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listTournamentOrganizers without sending the request
     */
    async listTournamentOrganizersRequestOpts(requestParameters: ListTournamentOrganizersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling listTournamentOrganizers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/organizers`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Who runs a Tournament, and whom its Owner offered it to  Every Organizer reads it.
     * Who runs a Tournament, and whom its Owner offered it to
     */
    async listTournamentOrganizersRaw(requestParameters: ListTournamentOrganizersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOrganizersResponse>> {
        const requestOptions = await this.listTournamentOrganizersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Who runs a Tournament, and whom its Owner offered it to  Every Organizer reads it.
     * Who runs a Tournament, and whom its Owner offered it to
     */
    async listTournamentOrganizers(requestParameters: ListTournamentOrganizersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOrganizersResponse> {
        const response = await this.listTournamentOrganizersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listTournamentParticipantDecks without sending the request
     */
    async listTournamentParticipantDecksRequestOpts(requestParameters: ListTournamentParticipantDecksRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling listTournamentParticipantDecks().'
            );
        }

        if (requestParameters['participant'] == null) {
            throw new runtime.RequiredError(
                'participant',
                'Required parameter "participant" was null or undefined when calling listTournamentParticipantDecks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/participants/{participant}/decks`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{participant}', encodeURIComponent(String(requestParameters['participant'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The decks a Participant\'s Account owns, as an Organizer about to register one  Private decks are left out: an Organizer registers none of them.
     * The decks a Participant\'s Account owns, as an Organizer about to register one
     */
    async listTournamentParticipantDecksRaw(requestParameters: ListTournamentParticipantDecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListParticipantDecksResponse>> {
        const requestOptions = await this.listTournamentParticipantDecksRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The decks a Participant\'s Account owns, as an Organizer about to register one  Private decks are left out: an Organizer registers none of them.
     * The decks a Participant\'s Account owns, as an Organizer about to register one
     */
    async listTournamentParticipantDecks(requestParameters: ListTournamentParticipantDecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListParticipantDecksResponse> {
        const response = await this.listTournamentParticipantDecksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listTournamentParticipants without sending the request
     */
    async listTournamentParticipantsRequestOpts(requestParameters: ListTournamentParticipantsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling listTournamentParticipants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/participants`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The Participants of a Tournament the reader may see  Says which of them is the reader, if any.
     * The Participants of a Tournament the reader may see
     */
    async listTournamentParticipantsRaw(requestParameters: ListTournamentParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListParticipantsResponse>> {
        const requestOptions = await this.listTournamentParticipantsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The Participants of a Tournament the reader may see  Says which of them is the reader, if any.
     * The Participants of a Tournament the reader may see
     */
    async listTournamentParticipants(requestParameters: ListTournamentParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListParticipantsResponse> {
        const response = await this.listTournamentParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listTournamentRegisteredDecks without sending the request
     */
    async listTournamentRegisteredDecksRequestOpts(requestParameters: ListTournamentRegisteredDecksRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling listTournamentRegisteredDecks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/registered-decks`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Every Registered deck of a Tournament, as an Organizer
     * Every Registered deck of a Tournament, as an Organizer
     */
    async listTournamentRegisteredDecksRaw(requestParameters: ListTournamentRegisteredDecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListRegisteredDecksResponse>> {
        const requestOptions = await this.listTournamentRegisteredDecksRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Every Registered deck of a Tournament, as an Organizer
     * Every Registered deck of a Tournament, as an Organizer
     */
    async listTournamentRegisteredDecks(requestParameters: ListTournamentRegisteredDecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListRegisteredDecksResponse> {
        const response = await this.listTournamentRegisteredDecksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listTournamentRegisteredLists without sending the request
     */
    async listTournamentRegisteredListsRequestOpts(requestParameters: ListTournamentRegisteredListsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling listTournamentRegisteredLists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/registered-lists`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The Registered decks\' lists the reader may see  Organizers read every list at any time, to check them against the format. Everybody else reads none before the Tournament is Finished and the shared ones afterwards, also once their deck was deleted.
     * The Registered decks\' lists the reader may see
     */
    async listTournamentRegisteredListsRaw(requestParameters: ListTournamentRegisteredListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisteredListsResponse>> {
        const requestOptions = await this.listTournamentRegisteredListsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The Registered decks\' lists the reader may see  Organizers read every list at any time, to check them against the format. Everybody else reads none before the Tournament is Finished and the shared ones afterwards, also once their deck was deleted.
     * The Registered decks\' lists the reader may see
     */
    async listTournamentRegisteredLists(requestParameters: ListTournamentRegisteredListsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisteredListsResponse> {
        const response = await this.listTournamentRegisteredListsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listTournamentRounds without sending the request
     */
    async listTournamentRoundsRequestOpts(requestParameters: ListTournamentRoundsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling listTournamentRounds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/rounds`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The Rounds of a Tournament the reader may see  A previewed Round only shows to the Tournament\'s Organizers.
     * The Rounds of a Tournament the reader may see
     */
    async listTournamentRoundsRaw(requestParameters: ListTournamentRoundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoundsResponse>> {
        const requestOptions = await this.listTournamentRoundsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The Rounds of a Tournament the reader may see  A previewed Round only shows to the Tournament\'s Organizers.
     * The Rounds of a Tournament the reader may see
     */
    async listTournamentRounds(requestParameters: ListTournamentRoundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoundsResponse> {
        const response = await this.listTournamentRoundsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listWatchListCopies without sending the request
     */
    async listWatchListCopiesRequestOpts(requestParameters: ListWatchListCopiesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['list'] == null) {
            throw new runtime.RequiredError(
                'list',
                'Required parameter "list" was null or undefined when calling listWatchListCopies().'
            );
        }

        if (requestParameters['entry'] == null) {
            throw new runtime.RequiredError(
                'entry',
                'Required parameter "entry" was null or undefined when calling listWatchListCopies().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/watch-lists/{list}/entries/{entry}/copies`;
        urlPath = urlPath.replace('{list}', encodeURIComponent(String(requestParameters['list'])));
        urlPath = urlPath.replace('{entry}', encodeURIComponent(String(requestParameters['entry'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Where the copies of one watched card are  Fetched when a row is opened rather than with the list: most rows are never opened, and a shelf of full collections is a lot of stacks to send along on the chance that one of them is.
     * Where the copies of one watched card are
     */
    async listWatchListCopiesRaw(requestParameters: ListWatchListCopiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWatchListCopiesResponse>> {
        const requestOptions = await this.listWatchListCopiesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Where the copies of one watched card are  Fetched when a row is opened rather than with the list: most rows are never opened, and a shelf of full collections is a lot of stacks to send along on the chance that one of them is.
     * Where the copies of one watched card are
     */
    async listWatchListCopies(requestParameters: ListWatchListCopiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWatchListCopiesResponse> {
        const response = await this.listWatchListCopiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listWatchListEntries without sending the request
     */
    async listWatchListEntriesRequestOpts(requestParameters: ListWatchListEntriesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['list'] == null) {
            throw new runtime.RequiredError(
                'list',
                'Required parameter "list" was null or undefined when calling listWatchListEntries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/watch-lists/{list}/entries`;
        urlPath = urlPath.replace('{list}', encodeURIComponent(String(requestParameters['list'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Everything one watch list page is drawn from  The catalog data, the stock counts and the alarm state in one request: the counting follows each entry\'s own switches, so it is the database that does it and the client is handed numbers rather than the whole shelf.
     * Everything one watch list page is drawn from
     */
    async listWatchListEntriesRaw(requestParameters: ListWatchListEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWatchListEntriesResponse>> {
        const requestOptions = await this.listWatchListEntriesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Everything one watch list page is drawn from  The catalog data, the stock counts and the alarm state in one request: the counting follows each entry\'s own switches, so it is the database that does it and the client is handed numbers rather than the whole shelf.
     * Everything one watch list page is drawn from
     */
    async listWatchListEntries(requestParameters: ListWatchListEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWatchListEntriesResponse> {
        const response = await this.listWatchListEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for logout without sending the request
     */
    async logoutRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/auth/logout`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Log out, dropping the session
     * Log out, dropping the session
     */
    async logoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.logoutRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Log out, dropping the session
     * Log out, dropping the session
     */
    async logout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.logoutRaw(initOverrides);
    }

    /**
     * Creates request options for me without sending the request
     */
    async meRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/accounts/me`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * The account the current session belongs to  The one route a locked Account\'s session still reaches: it answers with the `locked` flag, never the Lock reason, and logs the session out.
     * The account the current session belongs to
     */
    async meRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Me200Response>> {
        const requestOptions = await this.meRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The account the current session belongs to  The one route a locked Account\'s session still reaches: it answers with the `locked` flag, never the Lock reason, and logs the session out.
     * The account the current session belongs to
     */
    async me(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Me200Response> {
        const response = await this.meRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mergeCollectionEntries without sending the request
     */
    async mergeCollectionEntriesRequestOpts(requestParameters: MergeCollectionEntriesOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling mergeCollectionEntries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/collections/{collection}/entries/merge`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['MergeCollectionEntriesRequest'],
        };
    }

    /**
     * Combine stacks of the same cards into one  The oldest of them survives and takes over the copies, the averaged purchase price and the earliest acquisition date.
     * Combine stacks of the same cards into one
     */
    async mergeCollectionEntriesRaw(requestParameters: MergeCollectionEntriesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CollectionEntryResponse>> {
        const requestOptions = await this.mergeCollectionEntriesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Combine stacks of the same cards into one  The oldest of them survives and takes over the copies, the averaged purchase price and the earliest acquisition date.
     * Combine stacks of the same cards into one
     */
    async mergeCollectionEntries(requestParameters: MergeCollectionEntriesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CollectionEntryResponse> {
        const response = await this.mergeCollectionEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for offerTournamentHandover without sending the request
     */
    async offerTournamentHandoverRequestOpts(requestParameters: OfferTournamentHandoverRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling offerTournamentHandover().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/handover`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['NameAccountRequest'],
        };
    }

    /**
     * Offer a Tournament to an Account by its username, as its Owner  Replaces a pending offer. Nothing changes until the Account accepts. Unknown usernames are capped per caller, see [`unknown_username`].
     * Offer a Tournament to an Account by its username, as its Owner
     */
    async offerTournamentHandoverRaw(requestParameters: OfferTournamentHandoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfferTournamentHandover200Response>> {
        const requestOptions = await this.offerTournamentHandoverRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Offer a Tournament to an Account by its username, as its Owner  Replaces a pending offer. Nothing changes until the Account accepts. Unknown usernames are capped per caller, see [`unknown_username`].
     * Offer a Tournament to an Account by its username, as its Owner
     */
    async offerTournamentHandover(requestParameters: OfferTournamentHandoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfferTournamentHandover200Response> {
        const response = await this.offerTournamentHandoverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for pairTournamentRound without sending the request
     */
    async pairTournamentRoundRequestOpts(requestParameters: PairTournamentRoundRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling pairTournamentRound().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/rounds`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Pair the next Round as a preview, as an Organizer  Round 1 is paired at random, later Rounds by Match points without rematches. Only Organizers see the preview until it starts. Refused while another Round is previewed or running and once every Swiss Round was paired.
     * Pair the next Round as a preview, as an Organizer
     */
    async pairTournamentRoundRaw(requestParameters: PairTournamentRoundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PairTournamentRound200Response>> {
        const requestOptions = await this.pairTournamentRoundRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Pair the next Round as a preview, as an Organizer  Round 1 is paired at random, later Rounds by Match points without rematches. Only Organizers see the preview until it starts. Refused while another Round is previewed or running and once every Swiss Round was paired.
     * Pair the next Round as a preview, as an Organizer
     */
    async pairTournamentRound(requestParameters: PairTournamentRoundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PairTournamentRound200Response> {
        const response = await this.pairTournamentRoundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for putDeckCollaborator without sending the request
     */
    async putDeckCollaboratorRequestOpts(requestParameters: PutDeckCollaboratorOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling putDeckCollaborator().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/collaborators`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['PutDeckCollaboratorRequest'],
        };
    }

    /**
     * Name an Account on a deck by its username, or change the level it is named at  Naming an Account that is already on the deck changes its level, so it is on the deck once. The owner and the Tombstone cannot be named.  Unknown usernames are capped per caller, see [`UNKNOWN_USERNAMES`].
     * Name an Account on a deck by its username, or change the level it is named at
     */
    async putDeckCollaboratorRaw(requestParameters: PutDeckCollaboratorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PutDeckCollaborator200Response>> {
        const requestOptions = await this.putDeckCollaboratorRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Name an Account on a deck by its username, or change the level it is named at  Naming an Account that is already on the deck changes its level, so it is on the deck once. The owner and the Tombstone cannot be named.  Unknown usernames are capped per caller, see [`UNKNOWN_USERNAMES`].
     * Name an Account on a deck by its username, or change the level it is named at
     */
    async putDeckCollaborator(requestParameters: PutDeckCollaboratorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PutDeckCollaborator200Response> {
        const response = await this.putDeckCollaboratorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for readDeckUrl without sending the request
     */
    async readDeckUrlRequestOpts(requestParameters: ReadDeckUrlOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/import/url`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ReadDeckUrlRequest'],
        };
    }

    /**
     * Read a decklist off a link to another builder, or off one of our own links  Only the sites this knows are fetched, and only through a url composed here from the deck\'s id — the link is read, never followed. A link to this instance is not fetched at all: it is resolved against the database, which is what lets a deck come back with the print of every card.
     * Read a decklist off a link to another builder, or off one of our own links
     */
    async readDeckUrlRaw(requestParameters: ReadDeckUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReadDeckUrlResponse>> {
        const requestOptions = await this.readDeckUrlRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Read a decklist off a link to another builder, or off one of our own links  Only the sites this knows are fetched, and only through a url composed here from the deck\'s id — the link is read, never followed. A link to this instance is not fetched at all: it is resolved against the database, which is what lets a deck come back with the print of every card.
     * Read a decklist off a link to another builder, or off one of our own links
     */
    async readDeckUrl(requestParameters: ReadDeckUrlOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReadDeckUrlResponse> {
        const response = await this.readDeckUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for recoverAccount without sending the request
     */
    async recoverAccountRequestOpts(requestParameters: RecoverAccountOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/recover`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['RecoverAccountRequest'],
        };
    }

    /**
     * Send a fresh registration link to an account\'s stored address  The \"lost passkey\" flow: a new device has no passkey, so the login form offers this instead of a dead end. Registering over the link only *adds* a passkey — the existing ones keep working until their owner removes them.  Always answers `200`, whether or not the username exists — the response must not be usable to probe which usernames are registered. The link is only ever sent to the address stored on the account, never to one from the request, so this endpoint cannot be used to mail a third party. A locked account gets no link either, and only a Local Account gets one at all, including one not enrolled yet whose invite mail got lost; the answer is the same `200`.
     * Send a fresh registration link to an account\'s stored address
     */
    async recoverAccountRaw(requestParameters: RecoverAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.recoverAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Send a fresh registration link to an account\'s stored address  The \"lost passkey\" flow: a new device has no passkey, so the login form offers this instead of a dead end. Registering over the link only *adds* a passkey — the existing ones keep working until their owner removes them.  Always answers `200`, whether or not the username exists — the response must not be usable to probe which usernames are registered. The link is only ever sent to the address stored on the account, never to one from the request, so this endpoint cannot be used to mail a third party. A locked account gets no link either, and only a Local Account gets one at all, including one not enrolled yet whose invite mail got lost; the answer is the same `200`.
     * Send a fresh registration link to an account\'s stored address
     */
    async recoverAccount(requestParameters: RecoverAccountOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.recoverAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for redoDeckChange without sending the request
     */
    async redoDeckChangeRequestOpts(requestParameters: RedoDeckChangeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling redoDeckChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/history/redo`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Apply the latest undone Deck change again  Only the owner redoes. Refused when nothing is undone or a later Deck change discarded the undo.
     * Apply the latest undone Deck change again
     */
    async redoDeckChangeRaw(requestParameters: RedoDeckChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckUndoResponse>> {
        const requestOptions = await this.redoDeckChangeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Apply the latest undone Deck change again  Only the owner redoes. Refused when nothing is undone or a later Deck change discarded the undo.
     * Apply the latest undone Deck change again
     */
    async redoDeckChange(requestParameters: RedoDeckChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckUndoResponse> {
        const response = await this.redoDeckChangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for registerMyTournamentDeck without sending the request
     */
    async registerMyTournamentDeckRequestOpts(requestParameters: RegisterMyTournamentDeckRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling registerMyTournamentDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/deck`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['RegisterDeckRequest'],
        };
    }

    /**
     * Register one of the logged-in Account\'s decks for a Tournament it plays in, or swap the one registered  While the Tournament is in Registration, where the Registered deck follows the deck until the first Round starts; a late Participant registers its own afterwards, pinned at once, and can no longer swap it then.
     * Register one of the logged-in Account\'s decks for a Tournament it plays in,
     */
    async registerMyTournamentDeckRaw(requestParameters: RegisterMyTournamentDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForRegisterDeckErrors>> {
        const requestOptions = await this.registerMyTournamentDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Register one of the logged-in Account\'s decks for a Tournament it plays in, or swap the one registered  While the Tournament is in Registration, where the Registered deck follows the deck until the first Round starts; a late Participant registers its own afterwards, pinned at once, and can no longer swap it then.
     * Register one of the logged-in Account\'s decks for a Tournament it plays in,
     */
    async registerMyTournamentDeck(requestParameters: RegisterMyTournamentDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForRegisterDeckErrors> {
        const response = await this.registerMyTournamentDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for registerTournamentParticipantDeck without sending the request
     */
    async registerTournamentParticipantDeckRequestOpts(requestParameters: RegisterTournamentParticipantDeckRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling registerTournamentParticipantDeck().'
            );
        }

        if (requestParameters['participant'] == null) {
            throw new runtime.RequiredError(
                'participant',
                'Required parameter "participant" was null or undefined when calling registerTournamentParticipantDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/participants/{participant}/deck`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{participant}', encodeURIComponent(String(requestParameters['participant'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['RegisterDeckRequest'],
        };
    }

    /**
     * Register or swap a Participant\'s Registered deck, as an Organizer  At any time, with any of the Participant\'s decks that is not private; after the first Round started the new Registered deck is pinned at once and sets its own Deck checkpoint.
     * Register or swap a Participant\'s Registered deck, as an Organizer
     */
    async registerTournamentParticipantDeckRaw(requestParameters: RegisterTournamentParticipantDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForRegisterDeckErrors>> {
        const requestOptions = await this.registerTournamentParticipantDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Register or swap a Participant\'s Registered deck, as an Organizer  At any time, with any of the Participant\'s decks that is not private; after the first Round started the new Registered deck is pinned at once and sets its own Deck checkpoint.
     * Register or swap a Participant\'s Registered deck, as an Organizer
     */
    async registerTournamentParticipantDeck(requestParameters: RegisterTournamentParticipantDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForRegisterDeckErrors> {
        const response = await this.registerTournamentParticipantDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for releaseMatchLifeHistory without sending the request
     */
    async releaseMatchLifeHistoryRequestOpts(requestParameters: ReleaseMatchLifeHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling releaseMatchLifeHistory().'
            );
        }

        if (requestParameters['match'] == null) {
            throw new runtime.RequiredError(
                'match',
                'Required parameter "match" was null or undefined when calling releaseMatchLifeHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/matches/{match}/life-history/release`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{match}', encodeURIComponent(String(requestParameters['match'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ClaimMatchLifeRequest'],
        };
    }

    /**
     * Release a synchronized recording slot without deleting its history.
     * Release a synchronized recording slot without deleting its history.
     */
    async releaseMatchLifeHistoryRaw(requestParameters: ReleaseMatchLifeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SaveMatchLifeHistory200Response>> {
        const requestOptions = await this.releaseMatchLifeHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Release a synchronized recording slot without deleting its history.
     * Release a synchronized recording slot without deleting its history.
     */
    async releaseMatchLifeHistory(requestParameters: ReleaseMatchLifeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SaveMatchLifeHistory200Response> {
        const response = await this.releaseMatchLifeHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeDeckCheckpoint without sending the request
     */
    async removeDeckCheckpointRequestOpts(requestParameters: RemoveDeckCheckpointRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling removeDeckCheckpoint().'
            );
        }

        if (requestParameters['change'] == null) {
            throw new runtime.RequiredError(
                'change',
                'Required parameter "change" was null or undefined when calling removeDeckCheckpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/history/{change}/checkpoint`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));
        urlPath = urlPath.replace('{change}', encodeURIComponent(String(requestParameters['change'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove the Deck checkpoint of one of the deck\'s Deck changes  Only the owner removes. A Deck change without one stays as it is.
     * Remove the Deck checkpoint of one of the deck\'s Deck changes
     */
    async removeDeckCheckpointRaw(requestParameters: RemoveDeckCheckpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.removeDeckCheckpointRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Remove the Deck checkpoint of one of the deck\'s Deck changes  Only the owner removes. A Deck change without one stays as it is.
     * Remove the Deck checkpoint of one of the deck\'s Deck changes
     */
    async removeDeckCheckpoint(requestParameters: RemoveDeckCheckpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.removeDeckCheckpointRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeDeckCollaborator without sending the request
     */
    async removeDeckCollaboratorRequestOpts(requestParameters: RemoveDeckCollaboratorRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling removeDeckCollaborator().'
            );
        }

        if (requestParameters['account'] == null) {
            throw new runtime.RequiredError(
                'account',
                'Required parameter "account" was null or undefined when calling removeDeckCollaborator().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/collaborators/{account}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));
        urlPath = urlPath.replace('{account}', encodeURIComponent(String(requestParameters['account'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Take an Account off a deck  It loses its access with the next request it makes.
     * Take an Account off a deck
     */
    async removeDeckCollaboratorRaw(requestParameters: RemoveDeckCollaboratorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.removeDeckCollaboratorRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Take an Account off a deck  It loses its access with the next request it makes.
     * Take an Account off a deck
     */
    async removeDeckCollaborator(requestParameters: RemoveDeckCollaboratorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.removeDeckCollaboratorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeMyTournamentDeck without sending the request
     */
    async removeMyTournamentDeckRequestOpts(requestParameters: RemoveMyTournamentDeckRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling removeMyTournamentDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/deck`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove the logged-in Account\'s own Registered deck, to play without one  Only while the Tournament is in Registration.
     * Remove the logged-in Account\'s own Registered deck, to play without one
     */
    async removeMyTournamentDeckRaw(requestParameters: RemoveMyTournamentDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForRegisterDeckErrors>> {
        const requestOptions = await this.removeMyTournamentDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Remove the logged-in Account\'s own Registered deck, to play without one  Only while the Tournament is in Registration.
     * Remove the logged-in Account\'s own Registered deck, to play without one
     */
    async removeMyTournamentDeck(requestParameters: RemoveMyTournamentDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForRegisterDeckErrors> {
        const response = await this.removeMyTournamentDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeTournamentCoOrganizer without sending the request
     */
    async removeTournamentCoOrganizerRequestOpts(requestParameters: RemoveTournamentCoOrganizerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling removeTournamentCoOrganizer().'
            );
        }

        if (requestParameters['account'] == null) {
            throw new runtime.RequiredError(
                'account',
                'Required parameter "account" was null or undefined when calling removeTournamentCoOrganizer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/organizers/{account}`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{account}', encodeURIComponent(String(requestParameters['account'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Take a Co-organizer off a Tournament  The Owner takes off any Co-organizer, a Co-organizer only itself.
     * Take a Co-organizer off a Tournament
     */
    async removeTournamentCoOrganizerRaw(requestParameters: RemoveTournamentCoOrganizerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.removeTournamentCoOrganizerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Take a Co-organizer off a Tournament  The Owner takes off any Co-organizer, a Co-organizer only itself.
     * Take a Co-organizer off a Tournament
     */
    async removeTournamentCoOrganizer(requestParameters: RemoveTournamentCoOrganizerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.removeTournamentCoOrganizerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeTournamentParticipant without sending the request
     */
    async removeTournamentParticipantRequestOpts(requestParameters: RemoveTournamentParticipantRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling removeTournamentParticipant().'
            );
        }

        if (requestParameters['participant'] == null) {
            throw new runtime.RequiredError(
                'participant',
                'Required parameter "participant" was null or undefined when calling removeTournamentParticipant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/participants/{participant}`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{participant}', encodeURIComponent(String(requestParameters['participant'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Take a Participant out of a Tournament, as an Organizer  Only before the first Round starts; afterwards a Participant leaves by a Drop.
     * Take a Participant out of a Tournament, as an Organizer
     */
    async removeTournamentParticipantRaw(requestParameters: RemoveTournamentParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.removeTournamentParticipantRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Take a Participant out of a Tournament, as an Organizer  Only before the first Round starts; afterwards a Participant leaves by a Drop.
     * Take a Participant out of a Tournament, as an Organizer
     */
    async removeTournamentParticipant(requestParameters: RemoveTournamentParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.removeTournamentParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeTournamentParticipantDeck without sending the request
     */
    async removeTournamentParticipantDeckRequestOpts(requestParameters: RemoveTournamentParticipantDeckRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling removeTournamentParticipantDeck().'
            );
        }

        if (requestParameters['participant'] == null) {
            throw new runtime.RequiredError(
                'participant',
                'Required parameter "participant" was null or undefined when calling removeTournamentParticipantDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/participants/{participant}/deck`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{participant}', encodeURIComponent(String(requestParameters['participant'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove a Participant\'s Registered deck, as an Organizer, at any time
     * Remove a Participant\'s Registered deck, as an Organizer, at any time
     */
    async removeTournamentParticipantDeckRaw(requestParameters: RemoveTournamentParticipantDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForRegisterDeckErrors>> {
        const requestOptions = await this.removeTournamentParticipantDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Remove a Participant\'s Registered deck, as an Organizer, at any time
     * Remove a Participant\'s Registered deck, as an Organizer, at any time
     */
    async removeTournamentParticipantDeck(requestParameters: RemoveTournamentParticipantDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForRegisterDeckErrors> {
        const response = await this.removeTournamentParticipantDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for renameAccount without sending the request
     */
    async renameAccountRequestOpts(requestParameters: RenameAccountOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/accounts/me/username`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['RenameAccountRequest'],
        };
    }

    /**
     * Rename the logged-in account  The old username is free for anybody right away, and its profile link stops working. The session stays: it belongs to the account\'s identity, not its name.
     * Rename the logged-in account
     */
    async renameAccountRaw(requestParameters: RenameAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RenameAccount200Response>> {
        const requestOptions = await this.renameAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Rename the logged-in account  The old username is free for anybody right away, and its profile link stops working. The session stays: it belongs to the account\'s identity, not its name.
     * Rename the logged-in account
     */
    async renameAccount(requestParameters: RenameAccountOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RenameAccount200Response> {
        const response = await this.renameAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for renamePasskey without sending the request
     */
    async renamePasskeyRequestOpts(requestParameters: RenamePasskeyOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling renamePasskey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/accounts/passkeys/{uuid}`;
        urlPath = urlPath.replace('{uuid}', encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['RenamePasskeyRequest'],
        };
    }

    /**
     * Rename one of the logged-in account\'s passkeys
     * Rename one of the logged-in account\'s passkeys
     */
    async renamePasskeyRaw(requestParameters: RenamePasskeyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForRenamePasskeyErrors>> {
        const requestOptions = await this.renamePasskeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Rename one of the logged-in account\'s passkeys
     * Rename one of the logged-in account\'s passkeys
     */
    async renamePasskey(requestParameters: RenamePasskeyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForRenamePasskeyErrors> {
        const response = await this.renamePasskeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reportTournamentMatchResult without sending the request
     */
    async reportTournamentMatchResultRequestOpts(requestParameters: ReportTournamentMatchResultRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling reportTournamentMatchResult().'
            );
        }

        if (requestParameters['match'] == null) {
            throw new runtime.RequiredError(
                'match',
                'Required parameter "match" was null or undefined when calling reportTournamentMatchResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/matches/{match}/report`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{match}', encodeURIComponent(String(requestParameters['match'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ReportResultRequest'],
        };
    }

    /**
     * Report the Result of one\'s own Match, as its Participant  It counts at once. The reporter may correct it while the Round runs; another Participant who disagrees disputes it instead. A locked Account cannot report: an Organizer sets its Result.
     * Report the Result of one\'s own Match, as its Participant
     */
    async reportTournamentMatchResultRaw(requestParameters: ReportTournamentMatchResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForReportResultErrors>> {
        const requestOptions = await this.reportTournamentMatchResultRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Report the Result of one\'s own Match, as its Participant  It counts at once. The reporter may correct it while the Round runs; another Participant who disagrees disputes it instead. A locked Account cannot report: an Organizer sets its Result.
     * Report the Result of one\'s own Match, as its Participant
     */
    async reportTournamentMatchResult(requestParameters: ReportTournamentMatchResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForReportResultErrors> {
        const response = await this.reportTournamentMatchResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resetDeck without sending the request
     */
    async resetDeckRequestOpts(requestParameters: ResetDeckRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling resetDeck().'
            );
        }

        if (requestParameters['change'] == null) {
            throw new runtime.RequiredError(
                'change',
                'Required parameter "change" was null or undefined when calling resetDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/history/{change}/reset`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));
        urlPath = urlPath.replace('{change}', encodeURIComponent(String(requestParameters['change'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Bring the deck back to how it was right after one of its Deck changes  Only the owner resets. Recorded as one Deck change of its own, which can be undone; the Deck changes since stay in the Deck history.
     * Bring the deck back to how it was right after one of its Deck changes
     */
    async resetDeckRaw(requestParameters: ResetDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckUndoResponse>> {
        const requestOptions = await this.resetDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Bring the deck back to how it was right after one of its Deck changes  Only the owner resets. Recorded as one Deck change of its own, which can be undone; the Deck changes since stay in the Deck history.
     * Bring the deck back to how it was right after one of its Deck changes
     */
    async resetDeck(requestParameters: ResetDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckUndoResponse> {
        const response = await this.resetDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resolvePrintings without sending the request
     */
    async resolvePrintingsRequestOpts(requestParameters: ResolvePrintingsOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/printings/resolve`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ResolvePrintingsRequest'],
        };
    }

    /**
     * Place cards in the catalog  Takes the rows of an imported collection as the exporter wrote them — an id, a set and a collector number, or a bare name — and answers with the printing each names. Every answer carries the position of the lookup it belongs to; a lookup nothing names is one the catalog holds no card for.  This is the catalog the collection listing and the statistics are already answered from, so nothing can be filed here that those cannot read back.
     * Place cards in the catalog
     */
    async resolvePrintingsRaw(requestParameters: ResolvePrintingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResolvePrintingsResponse>> {
        const requestOptions = await this.resolvePrintingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Place cards in the catalog  Takes the rows of an imported collection as the exporter wrote them — an id, a set and a collector number, or a bare name — and answers with the printing each names. Every answer carries the position of the lookup it belongs to; a lookup nothing names is one the catalog holds no card for.  This is the catalog the collection listing and the statistics are already answered from, so nothing can be filed here that those cannot read back.
     * Place cards in the catalog
     */
    async resolvePrintings(requestParameters: ResolvePrintingsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResolvePrintingsResponse> {
        const response = await this.resolvePrintingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for returnAllDeckCards without sending the request
     */
    async returnAllDeckCardsRequestOpts(requestParameters: ReturnAllDeckCardsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling returnAllDeckCards().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/sourcing/return-all`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ReturnAllDeckCardsRequest'],
        };
    }

    /**
     * Sort everything in the deck back where it came from  This is what taking a deck apart does. Stacks that remember no origin only move when the client says where they should go; otherwise they stay, and the answer says how many that was.
     * Sort everything in the deck back where it came from
     */
    async returnAllDeckCardsRaw(requestParameters: ReturnAllDeckCardsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReturnAllDeckCardsResponse>> {
        const requestOptions = await this.returnAllDeckCardsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Sort everything in the deck back where it came from  This is what taking a deck apart does. Stacks that remember no origin only move when the client says where they should go; otherwise they stay, and the answer says how many that was.
     * Sort everything in the deck back where it came from
     */
    async returnAllDeckCards(requestParameters: ReturnAllDeckCardsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReturnAllDeckCardsResponse> {
        const response = await this.returnAllDeckCardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for returnDeckCards without sending the request
     */
    async returnDeckCardsRequestOpts(requestParameters: ReturnDeckCardsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling returnDeckCards().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/sourcing/return`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ReturnDeckCardsRequest'],
        };
    }

    /**
     * Sort copies out of the deck back into a collection
     * Sort copies out of the deck back into a collection
     */
    async returnDeckCardsRaw(requestParameters: ReturnDeckCardsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.returnDeckCardsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Sort copies out of the deck back into a collection
     * Sort copies out of the deck back into a collection
     */
    async returnDeckCards(requestParameters: ReturnDeckCardsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.returnDeckCardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for rotateDeckShareToken without sending the request
     */
    async rotateDeckShareTokenRequestOpts(requestParameters: RotateDeckShareTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling rotateDeckShareToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/share-token`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Mint a fresh secret for a deck\'s share link
     * Mint a fresh secret for a deck\'s share link
     */
    async rotateDeckShareTokenRaw(requestParameters: RotateDeckShareTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RotateDeckShareTokenResponse>> {
        const requestOptions = await this.rotateDeckShareTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Mint a fresh secret for a deck\'s share link
     * Mint a fresh secret for a deck\'s share link
     */
    async rotateDeckShareToken(requestParameters: RotateDeckShareTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RotateDeckShareTokenResponse> {
        const response = await this.rotateDeckShareTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for rotateShareToken without sending the request
     */
    async rotateShareTokenRequestOpts(requestParameters: RotateShareTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling rotateShareToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/collections/{collection}/share-token`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Mint a fresh secret for a collection\'s share link  Invalidates every link handed out so far. Does not change the visibility — a token only resolves while the collection is `Unlisted`.
     * Mint a fresh secret for a collection\'s share link
     */
    async rotateShareTokenRaw(requestParameters: RotateShareTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RotateShareTokenResponse>> {
        const requestOptions = await this.rotateShareTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Mint a fresh secret for a collection\'s share link  Invalidates every link handed out so far. Does not change the visibility — a token only resolves while the collection is `Unlisted`.
     * Mint a fresh secret for a collection\'s share link
     */
    async rotateShareToken(requestParameters: RotateShareTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RotateShareTokenResponse> {
        const response = await this.rotateShareTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for saveMatchLifeHistory without sending the request
     */
    async saveMatchLifeHistoryRequestOpts(requestParameters: SaveMatchLifeHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling saveMatchLifeHistory().'
            );
        }

        if (requestParameters['match'] == null) {
            throw new runtime.RequiredError(
                'match',
                'Required parameter "match" was null or undefined when calling saveMatchLifeHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/matches/{match}/life-history`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{match}', encodeURIComponent(String(requestParameters['match'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SaveMatchLifeRequest'],
        };
    }

    /**
     * Upload history using only the active recording Account, device and private capability.
     * Upload history using only the active recording Account, device and private capability.
     */
    async saveMatchLifeHistoryRaw(requestParameters: SaveMatchLifeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SaveMatchLifeHistory200Response>> {
        const requestOptions = await this.saveMatchLifeHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Upload history using only the active recording Account, device and private capability.
     * Upload history using only the active recording Account, device and private capability.
     */
    async saveMatchLifeHistory(requestParameters: SaveMatchLifeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SaveMatchLifeHistory200Response> {
        const response = await this.saveMatchLifeHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchCollaboratorCandidates without sending the request
     */
    async searchCollaboratorCandidatesRequestOpts(requestParameters: SearchCollaboratorCandidatesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling searchCollaboratorCandidates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/collaborators/candidates`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Accounts whose username starts with what the owner typed, to name on a deck  Answers with up to ten Accounts, the caller among them if it matches, alphabetically by username. Fewer than two characters search nothing. Searches are capped per caller, see [`CANDIDATE_SEARCHES`]; past the cap the answer is empty and says so.
     * Accounts whose username starts with what the owner typed, to name on a deck
     */
    async searchCollaboratorCandidatesRaw(requestParameters: SearchCollaboratorCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CollaboratorCandidatesResponse>> {
        const requestOptions = await this.searchCollaboratorCandidatesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Accounts whose username starts with what the owner typed, to name on a deck  Answers with up to ten Accounts, the caller among them if it matches, alphabetically by username. Fewer than two characters search nothing. Searches are capped per caller, see [`CANDIDATE_SEARCHES`]; past the cap the answer is empty and says so.
     * Accounts whose username starts with what the owner typed, to name on a deck
     */
    async searchCollaboratorCandidates(requestParameters: SearchCollaboratorCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CollaboratorCandidatesResponse> {
        const response = await this.searchCollaboratorCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchMpcfillArt without sending the request
     */
    async searchMpcfillArtRequestOpts(requestParameters: SearchMpcfillArtRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/mpcfill/search`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['MpcFillSearchRequest'],
        };
    }

    /**
     * The art MPCFill has for these cards  One list per name, in the order they were asked, each in the order MPCFill ranks it. Every image carries the Google Drive id an order xml names it by, plus the thumbnails to show it with, so a client can put the art in front of a reader and write the order they pick.  Proxied rather than asked from the browser: MPCFill answers cross-origin requests for their own site only. The answers are cached for a few hours per name, so picking through a deck card by card is one request per card at worst, not one per click.
     * The art MPCFill has for these cards
     */
    async searchMpcfillArtRaw(requestParameters: SearchMpcfillArtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MpcFillSearchResponse>> {
        const requestOptions = await this.searchMpcfillArtRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * The art MPCFill has for these cards  One list per name, in the order they were asked, each in the order MPCFill ranks it. Every image carries the Google Drive id an order xml names it by, plus the thumbnails to show it with, so a client can put the art in front of a reader and write the order they pick.  Proxied rather than asked from the browser: MPCFill answers cross-origin requests for their own site only. The answers are cached for a few hours per name, so picking through a deck card by card is one request per card at worst, not one per click.
     * The art MPCFill has for these cards
     */
    async searchMpcfillArt(requestParameters: SearchMpcfillArtRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MpcFillSearchResponse> {
        const response = await this.searchMpcfillArtRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchPublicDecks without sending the request
     */
    async searchPublicDecksRequestOpts(requestParameters: SearchPublicDecksRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['bracket'] != null) {
            queryParameters['bracket'] = requestParameters['bracket'];
        }

        if (requestParameters['descending'] != null) {
            queryParameters['descending'] = requestParameters['descending'];
        }

        if (requestParameters['format'] != null) {
            queryParameters['format'] = requestParameters['format'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['owner'] != null) {
            queryParameters['owner'] = requestParameters['owner'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/explore/decks`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Search the decks their owners put on show  By what a deck or its commander is called, by format, by the Commander bracket it claims, or by who built it. Only decks at [`Visibility::Public`] are ever found here — an unlisted deck stays behind its share link.
     * Search the decks their owners put on show
     */
    async searchPublicDecksRaw(requestParameters: SearchPublicDecksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPublicDecksResponse>> {
        const requestOptions = await this.searchPublicDecksRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search the decks their owners put on show  By what a deck or its commander is called, by format, by the Commander bracket it claims, or by who built it. Only decks at [`Visibility::Public`] are ever found here — an unlisted deck stays behind its share link.
     * Search the decks their owners put on show
     */
    async searchPublicDecks(requestParameters: SearchPublicDecksRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPublicDecksResponse> {
        const response = await this.searchPublicDecksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sendBugReport without sending the request
     */
    async sendBugReportRequestOpts(requestParameters: SendBugReportOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['report'] == null) {
            throw new runtime.RequiredError(
                'report',
                'Required parameter "report" was null or undefined when calling sendBugReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['images'] != null) {
            requestParameters['images'].forEach((element) => {
                formParams.append('images', element as any);
            })
        }

        if (requestParameters['report'] != null) {

            formParams.append('report', new Blob([JSON.stringify(requestParameters['report'])], { type: "application/json", }));
        }


        let urlPath = `/api/frontend/v1/bug-reports`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     * Send a Bug report  A multipart body: the `report` part as json and up to three `images`. Every Admin is mailed a notice without diagnostics or images; a mail that fails is logged and does not fail the send.
     * Send a Bug report
     */
    async sendBugReportRaw(requestParameters: SendBugReportOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendBugReport200Response>> {
        const requestOptions = await this.sendBugReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Send a Bug report  A multipart body: the `report` part as json and up to three `images`. Every Admin is mailed a notice without diagnostics or images; a mail that fails is logged and does not fail the send.
     * Send a Bug report
     */
    async sendBugReport(requestParameters: SendBugReportOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendBugReport200Response> {
        const response = await this.sendBugReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setDeckAdvisorSettings without sending the request
     */
    async setDeckAdvisorSettingsRequestOpts(requestParameters: SetDeckAdvisorSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling setDeckAdvisorSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/advisor-settings`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetAdvisorSettingsRequest'],
        };
    }

    /**
     * Replace this deck\'s advisor settings  A theme id, a bucket id and an oracle id are the graph service\'s vocabulary and it already reports what it cannot parse, so nothing here validates them. The only two shapes checked are the pool query\'s length and the curve\'s.
     * Replace this deck\'s advisor settings
     */
    async setDeckAdvisorSettingsRaw(requestParameters: SetDeckAdvisorSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.setDeckAdvisorSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Replace this deck\'s advisor settings  A theme id, a bucket id and an oracle id are the graph service\'s vocabulary and it already reports what it cannot parse, so nothing here validates them. The only two shapes checked are the pool query\'s length and the curve\'s.
     * Replace this deck\'s advisor settings
     */
    async setDeckAdvisorSettings(requestParameters: SetDeckAdvisorSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.setDeckAdvisorSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setDeckBracket without sending the request
     */
    async setDeckBracketRequestOpts(requestParameters: SetDeckBracketOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling setDeckBracket().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/bracket`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetDeckBracketRequest'],
        };
    }

    /**
     * Say which Commander bracket the deck is built to  Nothing is checked: the bracket is a claim its builder makes, and the client says where the claim and the cards disagree.
     * Say which Commander bracket the deck is built to
     */
    async setDeckBracketRaw(requestParameters: SetDeckBracketOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.setDeckBracketRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Say which Commander bracket the deck is built to  Nothing is checked: the bracket is a claim its builder makes, and the client says where the claim and the cards disagree.
     * Say which Commander bracket the deck is built to
     */
    async setDeckBracket(requestParameters: SetDeckBracketOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.setDeckBracketRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setDeckCheckpoint without sending the request
     */
    async setDeckCheckpointRequestOpts(requestParameters: SetDeckCheckpointOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling setDeckCheckpoint().'
            );
        }

        if (requestParameters['change'] == null) {
            throw new runtime.RequiredError(
                'change',
                'Required parameter "change" was null or undefined when calling setDeckCheckpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/history/{change}/checkpoint`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));
        urlPath = urlPath.replace('{change}', encodeURIComponent(String(requestParameters['change'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetDeckCheckpointRequest'],
        };
    }

    /**
     * Name one of the deck\'s Deck changes with a Deck checkpoint, or rename its Deck checkpoint  Only the owner names. A Deck change carries at most one Deck checkpoint, so naming a named one renames it.
     * Name one of the deck\'s Deck changes with a Deck checkpoint, or rename its
     */
    async setDeckCheckpointRaw(requestParameters: SetDeckCheckpointOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.setDeckCheckpointRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Name one of the deck\'s Deck changes with a Deck checkpoint, or rename its Deck checkpoint  Only the owner names. A Deck change carries at most one Deck checkpoint, so naming a named one renames it.
     * Name one of the deck\'s Deck changes with a Deck checkpoint, or rename its
     */
    async setDeckCheckpoint(requestParameters: SetDeckCheckpointOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.setDeckCheckpointRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setDeckColors without sending the request
     */
    async setDeckColorsRequestOpts(requestParameters: SetDeckColorsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling setDeckColors().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/colors`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetDeckColorsRequest'],
        };
    }

    /**
     * Overrule which colours the deck may play  `null` hands the decision back to the commander zone. This exists because there are commanders that grant the deck a colour outside their own identity, and the service has no business knowing which ones.
     * Overrule which colours the deck may play
     */
    async setDeckColorsRaw(requestParameters: SetDeckColorsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.setDeckColorsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Overrule which colours the deck may play  `null` hands the decision back to the commander zone. This exists because there are commanders that grant the deck a colour outside their own identity, and the service has no business knowing which ones.
     * Overrule which colours the deck may play
     */
    async setDeckColors(requestParameters: SetDeckColorsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.setDeckColorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setDeckFolder without sending the request
     */
    async setDeckFolderRequestOpts(requestParameters: SetDeckFolderOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling setDeckFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/folder`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetDeckFolderRequest'],
        };
    }

    /**
     * File a deck into one of the account\'s folders  `null` takes it off every shelf. Putting a deck away is this call with the archive, which is the folder [`crate::http::handler_frontend::folders`] hands out alongside the account\'s own.
     * File a deck into one of the account\'s folders
     */
    async setDeckFolderRaw(requestParameters: SetDeckFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.setDeckFolderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * File a deck into one of the account\'s folders  `null` takes it off every shelf. Putting a deck away is this call with the archive, which is the folder [`crate::http::handler_frontend::folders`] hands out alongside the account\'s own.
     * File a deck into one of the account\'s folders
     */
    async setDeckFolder(requestParameters: SetDeckFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.setDeckFolderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setDeckRuleZero without sending the request
     */
    async setDeckRuleZeroRequestOpts(requestParameters: SetDeckRuleZeroOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling setDeckRuleZero().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/rule-zero`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetDeckRuleZeroRequest'],
        };
    }

    /**
     * Record the house rules the deck is played under, colours included  Beyond a deck size that would hold no cards, nothing is checked: what a table agreed to is a claim its builder makes, and the client says where the claim and the cards disagree.
     * Record the house rules the deck is played under, colours included
     */
    async setDeckRuleZeroRaw(requestParameters: SetDeckRuleZeroOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.setDeckRuleZeroRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Record the house rules the deck is played under, colours included  Beyond a deck size that would hold no cards, nothing is checked: what a table agreed to is a claim its builder makes, and the client says where the claim and the cards disagree.
     * Record the house rules the deck is played under, colours included
     */
    async setDeckRuleZero(requestParameters: SetDeckRuleZeroOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.setDeckRuleZeroRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setMyTournamentListSharing without sending the request
     */
    async setMyTournamentListSharingRequestOpts(requestParameters: SetMyTournamentListSharingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling setMyTournamentListSharing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/deck/sharing`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetListSharingRequest'],
        };
    }

    /**
     * Choose whether others may see the logged-in Account\'s list once the Tournament is Finished  The Participant\'s own choice, open until the Tournament is Finished or Cancelled; from then on it is refused.
     * Choose whether others may see the logged-in Account\'s list once the
     */
    async setMyTournamentListSharingRaw(requestParameters: SetMyTournamentListSharingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForSetListSharingErrors>> {
        const requestOptions = await this.setMyTournamentListSharingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Choose whether others may see the logged-in Account\'s list once the Tournament is Finished  The Participant\'s own choice, open until the Tournament is Finished or Cancelled; from then on it is refused.
     * Choose whether others may see the logged-in Account\'s list once the
     */
    async setMyTournamentListSharing(requestParameters: SetMyTournamentListSharingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForSetListSharingErrors> {
        const response = await this.setMyTournamentListSharingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setPushSettings without sending the request
     */
    async setPushSettingsRequestOpts(requestParameters: SetPushSettingsOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/accounts/me/push`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetPushSettingsRequest'],
        };
    }

    /**
     * Turn tournament pushes on or off for every device of the logged-in account
     * Turn tournament pushes on or off for every device of the logged-in account
     */
    async setPushSettingsRaw(requestParameters: SetPushSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.setPushSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Turn tournament pushes on or off for every device of the logged-in account
     * Turn tournament pushes on or off for every device of the logged-in account
     */
    async setPushSettings(requestParameters: SetPushSettingsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.setPushSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setTournamentMatchResult without sending the request
     */
    async setTournamentMatchResultRequestOpts(requestParameters: SetTournamentMatchResultRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling setTournamentMatchResult().'
            );
        }

        if (requestParameters['match'] == null) {
            throw new runtime.RequiredError(
                'match',
                'Required parameter "match" was null or undefined when calling setTournamentMatchResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/matches/{match}/result`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{match}', encodeURIComponent(String(requestParameters['match'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetResultRequest'],
        };
    }

    /**
     * Set or correct the Result of a Match, as an Organizer  Any time once its Round started, also after the Tournament is over; the standings follow, the pairings stay as they are. This is how an Organizer settles a disputed Result and reports for Guests and locked Accounts.
     * Set or correct the Result of a Match, as an Organizer
     */
    async setTournamentMatchResultRaw(requestParameters: SetTournamentMatchResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForSetResultErrors>> {
        const requestOptions = await this.setTournamentMatchResultRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set or correct the Result of a Match, as an Organizer  Any time once its Round started, also after the Tournament is over; the standings follow, the pairings stay as they are. This is how an Organizer settles a disputed Result and reports for Guests and locked Accounts.
     * Set or correct the Result of a Match, as an Organizer
     */
    async setTournamentMatchResult(requestParameters: SetTournamentMatchResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForSetResultErrors> {
        const response = await this.setTournamentMatchResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setTournamentParticipantCheckedIn without sending the request
     */
    async setTournamentParticipantCheckedInRequestOpts(requestParameters: SetTournamentParticipantCheckedInRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling setTournamentParticipantCheckedIn().'
            );
        }

        if (requestParameters['participant'] == null) {
            throw new runtime.RequiredError(
                'participant',
                'Required parameter "participant" was null or undefined when calling setTournamentParticipantCheckedIn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/participants/{participant}/checked-in`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{participant}', encodeURIComponent(String(requestParameters['participant'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetCheckedInRequest'],
        };
    }

    /**
     * Check a Participant in or out, as an Organizer  Only in a Tournament that takes check-in, until it is over, and not for a Participant that dropped; once the first Round started, in only. Where a deck is required, an Account checks in only with a Registered deck, which keeps following its deck until the first Round starts. A Participant not checked in is left out of the pairing; changing the flag discards a previewed Round.
     * Check a Participant in or out, as an Organizer
     */
    async setTournamentParticipantCheckedInRaw(requestParameters: SetTournamentParticipantCheckedInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForSetCheckedInErrors>> {
        const requestOptions = await this.setTournamentParticipantCheckedInRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Check a Participant in or out, as an Organizer  Only in a Tournament that takes check-in, until it is over, and not for a Participant that dropped; once the first Round started, in only. Where a deck is required, an Account checks in only with a Registered deck, which keeps following its deck until the first Round starts. A Participant not checked in is left out of the pairing; changing the flag discards a previewed Round.
     * Check a Participant in or out, as an Organizer
     */
    async setTournamentParticipantCheckedIn(requestParameters: SetTournamentParticipantCheckedInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForSetCheckedInErrors> {
        const response = await this.setTournamentParticipantCheckedInRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setTournamentParticipantPaid without sending the request
     */
    async setTournamentParticipantPaidRequestOpts(requestParameters: SetTournamentParticipantPaidRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling setTournamentParticipantPaid().'
            );
        }

        if (requestParameters['participant'] == null) {
            throw new runtime.RequiredError(
                'participant',
                'Required parameter "participant" was null or undefined when calling setTournamentParticipantPaid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/participants/{participant}/paid`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{participant}', encodeURIComponent(String(requestParameters['participant'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetPaidRequest'],
        };
    }

    /**
     * Mark a Participant paid or unpaid, as an Organizer  Only in a Tournament with an entry fee, until it is over. An unpaid Participant is left out of the pairing; changing the flag discards a previewed Round.
     * Mark a Participant paid or unpaid, as an Organizer
     */
    async setTournamentParticipantPaidRaw(requestParameters: SetTournamentParticipantPaidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForSetPaidErrors>> {
        const requestOptions = await this.setTournamentParticipantPaidRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Mark a Participant paid or unpaid, as an Organizer  Only in a Tournament with an entry fee, until it is over. An unpaid Participant is left out of the pairing; changing the flag discards a previewed Round.
     * Mark a Participant paid or unpaid, as an Organizer
     */
    async setTournamentParticipantPaid(requestParameters: SetTournamentParticipantPaidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForSetPaidErrors> {
        const response = await this.setTournamentParticipantPaidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setTournamentRoundTimer without sending the request
     */
    async setTournamentRoundTimerRequestOpts(requestParameters: SetTournamentRoundTimerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling setTournamentRoundTimer().'
            );
        }

        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling setTournamentRoundTimer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/rounds/{number}/timer`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{number}', encodeURIComponent(String(requestParameters['number'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetRoundTimerRequest'],
        };
    }

    /**
     * Pause, resume, adjust or reset the round timer of a running Round, as an Organizer  Answers the timer afterwards; everybody following the Tournament hears of it.
     * Pause, resume, adjust or reset the round timer of a running Round, as an Organizer
     */
    async setTournamentRoundTimerRaw(requestParameters: SetTournamentRoundTimerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetTournamentRoundTimer200Response>> {
        const requestOptions = await this.setTournamentRoundTimerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Pause, resume, adjust or reset the round timer of a running Round, as an Organizer  Answers the timer afterwards; everybody following the Tournament hears of it.
     * Pause, resume, adjust or reset the round timer of a running Round, as an Organizer
     */
    async setTournamentRoundTimer(requestParameters: SetTournamentRoundTimerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetTournamentRoundTimer200Response> {
        const response = await this.setTournamentRoundTimerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setTournamentSwissRounds without sending the request
     */
    async setTournamentSwissRoundsRequestOpts(requestParameters: SetTournamentSwissRoundsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling setTournamentSwissRounds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/swiss-rounds`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetSwissRoundsRequest'],
        };
    }

    /**
     * Set how many Swiss Rounds are played, as an Organizer  At least as many as were paired. Set to the Rounds played once the last of them ended, the Tournament is Finished.
     * Set how many Swiss Rounds are played, as an Organizer
     */
    async setTournamentSwissRoundsRaw(requestParameters: SetTournamentSwissRoundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetTournamentSwissRounds200Response>> {
        const requestOptions = await this.setTournamentSwissRoundsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set how many Swiss Rounds are played, as an Organizer  At least as many as were paired. Set to the Rounds played once the last of them ended, the Tournament is Finished.
     * Set how many Swiss Rounds are played, as an Organizer
     */
    async setTournamentSwissRounds(requestParameters: SetTournamentSwissRoundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetTournamentSwissRounds200Response> {
        const response = await this.setTournamentSwissRoundsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setVisibilityCollection without sending the request
     */
    async setVisibilityCollectionRequestOpts(requestParameters: SetVisibilityCollectionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling setVisibilityCollection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/collections/{collection}`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetCollectionVisibilityRequest'],
        };
    }

    /**
     * Change who may see a collection
     * Change who may see a collection
     */
    async setVisibilityCollectionRaw(requestParameters: SetVisibilityCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.setVisibilityCollectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Change who may see a collection
     * Change who may see a collection
     */
    async setVisibilityCollection(requestParameters: SetVisibilityCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.setVisibilityCollectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setVisibilityDeck without sending the request
     */
    async setVisibilityDeckRequestOpts(requestParameters: SetVisibilityDeckRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling setVisibilityDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetDeckVisibilityRequest'],
        };
    }

    /**
     * Change who may see a deck
     * Change who may see a deck
     */
    async setVisibilityDeckRaw(requestParameters: SetVisibilityDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.setVisibilityDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Change who may see a deck
     * Change who may see a deck
     */
    async setVisibilityDeck(requestParameters: SetVisibilityDeckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.setVisibilityDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for signUpForSharedTournament without sending the request
     */
    async signUpForSharedTournamentRequestOpts(requestParameters: SignUpForSharedTournamentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling signUpForSharedTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/shared/tournaments/{token}/sign-up`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Sign the logged-in Account up for the Tournament a share link points at  The way into an unlisted Tournament; refused like `sign_up_for_tournament`.
     * Sign the logged-in Account up for the Tournament a share link points at
     */
    async signUpForSharedTournamentRaw(requestParameters: SignUpForSharedTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SignUpForSharedTournament200Response>> {
        const requestOptions = await this.signUpForSharedTournamentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Sign the logged-in Account up for the Tournament a share link points at  The way into an unlisted Tournament; refused like `sign_up_for_tournament`.
     * Sign the logged-in Account up for the Tournament a share link points at
     */
    async signUpForSharedTournament(requestParameters: SignUpForSharedTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SignUpForSharedTournament200Response> {
        const response = await this.signUpForSharedTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for signUpForTournament without sending the request
     */
    async signUpForTournamentRequestOpts(requestParameters: SignUpForTournamentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling signUpForTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/sign-up`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Sign the logged-in Account up for a Tournament it sees by its id  Takes effect at once. Refused unless the Owner turned self sign-up on and the Tournament is in Registration, and once the participant limit is reached. An unlisted Tournament is signed up for through its share link, see `sign_up_for_shared_tournament`.
     * Sign the logged-in Account up for a Tournament it sees by its id
     */
    async signUpForTournamentRaw(requestParameters: SignUpForTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SignUpForSharedTournament200Response>> {
        const requestOptions = await this.signUpForTournamentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Sign the logged-in Account up for a Tournament it sees by its id  Takes effect at once. Refused unless the Owner turned self sign-up on and the Tournament is in Registration, and once the participant limit is reached. An unlisted Tournament is signed up for through its share link, see `sign_up_for_shared_tournament`.
     * Sign the logged-in Account up for a Tournament it sees by its id
     */
    async signUpForTournament(requestParameters: SignUpForTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SignUpForSharedTournament200Response> {
        const response = await this.signUpForTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for signup without sending the request
     */
    async signupRequestOpts(requestParameters: SignupOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/signup`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SignupRequest'],
        };
    }

    /**
     * Sign up for a new account  Reports a taken username back to the form — profiles are reachable by name, so that is public information anyway. Everything else answers `200` whether or not anything was created, so the response cannot be used to probe which email addresses are in use.  A link is only ever sent to the address stored on the account, never to the one in the request, so this endpoint cannot be used to mail a third party.
     * Sign up for a new account
     */
    async signupRaw(requestParameters: SignupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Signup200Response>> {
        const requestOptions = await this.signupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Sign up for a new account  Reports a taken username back to the form — profiles are reachable by name, so that is public information anyway. Everything else answers `200` whether or not anything was created, so the response cannot be used to probe which email addresses are in use.  A link is only ever sent to the address stored on the account, never to the one in the request, so this endpoint cannot be used to mail a third party.
     * Sign up for a new account
     */
    async signup(requestParameters: SignupOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Signup200Response> {
        const response = await this.signupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for splitCollectionEntry without sending the request
     */
    async splitCollectionEntryRequestOpts(requestParameters: SplitCollectionEntryOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling splitCollectionEntry().'
            );
        }

        if (requestParameters['entry'] == null) {
            throw new runtime.RequiredError(
                'entry',
                'Required parameter "entry" was null or undefined when calling splitCollectionEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/collections/{collection}/entries/{entry}/split`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));
        urlPath = urlPath.replace('{entry}', encodeURIComponent(String(requestParameters['entry'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SplitCollectionEntryRequest'],
        };
    }

    /**
     * Move copies out of a stack into a new one  For the case where part of a stack is no longer interchangeable with the rest — one of four copies got played, or was sleeved as a foil by mistake.
     * Move copies out of a stack into a new one
     */
    async splitCollectionEntryRaw(requestParameters: SplitCollectionEntryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SplitCollectionEntryResponse>> {
        const requestOptions = await this.splitCollectionEntryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Move copies out of a stack into a new one  For the case where part of a stack is no longer interchangeable with the rest — one of four copies got played, or was sleeved as a foil by mistake.
     * Move copies out of a stack into a new one
     */
    async splitCollectionEntry(requestParameters: SplitCollectionEntryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SplitCollectionEntryResponse> {
        const response = await this.splitCollectionEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startAddPasskey without sending the request
     */
    async startAddPasskeyRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/accounts/passkeys/start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Start registering another passkey for the logged-in account  This is how a second device is added. Unlike the invite flow it needs no token — proving the session is proof enough, and the account already exists.
     * Start registering another passkey for the logged-in account
     */
    async startAddPasskeyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartAddPasskeyResponse>> {
        const requestOptions = await this.startAddPasskeyRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start registering another passkey for the logged-in account  This is how a second device is added. Unlike the invite flow it needs no token — proving the session is proof enough, and the account already exists.
     * Start registering another passkey for the logged-in account
     */
    async startAddPasskey(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartAddPasskeyResponse> {
        const response = await this.startAddPasskeyRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startLogin without sending the request
     */
    async startLoginRequestOpts(requestParameters: StartLoginOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/login/start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['StartLoginRequest'],
        };
    }

    /**
     * Start a passkey login for a given username  The account\'s passkeys are sent as the credential allow-list.
     * Start a passkey login for a given username
     */
    async startLoginRaw(requestParameters: StartLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartLogin200Response>> {
        const requestOptions = await this.startLoginRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start a passkey login for a given username  The account\'s passkeys are sent as the credential allow-list.
     * Start a passkey login for a given username
     */
    async startLogin(requestParameters: StartLoginOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartLogin200Response> {
        const response = await this.startLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startOidcLogin without sending the request
     */
    async startOidcLoginRequestOpts(requestParameters: StartOidcLoginOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/oidc/start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['StartOidcLoginRequest'],
        };
    }

    /**
     * Start an OIDC login, for signing up and logging in alike  Answers the provider\'s authorization url to send the browser to.
     * Start an OIDC login, for signing up and logging in alike
     */
    async startOidcLoginRaw(requestParameters: StartOidcLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartOidcLogin200Response>> {
        const requestOptions = await this.startOidcLoginRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start an OIDC login, for signing up and logging in alike  Answers the provider\'s authorization url to send the browser to.
     * Start an OIDC login, for signing up and logging in alike
     */
    async startOidcLogin(requestParameters: StartOidcLoginOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartOidcLogin200Response> {
        const response = await this.startOidcLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startRegistration without sending the request
     */
    async startRegistrationRequestOpts(requestParameters: StartRegistrationOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/auth/register/start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['StartRegistrationRequest'],
        };
    }

    /**
     * Start a passkey registration
     * Start a passkey registration
     */
    async startRegistrationRaw(requestParameters: StartRegistrationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartRegistration200Response>> {
        const requestOptions = await this.startRegistrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start a passkey registration
     * Start a passkey registration
     */
    async startRegistration(requestParameters: StartRegistrationOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartRegistration200Response> {
        const response = await this.startRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startTournamentRound without sending the request
     */
    async startTournamentRoundRequestOpts(requestParameters: StartTournamentRoundRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling startTournamentRound().'
            );
        }

        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling startTournamentRound().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/rounds/{number}/start`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{number}', encodeURIComponent(String(requestParameters['number'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Start a previewed Round, as an Organizer: from now on everybody sees it  Starting Round 1 closes Registration and settles the number of Swiss Rounds.
     * Start a previewed Round, as an Organizer: from now on everybody sees it
     */
    async startTournamentRoundRaw(requestParameters: StartTournamentRoundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForRoundErrors>> {
        const requestOptions = await this.startTournamentRoundRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start a previewed Round, as an Organizer: from now on everybody sees it  Starting Round 1 closes Registration and settles the number of Swiss Rounds.
     * Start a previewed Round, as an Organizer: from now on everybody sees it
     */
    async startTournamentRound(requestParameters: StartTournamentRoundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForRoundErrors> {
        const response = await this.startTournamentRoundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for subscribePushDevice without sending the request
     */
    async subscribePushDeviceRequestOpts(requestParameters: SubscribePushDeviceOperationRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/accounts/me/push/devices`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SubscribePushDeviceRequest'],
        };
    }

    /**
     * Subscribe this device to the logged-in account\'s pushes  A device subscribed for another account before gets this one\'s pushes from now on.
     * Subscribe this device to the logged-in account\'s pushes
     */
    async subscribePushDeviceRaw(requestParameters: SubscribePushDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForSubscribePushDeviceErrors>> {
        const requestOptions = await this.subscribePushDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Subscribe this device to the logged-in account\'s pushes  A device subscribed for another account before gets this one\'s pushes from now on.
     * Subscribe this device to the logged-in account\'s pushes
     */
    async subscribePushDevice(requestParameters: SubscribePushDeviceOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForSubscribePushDeviceErrors> {
        const response = await this.subscribePushDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for swapDeckCard without sending the request
     */
    async swapDeckCardRequestOpts(requestParameters: SwapDeckCardOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling swapDeckCard().'
            );
        }

        if (requestParameters['card'] == null) {
            throw new runtime.RequiredError(
                'card',
                'Required parameter "card" was null or undefined when calling swapDeckCard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/cards/{card}/swap`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));
        urlPath = urlPath.replace('{card}', encodeURIComponent(String(requestParameters['card'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SwapDeckCardRequest'],
        };
    }

    /**
     * Give up copies of a Deck entry for another card in the same zone  Both halves happen in one transaction: the entry loses the copies, which removes it when none are left, and the incoming card joins an alike Deck entry or opens its own. A swap that cannot happen as a whole changes nothing. The answer is the Deck entry the incoming card sits in.
     * Give up copies of a Deck entry for another card in the same zone
     */
    async swapDeckCardRaw(requestParameters: SwapDeckCardOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckCardResponse>> {
        const requestOptions = await this.swapDeckCardRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Give up copies of a Deck entry for another card in the same zone  Both halves happen in one transaction: the entry loses the copies, which removes it when none are left, and the incoming card joins an alike Deck entry or opens its own. A swap that cannot happen as a whole changes nothing. The answer is the Deck entry the incoming card sits in.
     * Give up copies of a Deck entry for another card in the same zone
     */
    async swapDeckCard(requestParameters: SwapDeckCardOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckCardResponse> {
        const response = await this.swapDeckCardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for takeBackTournamentRound without sending the request
     */
    async takeBackTournamentRoundRequestOpts(requestParameters: TakeBackTournamentRoundRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling takeBackTournamentRound().'
            );
        }

        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling takeBackTournamentRound().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/rounds/{number}/take-back`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{number}', encodeURIComponent(String(requestParameters['number'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Take back the latest ended Round, as an Organizer: it runs again  Only while no later Round started; a previewed next Round goes. Its Results stay. A Tournament its last Swiss Round finished is back in Swiss.
     * Take back the latest ended Round, as an Organizer: it runs again
     */
    async takeBackTournamentRoundRaw(requestParameters: TakeBackTournamentRoundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EndTournamentRound200Response>> {
        const requestOptions = await this.takeBackTournamentRoundRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Take back the latest ended Round, as an Organizer: it runs again  Only while no later Round started; a previewed next Round goes. Its Results stay. A Tournament its last Swiss Round finished is back in Swiss.
     * Take back the latest ended Round, as an Organizer: it runs again
     */
    async takeBackTournamentRound(requestParameters: TakeBackTournamentRoundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EndTournamentRound200Response> {
        const response = await this.takeBackTournamentRoundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for takeDeckCards without sending the request
     */
    async takeDeckCardsRequestOpts(requestParameters: TakeDeckCardsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling takeDeckCards().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/sourcing/take`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['TakeDeckCardsRequest'],
        };
    }

    /**
     * Move copies out of a collection and into the deck  Where they came from is written down with them, which is what makes taking the deck apart again possible.
     * Move copies out of a collection and into the deck
     */
    async takeDeckCardsRaw(requestParameters: TakeDeckCardsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.takeDeckCardsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Move copies out of a collection and into the deck  Where they came from is written down with them, which is what makes taking the deck apart again possible.
     * Move copies out of a collection and into the deck
     */
    async takeDeckCards(requestParameters: TakeDeckCardsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.takeDeckCardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for takeoverMatchLifeHistory without sending the request
     */
    async takeoverMatchLifeHistoryRequestOpts(requestParameters: TakeoverMatchLifeHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling takeoverMatchLifeHistory().'
            );
        }

        if (requestParameters['match'] == null) {
            throw new runtime.RequiredError(
                'match',
                'Required parameter "match" was null or undefined when calling takeoverMatchLifeHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/matches/{match}/life-history/takeover`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));
        urlPath = urlPath.replace('{match}', encodeURIComponent(String(requestParameters['match'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ClaimMatchLifeRequest'],
        };
    }

    /**
     * Explicitly take over the confirmed latest saved state while online.
     * Explicitly take over the confirmed latest saved state while online.
     */
    async takeoverMatchLifeHistoryRaw(requestParameters: TakeoverMatchLifeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SaveMatchLifeHistory200Response>> {
        const requestOptions = await this.takeoverMatchLifeHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Explicitly take over the confirmed latest saved state while online.
     * Explicitly take over the confirmed latest saved state while online.
     */
    async takeoverMatchLifeHistory(requestParameters: TakeoverMatchLifeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SaveMatchLifeHistory200Response> {
        const response = await this.takeoverMatchLifeHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for unassignCollectionEntryTag without sending the request
     */
    async unassignCollectionEntryTagRequestOpts(requestParameters: UnassignCollectionEntryTagRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling unassignCollectionEntryTag().'
            );
        }

        if (requestParameters['entry'] == null) {
            throw new runtime.RequiredError(
                'entry',
                'Required parameter "entry" was null or undefined when calling unassignCollectionEntryTag().'
            );
        }

        if (requestParameters['tag'] == null) {
            throw new runtime.RequiredError(
                'tag',
                'Required parameter "tag" was null or undefined when calling unassignCollectionEntryTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/collections/{collection}/entries/{entry}/tags/{tag}`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));
        urlPath = urlPath.replace('{entry}', encodeURIComponent(String(requestParameters['entry'])));
        urlPath = urlPath.replace('{tag}', encodeURIComponent(String(requestParameters['tag'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Take a card-wide tag off a stack, see [`assign_collection_entry_tag`]
     * Take a card-wide tag off a stack, see [`assign_collection_entry_tag`]
     */
    async unassignCollectionEntryTagRaw(requestParameters: UnassignCollectionEntryTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.unassignCollectionEntryTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Take a card-wide tag off a stack, see [`assign_collection_entry_tag`]
     * Take a card-wide tag off a stack, see [`assign_collection_entry_tag`]
     */
    async unassignCollectionEntryTag(requestParameters: UnassignCollectionEntryTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.unassignCollectionEntryTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for unassignDeckCardTag without sending the request
     */
    async unassignDeckCardTagRequestOpts(requestParameters: UnassignDeckCardTagRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling unassignDeckCardTag().'
            );
        }

        if (requestParameters['card'] == null) {
            throw new runtime.RequiredError(
                'card',
                'Required parameter "card" was null or undefined when calling unassignDeckCardTag().'
            );
        }

        if (requestParameters['tag'] == null) {
            throw new runtime.RequiredError(
                'tag',
                'Required parameter "tag" was null or undefined when calling unassignDeckCardTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/cards/{card}/tags/{tag}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));
        urlPath = urlPath.replace('{card}', encodeURIComponent(String(requestParameters['card'])));
        urlPath = urlPath.replace('{tag}', encodeURIComponent(String(requestParameters['tag'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Take a tag off a card  An Editor only takes off tags local to this deck, as with putting one on.
     * Take a tag off a card
     */
    async unassignDeckCardTagRaw(requestParameters: UnassignDeckCardTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.unassignDeckCardTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Take a tag off a card  An Editor only takes off tags local to this deck, as with putting one on.
     * Take a tag off a card
     */
    async unassignDeckCardTag(requestParameters: UnassignDeckCardTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.unassignDeckCardTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for undoDeckChange without sending the request
     */
    async undoDeckChangeRequestOpts(requestParameters: UndoDeckChangeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling undoDeckChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/decks/{deck}/history/undo`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Take back the latest Deck change that is not undone yet  Only the owner undoes. Refused when only the deck\'s first Deck change is left.
     * Take back the latest Deck change that is not undone yet
     */
    async undoDeckChangeRaw(requestParameters: UndoDeckChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeckUndoResponse>> {
        const requestOptions = await this.undoDeckChangeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Take back the latest Deck change that is not undone yet  Only the owner undoes. Refused when only the deck\'s first Deck change is left.
     * Take back the latest Deck change that is not undone yet
     */
    async undoDeckChange(requestParameters: UndoDeckChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeckUndoResponse> {
        const response = await this.undoDeckChangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for unsubscribePushDevice without sending the request
     */
    async unsubscribePushDeviceRequestOpts(requestParameters: UnsubscribePushDeviceRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/accounts/me/push/devices/unsubscribe`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['PushDeviceRequest'],
        };
    }

    /**
     * Unsubscribe one of the logged-in account\'s devices; a device that is none of its is left alone
     * Unsubscribe one of the logged-in account\'s devices; a device that is none of its is left alone
     */
    async unsubscribePushDeviceRaw(requestParameters: UnsubscribePushDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.unsubscribePushDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Unsubscribe one of the logged-in account\'s devices; a device that is none of its is left alone
     * Unsubscribe one of the logged-in account\'s devices; a device that is none of its is left alone
     */
    async unsubscribePushDevice(requestParameters: UnsubscribePushDeviceRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.unsubscribePushDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateCollection without sending the request
     */
    async updateCollectionRequestOpts(requestParameters: UpdateCollectionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling updateCollection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/collections/{collection}`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateCollectionRequest'],
        };
    }

    /**
     */
    async updateCollectionRaw(requestParameters: UpdateCollectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.updateCollectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async updateCollection(requestParameters: UpdateCollectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateCollectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateCollectionEntry without sending the request
     */
    async updateCollectionEntryRequestOpts(requestParameters: UpdateCollectionEntryOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling updateCollectionEntry().'
            );
        }

        if (requestParameters['entry'] == null) {
            throw new runtime.RequiredError(
                'entry',
                'Required parameter "entry" was null or undefined when calling updateCollectionEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/collections/{collection}/entries/{entry}`;
        urlPath = urlPath.replace('{collection}', encodeURIComponent(String(requestParameters['collection'])));
        urlPath = urlPath.replace('{entry}', encodeURIComponent(String(requestParameters['entry'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateCollectionEntryRequest'],
        };
    }

    /**
     * Change a stack: its count, condition, finish, signature, price, date or printing  Every field is optional; whatever is left out stays as it is.
     * Change a stack: its count, condition, finish, signature, price, date or printing
     */
    async updateCollectionEntryRaw(requestParameters: UpdateCollectionEntryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CollectionEntryResponse>> {
        const requestOptions = await this.updateCollectionEntryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Change a stack: its count, condition, finish, signature, price, date or printing  Every field is optional; whatever is left out stays as it is.
     * Change a stack: its count, condition, finish, signature, price, date or printing
     */
    async updateCollectionEntry(requestParameters: UpdateCollectionEntryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CollectionEntryResponse> {
        const response = await this.updateCollectionEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateDeck without sending the request
     */
    async updateDeckRequestOpts(requestParameters: UpdateDeckOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling updateDeck().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateDeckRequest'],
        };
    }

    /**
     * Rename a deck, change its description or the format it is built for
     * Rename a deck, change its description or the format it is built for
     */
    async updateDeckRaw(requestParameters: UpdateDeckOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.updateDeckRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Rename a deck, change its description or the format it is built for
     * Rename a deck, change its description or the format it is built for
     */
    async updateDeck(requestParameters: UpdateDeckOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateDeckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateDeckCard without sending the request
     */
    async updateDeckCardRequestOpts(requestParameters: UpdateDeckCardOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling updateDeckCard().'
            );
        }

        if (requestParameters['card'] == null) {
            throw new runtime.RequiredError(
                'card',
                'Required parameter "card" was null or undefined when calling updateDeckCard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/cards/{card}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));
        urlPath = urlPath.replace('{card}', encodeURIComponent(String(requestParameters['card'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateDeckCardRequest'],
        };
    }

    /**
     * Change a Deck entry: its count, its zone or the print it sleeves  An entry made alike to another one merges into it, and a count of zero removes it. A Collaborator\'s change leaves the proxy flag as it is, see [`DeckGrant::proxy`].
     * Change a Deck entry: its count, its zone or the print it sleeves
     */
    async updateDeckCardRaw(requestParameters: UpdateDeckCardOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.updateDeckCardRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Change a Deck entry: its count, its zone or the print it sleeves  An entry made alike to another one merges into it, and a count of zero removes it. A Collaborator\'s change leaves the proxy flag as it is, see [`DeckGrant::proxy`].
     * Change a Deck entry: its count, its zone or the print it sleeves
     */
    async updateDeckCard(requestParameters: UpdateDeckCardOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateDeckCardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateDeckFolder without sending the request
     */
    async updateDeckFolderRequestOpts(requestParameters: UpdateDeckFolderOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['folder'] == null) {
            throw new runtime.RequiredError(
                'folder',
                'Required parameter "folder" was null or undefined when calling updateDeckFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/folders/{folder}`;
        urlPath = urlPath.replace('{folder}', encodeURIComponent(String(requestParameters['folder'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateDeckFolderRequest'],
        };
    }

    /**
     * Rename a folder  The archive is refused: it is called what the app calls it.
     * Rename a folder
     */
    async updateDeckFolderRaw(requestParameters: UpdateDeckFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.updateDeckFolderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Rename a folder  The archive is refused: it is called what the app calls it.
     * Rename a folder
     */
    async updateDeckFolder(requestParameters: UpdateDeckFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateDeckFolderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateDeckTag without sending the request
     */
    async updateDeckTagRequestOpts(requestParameters: UpdateDeckTagOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deck'] == null) {
            throw new runtime.RequiredError(
                'deck',
                'Required parameter "deck" was null or undefined when calling updateDeckTag().'
            );
        }

        if (requestParameters['tag'] == null) {
            throw new runtime.RequiredError(
                'tag',
                'Required parameter "tag" was null or undefined when calling updateDeckTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/decks/{deck}/tags/{tag}`;
        urlPath = urlPath.replace('{deck}', encodeURIComponent(String(requestParameters['deck'])));
        urlPath = urlPath.replace('{tag}', encodeURIComponent(String(requestParameters['tag'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateDeckTagRequest'],
        };
    }

    /**
     * Rename a tag, change its marker or move its scope  An Editor only changes a tag local to this deck and keeps it there.
     * Rename a tag, change its marker or move its scope
     */
    async updateDeckTagRaw(requestParameters: UpdateDeckTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.updateDeckTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Rename a tag, change its marker or move its scope  An Editor only changes a tag local to this deck and keeps it there.
     * Rename a tag, change its marker or move its scope
     */
    async updateDeckTag(requestParameters: UpdateDeckTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateDeckTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateGlobalTag without sending the request
     */
    async updateGlobalTagRequestOpts(requestParameters: UpdateGlobalTagOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tag'] == null) {
            throw new runtime.RequiredError(
                'tag',
                'Required parameter "tag" was null or undefined when calling updateGlobalTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tags/{tag}`;
        urlPath = urlPath.replace('{tag}', encodeURIComponent(String(requestParameters['tag'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateGlobalTagRequest'],
        };
    }

    /**
     * Rename a card-wide tag or change its marker
     * Rename a card-wide tag or change its marker
     */
    async updateGlobalTagRaw(requestParameters: UpdateGlobalTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.updateGlobalTagRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Rename a card-wide tag or change its marker
     * Rename a card-wide tag or change its marker
     */
    async updateGlobalTag(requestParameters: UpdateGlobalTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateGlobalTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateScannerSession without sending the request
     */
    async updateScannerSessionRequestOpts(requestParameters: UpdateScannerSessionOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['session'] == null) {
            throw new runtime.RequiredError(
                'session',
                'Required parameter "session" was null or undefined when calling updateScannerSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/scanner-sessions/{session}`;
        urlPath = urlPath.replace('{session}', encodeURIComponent(String(requestParameters['session'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateScannerSessionRequest'],
        };
    }

    /**
     * Rename a session or change its marker and preferred collection
     * Rename a session or change its marker and preferred collection
     */
    async updateScannerSessionRaw(requestParameters: UpdateScannerSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.updateScannerSessionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Rename a session or change its marker and preferred collection
     * Rename a session or change its marker and preferred collection
     */
    async updateScannerSession(requestParameters: UpdateScannerSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateScannerSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateScannerSessionEntry without sending the request
     */
    async updateScannerSessionEntryRequestOpts(requestParameters: UpdateScannerSessionEntryOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['session'] == null) {
            throw new runtime.RequiredError(
                'session',
                'Required parameter "session" was null or undefined when calling updateScannerSessionEntry().'
            );
        }

        if (requestParameters['entry'] == null) {
            throw new runtime.RequiredError(
                'entry',
                'Required parameter "entry" was null or undefined when calling updateScannerSessionEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/scanner-sessions/{session}/entries/{entry}`;
        urlPath = urlPath.replace('{session}', encodeURIComponent(String(requestParameters['session'])));
        urlPath = urlPath.replace('{entry}', encodeURIComponent(String(requestParameters['entry'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateScannerSessionEntryRequest'],
        };
    }

    /**
     * Adjust count, finish, signed state, paid price or printing
     * Adjust count, finish, signed state, paid price or printing
     */
    async updateScannerSessionEntryRaw(requestParameters: UpdateScannerSessionEntryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScannerSessionEntryResponse>> {
        const requestOptions = await this.updateScannerSessionEntryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Adjust count, finish, signed state, paid price or printing
     * Adjust count, finish, signed state, paid price or printing
     */
    async updateScannerSessionEntry(requestParameters: UpdateScannerSessionEntryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScannerSessionEntryResponse> {
        const response = await this.updateScannerSessionEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateTournament without sending the request
     */
    async updateTournamentRequestOpts(requestParameters: UpdateTournamentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling updateTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/tournaments/{tournament}`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['TournamentSettingsRequest'],
        };
    }

    /**
     * Replace a Tournament\'s settings, as one of its Organizers  Table size, Ruleset and best-of stay as they are once the first Round started, the Top cut and its best-of once the Swiss Rounds are over. Settings that change which Participants are pairable throw a previewed Round away.
     * Replace a Tournament\'s settings, as one of its Organizers
     */
    async updateTournamentRaw(requestParameters: UpdateTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTournament200Response>> {
        const requestOptions = await this.updateTournamentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Replace a Tournament\'s settings, as one of its Organizers  Table size, Ruleset and best-of stay as they are once the first Round started, the Top cut and its best-of once the Swiss Rounds are over. Settings that change which Participants are pairable throw a previewed Round away.
     * Replace a Tournament\'s settings, as one of its Organizers
     */
    async updateTournament(requestParameters: UpdateTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTournament200Response> {
        const response = await this.updateTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateWatchList without sending the request
     */
    async updateWatchListRequestOpts(requestParameters: UpdateWatchListOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['list'] == null) {
            throw new runtime.RequiredError(
                'list',
                'Required parameter "list" was null or undefined when calling updateWatchList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/watch-lists/{list}`;
        urlPath = urlPath.replace('{list}', encodeURIComponent(String(requestParameters['list'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateWatchListRequest'],
        };
    }

    /**
     * Rename a watch list or change its marker
     * Rename a watch list or change its marker
     */
    async updateWatchListRaw(requestParameters: UpdateWatchListOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.updateWatchListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Rename a watch list or change its marker
     * Rename a watch list or change its marker
     */
    async updateWatchList(requestParameters: UpdateWatchListOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateWatchListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateWatchListEntry without sending the request
     */
    async updateWatchListEntryRequestOpts(requestParameters: UpdateWatchListEntryOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['list'] == null) {
            throw new runtime.RequiredError(
                'list',
                'Required parameter "list" was null or undefined when calling updateWatchListEntry().'
            );
        }

        if (requestParameters['entry'] == null) {
            throw new runtime.RequiredError(
                'entry',
                'Required parameter "entry" was null or undefined when calling updateWatchListEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/frontend/v1/watch-lists/{list}/entries/{entry}`;
        urlPath = urlPath.replace('{list}', encodeURIComponent(String(requestParameters['list'])));
        urlPath = urlPath.replace('{entry}', encodeURIComponent(String(requestParameters['entry'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateWatchListEntryRequest'],
        };
    }

    /**
     * Change some of an entry\'s fields, leaving the rest alone
     * Change some of an entry\'s fields, leaving the rest alone
     */
    async updateWatchListEntryRaw(requestParameters: UpdateWatchListEntryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.updateWatchListEntryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Change some of an entry\'s fields, leaving the rest alone
     * Change some of an entry\'s fields, leaving the rest alone
     */
    async updateWatchListEntry(requestParameters: UpdateWatchListEntryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.updateWatchListEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for withdrawTournamentHandover without sending the request
     */
    async withdrawTournamentHandoverRequestOpts(requestParameters: WithdrawTournamentHandoverRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling withdrawTournamentHandover().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/handover`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Withdraw the pending offer of a Tournament, as its Owner
     * Withdraw the pending offer of a Tournament, as its Owner
     */
    async withdrawTournamentHandoverRaw(requestParameters: WithdrawTournamentHandoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.withdrawTournamentHandoverRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Withdraw the pending offer of a Tournament, as its Owner
     * Withdraw the pending offer of a Tournament, as its Owner
     */
    async withdrawTournamentHandover(requestParameters: WithdrawTournamentHandoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.withdrawTournamentHandoverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for withdrawTournamentSignUp without sending the request
     */
    async withdrawTournamentSignUpRequestOpts(requestParameters: WithdrawTournamentSignUpRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['tournament'] == null) {
            throw new runtime.RequiredError(
                'tournament',
                'Required parameter "tournament" was null or undefined when calling withdrawTournamentSignUp().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/frontend/v1/tournaments/{tournament}/sign-up`;
        urlPath = urlPath.replace('{tournament}', encodeURIComponent(String(requestParameters['tournament'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Withdraw the logged-in Account\'s own sign-up  Only before the first Round starts; afterwards a Participant leaves by a Drop.
     * Withdraw the logged-in Account\'s own sign-up
     */
    async withdrawTournamentSignUpRaw(requestParameters: WithdrawTournamentSignUpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.withdrawTournamentSignUpRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Withdraw the logged-in Account\'s own sign-up  Only before the first Round starts; afterwards a Participant leaves by a Drop.
     * Withdraw the logged-in Account\'s own sign-up
     */
    async withdrawTournamentSignUp(requestParameters: WithdrawTournamentSignUpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.withdrawTournamentSignUpRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
